import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.48129294297],
    [0.09260408234, 0.89106421507, 74.7815985673],
    [0.01504247898, 3.6271926092, 1.4844727083],
    [0.00365981674, 1.89962179044, 73.297125859],
    [0.00272328168, 3.35823706307, 149.5631971346],
    [0.00070328461, 5.39254450063, 63.7358983034],
    [0.00068892678, 6.09292483287, 76.2660712756],
    [0.00061998615, 2.26952066061, 2.9689454166],
    [0.00061950719, 2.85098872691, 11.0457002639],
    [0.0002646877, 3.14152083966, 71.8126531507],
    [0.00025710476, 6.11379840493, 454.9093665273],
    [0.0002107885, 4.36059339067, 148.0787244263],
    [0.00017818647, 1.74436930289, 36.6485629295],
    [0.00014613507, 4.73732166022, 3.9321532631],
    [0.00011162509, 5.8268179635, 224.3447957019],
    [0.0001099791, 0.48865004018, 138.5174968707],
    [0.00009527478, 2.95516862826, 35.1640902212],
    [0.00007545601, 5.236265824, 109.9456887885],
    [0.00004220241, 3.23328220918, 70.8494453042],
    [0.000040519, 2.277550173, 151.0476698429],
    [0.00003354596, 1.0654900738, 4.4534181249],
    [0.00002926718, 4.62903718891, 9.5612275556],
    [0.0000349034, 5.48306144511, 146.594251718],
    [0.00003144069, 4.75199570434, 77.7505439839],
    [0.00002922333, 5.35235361027, 85.8272988312],
    [0.00002272788, 4.36600400036, 70.3281804424],
    [0.00002051219, 1.51773566586, 0.1118745846],
    [0.00002148602, 0.60745949945, 38.1330356378],
    [0.00001991643, 4.92437588682, 277.0349937414],
    [0.00001376226, 2.04283539351, 65.2203710117],
    [0.00001666902, 3.62744066769, 380.12776796],
    [0.00001284107, 3.11347961505, 202.2533951741],
    [0.00001150429, 0.93343589092, 3.1813937377],
    [0.00001533221, 2.58594681212, 52.6901980395],
    [0.00001281604, 0.54271272721, 222.8603229936],
    [0.00001372139, 4.19641530878, 111.4301614968],
    [0.00001221029, 0.1990065003, 108.4612160802],
    [0.00000946181, 1.19253165736, 127.4717966068],
    [0.00001150989, 4.17898916639, 33.6796175129],
    [0.00001244347, 0.91614441731, 2.4476805548],
    [0.00001072013, 0.23566016888, 62.2514255951],
    [0.00001090463, 1.77501500531, 12.5301729722],
    [0.00000707935, 5.18291670033, 213.299095438],
    [0.00000653376, 0.96587864431, 78.7137518304],
    [0.0000062757, 0.18209040157, 984.6003316219],
    [0.00000524485, 2.01275350435, 299.1263942692],
    [0.00000559396, 3.35768635981, 0.5212648618],
    [0.00000606847, 5.4320988925, 529.6909650946],
    [0.00000404897, 5.98690517582, 8.0767548473],
    [0.00000467183, 0.41482520325, 145.1097790097],
    [0.00000471311, 1.40661608158, 184.7272873558],
    [0.00000483226, 2.10553218341, 0.9632078465],
    [0.00000395569, 5.87037914022, 351.8165923087],
    [0.00000433527, 5.52141037763, 183.2428146475],
    [0.00000309843, 5.83301863492, 145.6310438715],
    [0.00000378642, 2.34989391811, 56.6223513026],
    [0.00000399033, 0.33796522578, 415.5524906121],
    [0.00000300392, 5.64355207373, 22.0914005278],
    [0.0000024923, 4.74621772167, 225.8292684102],
    [0.00000239311, 2.35072447972, 137.0330241624],
    [0.00000294103, 5.83919833199, 39.6175083461],
    [0.0000021645, 4.77807782477, 340.7708920448],
    [0.00000251784, 1.63692846797, 221.3758502853],
    [0.00000219624, 1.92233630317, 67.6680515665],
    [0.00000202019, 1.29693040688, 0.0481841098],
    [0.00000224105, 0.51589500446, 84.3428261229],
    [0.00000216563, 6.14217553245, 5.9378908332],
    [0.00000222605, 2.84314245655, 0.2606324309],
    [0.00000207907, 5.5801263788, 68.8437077341],
    [0.0000018752, 1.3192760652, 0.1600586944],
    [0.00000199306, 0.95648612651, 152.5321425512],
    [0.00000158075, 0.73795262538, 54.1746707478],
    [0.00000168606, 5.87865394974, 18.1592472647],
    [0.00000170326, 3.67712574811, 5.4166259714],
    [0.00000193647, 1.88800957346, 456.3938392356],
    [0.00000193051, 0.91616617785, 453.424893819],
    [0.00000181991, 3.53625031273, 79.2350166922],
    [0.00000173102, 1.53869634445, 160.6088973985],
    [0.00000164483, 1.42390725018, 106.9767433719],
    [0.0000017194, 5.67948631369, 219.891377577],
    [0.00000162805, 3.05027759814, 112.9146342051],
    [0.00000146659, 1.26296726443, 59.8037450403],
    [0.00000139276, 5.38697273752, 32.1951448046],
    [0.00000138636, 4.25998533357, 909.8187330546],
    [0.00000143058, 1.2998045387, 35.4247226521],
    [0.00000123986, 1.37489956563, 7.1135470008],
    [0.00000104582, 5.02793726187, 0.7507595254],
    [0.00000103295, 0.68145096277, 14.977853527],
    [0.00000094957, 0.90678215577, 74.6697239827],
    [0.00000082948, 2.92800368384, 265.9892934775],
    [0.00000110403, 2.02666475709, 554.0699874828],
    [0.00000094433, 3.94271122207, 74.8934731519],
    [0.00000080072, 1.01583506701, 6.592282139],
    [0.00000109576, 5.70572405893, 77.962992305],
    [0.00000085946, 1.70581556772, 82.8583534146],
    [0.00000103799, 1.45794315266, 24.3790223882],
    [0.00000074661, 4.63178804642, 69.3649725959],
    [0.00000079813, 3.00965058125, 297.6419215609],
    [0.0000008449, 0.36886722094, 186.2117600641],
    [0.00000088657, 0.52498114072, 181.7583419392],
    [0.00000070368, 1.18984702891, 66.70484372],
    [0.00000069971, 0.87463619381, 305.3461693927],
    [0.00000070082, 3.75845990682, 131.4039498699],
    [0.0000008435, 5.88592009032, 256.5399405065],
    [0.00000074493, 6.2423868428, 447.7958195265],
    [0.00000062454, 0.16868402018, 479.2883889155],
    [0.00000072904, 2.84891153624, 462.0229135281],
    [0.00000069205, 4.43939850837, 39.3568759152],
    [0.00000076729, 4.58716659215, 6.2197751235],
    [0.00000073423, 4.27591432865, 87.3117715395],
    [0.00000055577, 1.49804110443, 71.6002048296],
    [0.00000057315, 1.63007488533, 143.6253063014],
    [0.00000061674, 3.18616775231, 77.2292791221],
    [0.00000057668, 3.67128264895, 51.2057253312],
    [0.00000050352, 1.12355398826, 20.6069278195],
    [0.0000005372, 5.51853172042, 128.9562693151],
    [0.00000057895, 2.6686921691, 381.6122406683],
    [0.00000058089, 1.5863521331, 60.7669528868],
    [0.0000004539, 0.48027056949, 14.0146456805],
    [0.00000037513, 6.06768205316, 211.8146227297],
    [0.00000038565, 3.43547372715, 153.4953503977],
    [0.00000046085, 4.36220351003, 75.7448064138],
    [0.0000004022, 4.57551863155, 46.2097904851],
    [0.00000034314, 2.9385893887, 140.001969579],
    [0.00000038754, 5.59046474201, 99.1606209555],
    [0.00000034864, 1.0287768134, 203.7378678824],
    [0.00000040016, 0.69893479575, 218.4069048687],
    [0.00000032562, 4.21895389367, 200.7689224658],
    [0.00000031889, 5.50965372046, 72.3339180125],
    [0.00000041668, 3.82449219367, 81.0013736908],
    [0.00000034668, 0.39221757952, 1.3725981237],
    [0.00000039741, 6.05490168728, 293.188503436],
    [0.00000027545, 2.18754130148, 125.9873238985],
    [0.00000036328, 1.66621808766, 258.0244132148],
    [0.00000035508, 1.96672429313, 835.0371344873],
    [0.00000035373, 3.72274050162, 692.5874843535],
    [0.00000027364, 2.10315692995, 209.3669421749],
    [0.00000026442, 4.48298644364, 373.9079928365],
    [0.00000034517, 1.08687838842, 191.2076949102],
    [0.00000026317, 3.6335778804, 490.3340891794],
    [0.00000029888, 3.87365011384, 259.5088859231],
    [0.00000025926, 0.54378574725, 41.6444977756],
    [0.0000002711, 0.00478270361, 28.5718080822],
    [0.00000026313, 5.81236674192, 75.3028634291],
    [0.00000034277, 6.05545630018, 275.5505210331],
    [0.00000024315, 3.18651202042, 81.3738807063],
    [0.00000029936, 1.8878903041, 269.9214467406],
    [0.00000026242, 6.20368166778, 134.5853436076],
    [0.00000022842, 0.92857008471, 288.0806940053],
    [0.00000025216, 5.43032747843, 116.4260963429],
    [0.00000027063, 4.75299776159, 41.1019810544],
    [0.00000022706, 0.5305745312, 1514.2912967165],
    [0.0000002648, 4.77161377188, 284.1485407422],
    [0.0000002195, 4.59091247537, 404.5067903482],
    [0.00000022022, 1.84418065243, 617.8058857862],
    [0.00000024811, 4.70901440561, 378.6432952517],
    [0.0000002904, 0.17160028536, 528.2064923863],
    [0.00000020487, 0.10247779138, 195.1398481733],
    [0.00000020726, 5.62240737217, 55.6591434561],
    [0.00000025919, 0.74700144605, 278.5194664497],
    [0.00000022824, 3.58334799786, 1.5963472929],
    [0.00000021855, 0.05691568897, 173.9422195228],
    [0.00000019045, 2.30354999303, 5.1078094307],
    [0.00000020831, 2.64115582292, 105.4922706636],
    [0.00000021849, 5.87274563981, 45.5766510387],
    [0.00000021075, 1.98176191313, 114.3991069134],
    [0.00000019306, 2.84240229356, 159.1244246902],
    [0.00000019062, 0.50604571692, 67.3592350258],
    [0.00000020431, 3.77538635518, 135.5485514541],
    [0.00000017322, 4.47827838578, 120.358249606],
    [0.00000020581, 0.88703968592, 255.0554677982],
    [0.00000019339, 1.4856940316, 0.8937718773],
    [0.00000021333, 2.7445877721, 28.3111756513],
    [0.00000017629, 4.09292272552, 296.1574488526],
    [0.00000015918, 3.94524461273, 17.5261078183],
    [0.00000015556, 0.92841352827, 300.6108669775],
    [0.00000016443, 0.30879187235, 30.7106720963],
    [0.00000015248, 4.93045860155, 7.4223635415],
    [0.000000193, 6.21959323869, 329.8370663655],
    [0.00000013876, 0.56084534056, 144.1465711632],
    [0.00000016198, 2.30318612128, 344.7030453079],
    [0.00000016033, 0.19604773155, 103.0927742186],
    [0.00000014368, 2.57751058848, 230.5645708254],
    [0.00000016807, 4.9362064894, 565.1156877467],
    [0.00000017121, 1.82016259921, 294.6729761443],
    [0.00000016827, 0.27566510604, 73.8183907208],
    [0.00000015455, 1.91556741732, 96.8729990951],
    [0.00000015814, 3.86318315976, 98.8999885246],
    [0.00000011923, 6.17587234615, 44.7253177768],
    [0.00000012446, 6.2246634541, 80.1982245387],
    [0.00000013001, 1.9948387226, 27.0873353739],
    [0.0000001318, 3.43753711704, 227.3137411185],
    [0.00000011678, 4.31505860166, 426.598190876],
    [0.00000014374, 5.78359439943, 1059.3819301892],
    [0.00000015879, 0.98454960135, 6208.2942514241],
    [0.00000011511, 2.55846980442, 19.1224551112],
    [0.00000011193, 1.74548073119, 220.4126424388],
    [0.00000011981, 5.8435546521, 13.3333221243],
    [0.00000013333, 5.39450805857, 391.1734682239],
    [0.00000012322, 4.57477369077, 23.5758732361],
    [0.00000012847, 1.77354298387, 180.2738692309],
    [0.00000011629, 4.29071404978, 142.4496501338],
    [0.00000012214, 2.44698830848, 100.3844612329],
    [0.00000012439, 2.3266100767, 80.7194894005],
    [0.0000000977, 0.39792836846, 7.8643065262],
    [0.00000013165, 2.74113201454, 177.8743727859],
    [0.00000012265, 5.428160452, 831.1049812242],
    [0.00000010264, 5.90199222998, 74.5209661364],
    [0.00000009317, 3.75869700707, 74.8297826771],
    [0.00000012284, 5.52145313445, 74.2603337055],
    [0.00000010682, 4.00694729802, 235.3904959658],
    [0.00000009243, 5.38488037675, 20.4468691251],
    [0.00000009458, 2.60118467048, 92.3077063856],
    [0.00000009317, 1.16483658243, 74.7334144575],
    [0.00000010786, 1.88993609169, 241.6102710893],
    [0.00000010597, 5.50467173303, 187.6962327724],
    [0.00000012035, 6.02036249862, 154.0166152595],
    [0.00000009129, 1.15458738606, 0.6331394464],
    [0.00000011708, 6.25765865911, 155.7829722581],
    [0.00000012186, 5.79479693025, 1364.7280995819],
    [0.00000010992, 5.7667459645, 628.8515860501],
    [0.00000008531, 5.1791803753, 1.6445314027],
    [0.00000008662, 3.78046237096, 74.9416572617],
    [0.00000011225, 1.30868548209, 604.4725636619],
    [0.0000001054, 1.05897224519, 291.7040307277],
    [0.00000008443, 3.52060391248, 756.3233826569],
    [0.0000001029, 5.3049938479, 75.0422309982],
    [0.00000009591, 1.64200163871, 24.1183899573],
    [0.0000000802, 6.24545313293, 543.0242872189],
    [0.00000007796, 5.23505740309, 58.1068240109],
    [0.00000008649, 1.14271989382, 74.6215398729],
    [0.00000007793, 4.00212500951, 31.492569389],
    [0.00000008915, 3.63129999542, 408.4389436113],
    [0.00000007195, 4.24369275612, 110.2063212194],
    [0.00000009545, 2.00926809412, 331.3215390738],
    [0.00000008786, 2.25836637388, 451.9404211107],
    [0.00000009768, 0.10232823685, 366.485629295],
    [0.00000009075, 1.63090160034, 443.8636662634],
    [0.00000007255, 4.35305855248, 88.1149206916],
    [0.00000009482, 1.43114303369, 414.0680179038],
    [0.00000007645, 0.62076955028, 50.4025761791],
    [0.00000006836, 5.12192858785, 0.8031491521],
    [0.00000006899, 5.86240754958, 339.2864193365],
    [0.00000008125, 0.45159535895, 25.6028626656],
    [0.00000006488, 6.03171366016, 1.2238402774],
    [0.00000009108, 2.41055572869, 10138.5039476437],
    [0.00000008139, 0.21930359866, 422.6660376129],
    [0.00000007164, 4.00283046264, 157.6399519819],
    [0.00000006393, 4.47880072523, 79.889407998],
    [0.00000008039, 2.1016108553, 92.940845832],
    [0.00000006773, 1.38798529262, 16.6747745564],
    [0.00000006816, 2.84724339946, 142.1408335931],
    [0.00000007788, 5.86998158412, 760.25553592],
    [0.0000000838, 2.33770107198, 417.0369633204],
    [0.00000007928, 3.41948324447, 7.7042478318],
    [0.00000007235, 0.50521045386, 457.8783119439],
    [0.00000007143, 5.57879993926, 4.7353024152],
    [0.00000007379, 0.47767694338, 68.1893164283],
    [0.00000006403, 3.88657131997, 74.0308390419],
    [0.00000006101, 1.65240727244, 350.3321196004],
    [0.0000000682, 6.15375544111, 67.8804998876],
    [0.00000005994, 2.3608765312, 2.0057375701],
    [0.00000006008, 5.46469064027, 48.7580447764],
    [0.0000000702, 0.13804863634, 306.830642101],
    [0.0000000572, 1.49555002206, 206.1855484372],
    [0.00000006862, 1.08055101709, 465.9550667912],
    [0.00000006413, 5.07420793721, 4.665866446],
    [0.00000007804, 3.98873608283, 3.6233367224],
    [0.0000000553, 5.57878118094, 2.9207613068],
    [0.00000005519, 3.38213279322, 149.45132255],
    [0.00000006111, 1.95407755561, 216.9224321604],
    [0.0000000658, 2.7099382691, 329.7251917809],
    [0.00000005835, 3.99897551776, 347.8844390456],
    [0.00000005112, 2.42454049536, 342.2553647531],
    [0.00000005533, 2.83342316665, 260.9933586314],
    [0.00000005727, 0.49154098031, 0.3725070155],
    [0.00000005395, 2.78483514026, 13.4933808187],
    [0.00000006024, 4.78785737004, 558.0021407459],
    [0.00000004903, 1.76924594442, 333.657345044],
    [0.00000005381, 5.71120333625, 1.6969210294],
    [0.00000005389, 2.940752762, 9.4011688612],
    [0.00000005042, 5.47678294897, 372.4235201282],
    [0.00000005093, 3.43101132912, 518.6452648307],
    [0.00000004766, 5.34829276989, 61.2882177486],
    [0.00000005655, 3.30309284254, 0.6543913058],
    [0.00000005566, 0.44947190504, 162.0933701068],
    [0.00000005834, 3.46697149482, 55.1378785943],
    [0.00000005656, 1.23594821626, 328.3525936572],
    [0.00000005071, 5.42033083225, 977.4867846211],
    [0.00000005719, 0.66730329426, 92.0470739547],
    [0.00000005283, 2.4227215143, 58.319272332],
    [0.00000005613, 2.36101054919, 6.9010986797],
    [0.00000004853, 1.2709395912, 983.1158589136],
    [0.00000005512, 0.13294006611, 149.6750717192],
    [0.00000004693, 1.85511154338, 119.5069163441],
    [0.00000004307, 4.18173079985, 90.8232336773],
    [0.00000005957, 1.73124132593, 152.7445908723],
    [0.00000005675, 5.53546214308, 1087.6931058405],
    [0.00000004562, 3.26460078185, 89.7594520943],
    [0.00000005594, 5.75194360195, 358.9301393095],
    [0.00000004689, 5.01733767973, 43.1289704839],
    [0.00000004424, 0.97724627015, 4.192785694],
    [0.00000004012, 1.08246444514, 75.5323580927],
    [0.00000005623, 1.1038737829, 66.9172920411],
    [0.00000004048, 1.94074496693, 17.2654753874],
    [0.00000004768, 2.24189462905, 986.0848043302],
    [0.00000005213, 1.36495122038, 767.3690829208],
    [0.00000004922, 0.1374247914, 0.8513332619],
    [0.00000004342, 5.33545538316, 152.0108776894],
    [0.00000003918, 3.85162186106, 2.2876218604],
    [0.00000003931, 1.7019168766, 5.6290742925],
    [0.00000004658, 0.93863607366, 267.4737661858],
    [0.00000003895, 5.87672991487, 16.4623262353],
    [0.00000005176, 3.40869435646, 1289.9465010146],
    [0.00000004628, 5.42648205428, 16.04163511],
    [0.00000005039, 2.16699952281, 367.9701020033],
    [0.00000003775, 0.59927848906, 210.3301500214],
    [0.00000005015, 0.26807931893, 403.1341922245],
    [0.00000004535, 2.90035619661, 59.2824801785],
    [0.00000004571, 0.85791209853, 969.6224780949],
    [0.00000004201, 5.12033927784, 19.0105805266],
    [0.000000047, 4.17550908523, 130.4407420234],
    [0.00000003694, 0.75965712567, 114.1384744825],
    [0.00000003794, 4.59731406975, 25.8634950965],
    [0.00000004019, 4.98465691172, 30.0562807905],
    [0.00000004735, 3.76713441227, 373.0142209592],
    [0.00000003635, 3.20392753847, 991.7138786227],
    [0.00000004021, 0.47038124299, 387.2413149608],
    [0.00000003443, 5.20975249527, 894.8408795276],
    [0.00000003304, 2.01134489744, 286.596221297],
    [0.00000003315, 3.98568908785, 264.5048207692],
    [0.0000000328, 5.46909245799, 192.6921676185],
    [0.00000004481, 6.1551081404, 173.6815870919],
    [0.00000003302, 1.63115447974, 681.5417840896],
    [0.00000003193, 3.9651467602, 146.3818033969],
    [0.00000004, 1.40741532794, 383.0967133766],
    [0.00000003523, 5.19259518595, 97.4155158163],
    [0.00000003844, 3.60271287642, 0.590700831],
    [0.00000003183, 4.15987875012, 76.4785195967],
    [0.00000003122, 4.5019516359, 1439.5096981492],
    [0.00000003238, 1.64548946107, 214.7835681463],
    [0.00000003543, 4.15778489389, 68.5618234438],
    [0.0000000295, 2.95792688293, 120.9913890524],
    [0.00000002904, 3.69931078718, 874.3940104025],
    [0.00000003292, 2.14601654518, 253.5709950899],
    [0.00000003225, 2.56298661136, 60.5545045657],
    [0.00000003071, 3.57595003388, 117.9105690512],
    [0.00000003237, 4.80214981899, 19.643719973],
    [0.0000000278, 0.65215559196, 42.5382696529],
    [0.0000000324, 5.31726675118, 546.956440482],
    [0.00000003657, 5.89905956226, 16.1535096946],
    [0.00000003547, 2.76324444984, 82.4858463991],
    [0.00000003556, 4.68368769233, 593.426863398],
    [0.00000003342, 1.56467995408, 312.4597163935],
    [0.00000003437, 4.95814102027, 49.7212526229],
    [0.00000003593, 2.52079368833, 22.8945496799],
    [0.00000002672, 2.41694469728, 29.2049475286],
    [0.00000002899, 3.48228574147, 95.3885263868],
    [0.00000003102, 1.42591645035, 17.6379824029],
    [0.00000003341, 2.64162643824, 771.3012361839],
    [0.00000002547, 6.10642153796, 455.8725743738],
    [0.0000000268, 1.16873928613, 477.8039162072],
    [0.00000003335, 3.01819753318, 88.7962442478],
    [0.00000003356, 3.09879595032, 552.5855147745],
    [0.00000002947, 0.32015414114, 150.5264049811],
    [0.00000002678, 1.42841144096, 1.1119656928],
    [0.0000000254, 1.94053883528, 6.4804075544],
    [0.00000002953, 4.59498573141, 167.0893049529],
    [0.00000002746, 1.93558791594, 73.1852512744],
    [0.00000002491, 2.97226347553, 453.9461586808],
    [0.00000003051, 1.91972740209, 561.1835344836],
    [0.00000002999, 1.37948475539, 365.0011565867],
    [0.00000002491, 5.45961727666, 66.1835788582],
    [0.00000002845, 1.23683883276, 32.2433289144],
    [0.00000002318, 1.14709996164, 43.2408450685],
    [0.00000002591, 1.46851525197, 33.1371007917],
    [0.00000003188, 4.01290993082, 555.5544601911],
    [0.00000002341, 5.87022529526, 228.276948965],
    [0.00000002507, 3.85921708605, 104.0077979553],
    [0.00000002825, 1.55599717119, 353.301065017],
    [0.00000002823, 3.60128149001, 42.5864537627],
    [0.00000002911, 5.22123493517, 73.4090004436],
    [0.00000002269, 3.31411348054, 4.1446015842],
    [0.00000002243, 2.66541975581, 70.1157321213],
    [0.00000002253, 4.08061547423, 123.5396433437],
    [0.00000002576, 2.38332773848, 100.6450936638],
    [0.00000002868, 6.16611201949, 101.8689339412],
    [0.0000000276, 5.71757499554, 43.2890291783],
    [0.00000002847, 0.54976679257, 20.4950532349],
    [0.00000002944, 2.79704642392, 418.2608035978],
    [0.00000002155, 4.04509548705, 47.061123747],
    [0.00000002825, 1.90768435934, 273.1028404783],
    [0.00000002529, 4.12564642359, 332.8060117821],
    [0.00000002797, 2.32758928903, 404.6186649328],
    [0.0000000204, 2.01870191041, 316.3918696566],
    [0.00000002525, 3.11718333411, 905.8865797915],
    [0.00000002021, 5.48821446741, 47.6942631934],
    [0.0000000217, 4.4619656005, 2.7083129857],
    [0.00000002399, 3.7884951828, 75.5847477194],
    [0.00000002746, 4.82558024832, 6.8529145699],
    [0.00000002471, 3.46241291144, 8.5980197091],
    [0.0000000198, 3.45572736554, 472.1748419147],
    [0.00000001968, 5.79683846128, 11.1575748485],
    [0.00000001976, 5.43505814122, 199.2844497575],
    [0.00000002285, 2.79572464474, 22.633917249],
    [0.00000001913, 0.27742491783, 69.1525242748],
    [0.00000002663, 5.43112910549, 3265.8308281325],
    [0.00000002604, 0.4366204973, 439.782755154],
    [0.00000002058, 1.69376068077, 65.8747623175],
    [0.00000002121, 2.00288263601, 106.0135355254],
    [0.00000002217, 0.97212356159, 39.0962434843],
    [0.00000002003, 1.49825259375, 29.226199388],
    [0.00000002225, 4.36334040085, 468.2426886516],
    [0.00000002057, 0.06201487399, 205.2223405907],
    [0.00000002086, 0.44287700052, 10.2949407385],
    [0.00000001924, 0.83899941456, 254.9435932136],
    [0.0000000177, 4.3204880583, 0.457574387],
    [0.00000001973, 6.05836685033, 78.4049352897],
    [0.00000001852, 6.19975101768, 258.8757464767],
    [0.00000002095, 5.80179588658, 486.4019359163],
    [0.00000002207, 5.18886333203, 134.0640787458],
    [0.00000002085, 5.35829244404, 908.3342603463],
    [0.00000001887, 6.20764466965, 198.321241911],
    [0.00000002147, 1.40526642648, 526.722019678],
    [0.00000002085, 2.55047290838, 49.5088043018],
    [0.00000001634, 3.36868035546, 118.0224436358],
    [0.00000001729, 1.99202140996, 77.0692204277],
    [0.00000001772, 0.04590477856, 334.2904844904],
    [0.00000001844, 2.97451465787, 178.7893965226],
    [0.0000000173, 2.01735784062, 142.6620984549],
    [0.00000001597, 1.60733571281, 40.1600250673],
    [0.00000001602, 5.65898626013, 175.1660598002],
    [0.00000001668, 1.53361997245, 0.8300814025],
    [0.00000001768, 4.72713891115, 32.7164096664],
    [0.00000001731, 5.53331362694, 15.4991183888],
    [0.00000001756, 5.57550298818, 522.5774180938],
    [0.00000001762, 2.61456701609, 166.828672522],
    [0.00000001558, 3.43776574559, 124.5028511902],
    [0.00000001785, 2.31713014156, 290.2195580194],
    [0.00000001878, 1.08799780926, 274.0660483248],
    [0.0000000153, 3.28602877385, 820.0592809603],
    [0.0000000154, 6.11183693327, 165.6048322446],
    [0.00000001503, 1.88793984015, 303.8616966844],
    [0.00000001637, 0.10818716175, 72.7758609972],
    [0.00000001497, 2.01776960009, 150.0844619964],
    [0.00000001575, 5.25534001318, 233.9060232575],
    [0.00000001469, 0.61918308468, 1033.3583763983],
    [0.00000001904, 6.25182084377, 162.8965192589],
    [0.00000001398, 3.41567259878, 4.9959348461],
    [0.00000001696, 2.11496406243, 189.7232222019],
    [0.00000001641, 0.88245154254, 115.8835796217],
    [0.00000001924, 0.91450801831, 1819.6374661092],
    [0.00000001707, 2.55772668001, 1108.1399749656],
    [0.00000001338, 3.17269412566, 362.8622925726],
    [0.0000000143, 3.7335297053, 8.9068362498],
    [0.00000001342, 2.84242222704, 55.7710180407],
    [0.00000001366, 4.0010335875, 103.3534066495],
    [0.00000001606, 6.02754119794, 31.2319369581],
    [0.00000001693, 1.52609075769, 401.6497195162],
    [0.00000001451, 5.63277890051, 129.9194771616],
    [0.0000000139, 0.22627586528, 370.9390474199],
    [0.000000013, 0.19222551672, 81.8951455681],
    [0.0000000128, 0.62174224381, 448.6895914038],
    [0.0000000129, 2.77107833656, 63.6240237188],
    [0.00000001712, 2.16788442139, 536.8045120954],
    [0.00000001694, 2.49962791661, 441.2672278623],
    [0.00000001644, 2.41311982961, 10.0824924174],
    [0.00000001668, 5.00711095329, 79.5169009825],
    [0.00000001629, 5.55917656506, 344.9636777388],
    [0.00000001345, 4.42619970902, 189.1807054807],
    [0.00000001252, 5.9230078039, 57.1436161644],
    [0.00000001176, 1.63172838154, 84.1827674285],
    [0.00000001322, 0.24854997323, 114.9416236346],
    [0.00000001647, 0.00195946885, 491.5579294568],
    [0.00000001383, 5.72955320309, 89.338760969],
    [0.00000001421, 4.2603541051, 369.4545747116],
    [0.00000001287, 0.99537181009, 14.6690369863],
    [0.00000001412, 5.18998440411, 113.8778420516],
    [0.00000001113, 5.5414551977, 403.0223176399],
    [0.00000001484, 1.03508883775, 1215.1649024473],
    [0.00000001391, 1.49396068486, 14.2270940016],
    [0.00000001202, 3.60264192173, 480.7728616238],
    [0.00000001113, 4.80418427391, 9.449352971],
    [0.00000001428, 1.57155860246, 419.7452763061],
    [0.00000001311, 2.99755331991, 458.8415197904],
    [0.00000001438, 6.10376597618, 64.6991061499],
    [0.00000001074, 3.16426816293, 54.3347294422],
    [0.00000001387, 2.78485990518, 26.0235537909],
    [0.00000001203, 0.20627563214, 0.5694489716],
    [0.00000001347, 5.57876007696, 95.2284676924],
    [0.00000001388, 1.66409814967, 240.3864308119],
    [0.00000001269, 2.37681963075, 37.8724032069],
    [0.00000001011, 2.76310774823, 80.4106728598],
    [0.00000001003, 2.79269932952, 218.9281697305],
    [0.00000001004, 1.15611283525, 384.0599212231],
    [0.00000001009, 2.43209796832, 154.979823106],
    [0.00000001326, 0.99157908827, 483.2205421786],
    [0.00000001339, 0.58791307654, 476.4313180835],
    [0.00000000989, 3.31666847329, 18.9100067901],
    [0.0000000107, 2.82291623041, 616.3214130779],
    [0.00000001257, 1.51721661185, 280.9671470045],
    [0.00000001219, 3.62982970433, 106.2741679563],
    [0.00000001276, 4.73464701935, 691.1030116452],
    [0.00000001146, 4.85249483698, 1044.4040766622],
    [0.00000001124, 2.46295455688, 326.8681209489],
    [0.0000000098, 6.04026702553, 5.4690155981],
    [0.0000000123, 0.61713965835, 237.6781178262],
    [0.00000000922, 0.36432013348, 10.9338256793],
    [0.00000001227, 5.83120102521, 63.847772888],
    [0.00000000918, 3.41111361461, 375.3924655448],
    [0.00000001262, 5.69321383311, 694.0719570618],
    [0.00000001037, 5.92126063748, 4.8259251404],
    [0.00000001148, 5.35062584493, 369.0820676961],
    [0.0000000102, 2.45414816467, 147.1155165798],
    [0.00000001217, 3.63858890321, 699.7010313543],
    [0.0000000096, 4.7838347384, 93.9040536785],
    [0.00000000993, 3.39918521663, 10.785067833],
    [0.00000000879, 3.42965236315, 3.0808200012],
    [0.00000001109, 4.80576232812, 6133.5126528568],
    [0.00000001004, 3.13174510948, 215.4379594521],
    [0.00000000868, 2.87444546307, 15.1903018481],
    [0.00000001167, 6.01716139063, 377.1588225434],
    [0.00000000967, 2.51117953936, 121.8427223143],
    [0.00000000857, 5.69539341636, 141.6988906084],
    [0.0000000118, 2.37522177893, 33.9402499438],
    [0.00000000961, 0.22181374419, 0.9150237367],
    [0.00000000901, 4.21763792004, 488.8496164711],
    [0.00000000999, 2.76968761861, 148.5999892881],
    [0.00000001007, 3.44301576832, 36.9091953604],
    [0.00000000838, 1.63355479706, 2.3358059702],
    [0.00000001055, 5.32670142035, 308.3151148093],
    [0.00000001043, 1.72678741786, 438.2982824457],
    [0.00000000809, 0.7748882728, 2043.9822618111],
    [0.00000000966, 5.97805325335, 606.7601855223],
    [0.00000000826, 2.97722608735, 62.7726904569],
    [0.00000000989, 4.44879184782, 406.1031376411],
    [0.00000000842, 4.09747897628, 140.6563608848],
    [0.0000000102, 5.1325075604, 157.2674449664],
    [0.00000000797, 3.10995123049, 93.7921790939],
    [0.00000001075, 2.4825931792, 405.9912630565],
    [0.00000000944, 1.16305712399, 82.2039621088],
    [0.00000000917, 4.89097024007, 12.0089081104],
    [0.00000000883, 2.3622438514, 3.7720945687],
    [0.0000000102, 3.90895442648, 194.2885149114],
    [0.00000000772, 3.14155617772, 248.4631856592],
    [0.00000001067, 4.11262597752, 141.4864422873],
    [0.00000000982, 1.66627917034, 40.5807161926],
    [0.00000000818, 5.48402326753, 252.6559713532],
    [0.00000000843, 0.97496001006, 73.88782669],
    [0.00000000846, 3.36344025893, 40.8413486235],
    [0.00000001017, 2.6513815772, 477.9157907918],
    [0.00000000727, 2.75669289381, 703.6331846174],
    [0.00000000772, 4.96057719406, 661.0949149645],
    [0.00000001013, 4.06561496066, 76.154196691],
    [0.0000000077, 0.58191520313, 97.6761482472],
    [0.00000000782, 4.43864011717, 295.1942410061],
    [0.00000000933, 1.26735157121, 624.919432787],
    [0.00000000742, 2.20772577601, 1171.875873269],
    [0.00000000785, 0.09340179162, 440.6822725257],
    [0.0000000079, 0.78895659697, 11.848849416],
    [0.00000000801, 5.48034970397, 21.9795259432],
    [0.00000000717, 4.97342005598, 425.1137181677],
    [0.00000000948, 3.14533047586, 833.552661779],
    [0.00000000963, 4.82532331563, 1744.8558675419],
    [0.00000000811, 6.141747735, 184.9879197867],
    [0.00000000683, 3.1999081101, 31.6526280834],
    [0.00000000887, 4.21473602061, 778.4147831847],
    [0.00000000683, 2.71571995972, 685.4739373527],
    [0.00000000878, 4.6954102493, 81.682697247],
    [0.00000000897, 3.94746491465, 75.6753704446],
    [0.00000000744, 4.00270623421, 902.7051860538],
    [0.00000000825, 4.24768237924, 1246.6574718363],
    [0.00000000673, 2.56327330773, 109.3125493421],
    [0.0000000067, 5.39020598872, 610.6923387854],
    [0.00000000835, 3.65058253628, 14.8177948326],
    [0.00000000703, 3.32025655236, 25.0603459444],
    [0.00000000653, 5.83345039162, 86.6304479833],
    [0.00000000657, 1.73039905547, 216.4804891757],
    [0.00000000737, 2.66162027091, 363.5166838784],
    [0.00000000652, 3.21433113908, 207.8824694666],
    [0.00000000632, 5.311631538, 180.1619946463],
    [0.00000000751, 1.05682418871, 916.9322800554],
    [0.00000000858, 0.07715076892, 156.1554792736],
    [0.00000000633, 4.98330418733, 958.576777831],
    [0.00000000651, 6.22872888278, 69.6737891366],
    [0.00000000617, 1.322047737, 193.655375465],
    [0.00000000789, 5.67161089073, 280.003939158],
    [0.00000000815, 3.68454632935, 411.620337349],
    [0.00000000668, 1.92099734116, 37.611770776],
    [0.00000000643, 0.26372916234, 217.2312487011],
    [0.00000000648, 5.91545920656, 302.0953396858],
    [0.00000000786, 1.22164212539, 490.0734567485],
    [0.0000000073, 0.75877218619, 44.0921783304],
    [0.00000000662, 2.70374442339, 469.1364605289],
    [0.00000000616, 5.68826448465, 25.2727942655],
    [0.00000000708, 0.65048856186, 14.5571624017],
    [0.0000000068, 0.50483861507, 1057.8974574809],
    [0.00000000741, 4.39625712898, 184.0941479094],
    [0.00000000616, 4.62035066985, 12.2695405413],
    [0.00000000578, 1.51577770689, 668.2084619653],
    [0.00000000574, 3.07628710998, 285.1117485887],
    [0.00000000658, 3.16493349809, 268.4369740323],
    [0.00000000599, 2.08313007917, 149.3025647037],
    [0.00000000778, 4.44580465697, 171.6545976624],
    [0.00000000702, 2.56984201593, 621.7380390493],
    [0.00000000593, 1.51837555428, 397.3932433474],
    [0.00000000651, 2.27936792883, 49.1787359017],
    [0.00000000558, 0.37741292307, 107.4980082337],
    [0.00000000559, 0.82035344351, 541.5398145106],
    [0.00000000579, 2.6638461857, 823.9914342234],
    [0.00000000738, 3.04661280921, 131.9252147317],
    [0.00000000661, 3.46706982545, 105.380396079],
    [0.0000000055, 3.5604397096, 497.4476361802],
    [0.00000000552, 2.93525507111, 34.2008823747],
    [0.0000000057, 5.61286873129, 118.8737768977],
    [0.00000000611, 3.52382599505, 149.4031384402],
    [0.00000000538, 0.46786259161, 133.1008708993],
    [0.00000000581, 3.06975609659, 137.5542890242],
    [0.00000000699, 2.57905086244, 602.9880909536],
    [0.00000000529, 5.41517154207, 450.9772132642],
    [0.00000000572, 0.49705877254, 331.2096644892],
    [0.00000000567, 4.82584789901, 842.1506814881],
    [0.000000006, 5.83868295988, 181.0557665236],
    [0.00000000545, 2.85574498347, 61.448276443],
    [0.00000000591, 5.51829236048, 140.9651774255],
    [0.00000000624, 0.70843752821, 836.5216071956],
    [0.00000000638, 3.99812366414, 136.0698163159],
    [0.00000000623, 5.8434133579, 52.8020726241],
    [0.00000000576, 0.33426283342, 139.4807047172],
    [0.00000000588, 0.05694902672, 95.931043108],
    [0.00000000516, 2.19916574088, 458.090760265],
    [0.0000000064, 6.23103740957, 10063.7223490764],
    [0.00000000583, 2.01801609392, 449.2802922348],
    [0.00000000541, 3.38817907552, 252.0865223816],
    [0.00000000674, 1.68032765593, 149.0419322728],
    [0.00000000537, 2.96196069752, 73.1370671646],
    [0.00000000508, 2.53212989919, 41.7563723602],
    [0.00000000524, 6.13250235908, 1589.0728952838],
    [0.0000000063, 0.72006810767, 513.079881013],
    [0.00000000536, 5.79291762554, 282.6640680339],
    [0.00000000582, 0.4966183054, 283.6272758804],
    [0.00000000589, 6.240547917, 29.7956483596],
    [0.00000000465, 0.25511403173, 57.255490749],
    [0.00000000581, 4.76285550074, 479.4002635001],
    [0.00000000534, 2.40031010789, 393.4610900843],
    [0.00000000499, 1.70080029975, 262.4778313397],
    [0.00000000574, 2.86244729074, 170.7608257851],
    [0.00000000564, 1.20364214586, 832.5894539325],
    [0.00000000556, 4.40198802843, 196.6243208816],
    [0.00000000566, 0.3431142639, 343.4792050305],
    [0.0000000053, 3.45607265169, 450.4559484024],
    [0.00000000443, 3.98624215251, 135.336103133],
    [0.00000000558, 6.0657095517, 76.3779458602],
    [0.00000000565, 4.90824100099, 463.5073862364],
    [0.00000000519, 3.93421845882, 460.5384408198],
    [0.00000000462, 4.1901057001, 271.4059194489],
    [0.00000000474, 4.61013000511, 291.262087743],
    [0.00000000515, 2.2385727469, 228.7982138268],
    [0.00000000436, 6.22400798387, 149.6113812444],
    [0.00000000499, 3.72703652941, 853.196381752],
    [0.00000000436, 5.07972033661, 79.4474650133],
    [0.00000000426, 2.17011428925, 119.3950417595],
    [0.0000000054, 1.04610917716, 446.3113468182],
    [0.00000000423, 1.23352648155, 357.4456666012],
    [0.00000000484, 2.83311091436, 400.1652468079],
    [0.00000000547, 0.55236729498, 241.8709035202],
    [0.00000000436, 3.63014811867, 149.5150130248],
    [0.00000000435, 1.21235386124, 911.3032057629],
    [0.00000000506, 1.59810782706, 54.2865453324],
    [0.00000000468, 0.00162187872, 232.4215505492],
    [0.0000000045, 6.04091895999, 1894.4190646765],
    [0.00000000426, 4.89607718517, 116.5379709275],
    [0.00000000405, 6.24550564728, 149.723255829],
    [0.00000000552, 0.23040562733, 829.6205085159],
    [0.00000000517, 2.70015186737, 412.5835451955],
    [0.00000000406, 2.04699110555, 232.0490435337],
    [0.00000000409, 4.02096236368, 735.8765135318],
    [0.00000000464, 3.82915340503, 1094.5460204104],
    [0.00000000554, 3.92724998283, 416.7763308895],
    [0.00000000478, 0.23337342897, 1182.9215735329],
    [0.00000000455, 4.41056074117, 754.8389099486],
    [0.00000000425, 0.19362570317, 310.1720945331],
    [0.00000000405, 0.08637530483, 18.9623964168],
    [0.00000000505, 4.18178166641, 449.4927405559],
    [0.00000000391, 0.09596077147, 1097.0942747017],
    [0.00000000486, 4.60822193064, 442.7517005706],
    [0.00000000447, 0.56825354381, 758.7710632117],
    [0.00000000406, 3.80066885794, 34.5309507748],
    [0.00000000543, 2.80897788326, 514.5643537213],
    [0.00000000394, 0.82400691137, 337.8019466282],
    [0.00000000498, 1.11991750513, 154.2984995498],
    [0.00000000526, 5.3572965596, 838.218528225],
    [0.00000000396, 6.00531185948, 246.9787129509],
    [0.00000000436, 3.6189681325, 229.0800981171],
    [0.00000000419, 0.9054672932, 451.7279727896],
    [0.00000000394, 4.86493280924, 1404.0849754971],
    [0.00000000505, 4.80928477681, 155.5010879678],
    [0.00000000437, 1.36909044697, 745.277682393],
    [0.00000000472, 3.61944685312, 679.2541622292],
    [0.00000000465, 5.53770634513, 494.2662424425],
    [0.00000000415, 3.01980670649, 348.8476468921],
    [0.00000000422, 3.51871257208, 706.8145783551],
    [0.00000000354, 4.06294331463, 124.2904028691],
    [0.0000000035, 0.69344344427, 742.9900605326],
    [0.000000004, 0.28819545975, 407.5876103494],
    [0.00000000436, 3.13753022197, 168.5737776612],
    [0.00000000461, 4.10342065247, 27.7204748203],
    [0.00000000353, 2.94674365806, 806.725958836],
    [0.00000000364, 3.0751873248, 442.639825986],
    [0.00000000482, 1.48698198058, 149.8238295655],
    [0.00000000397, 2.65695336615, 464.4705940829],
    [0.00000000348, 5.78081905496, 1265.5674786264],
    [0.00000000422, 1.93225903819, 474.9468453752],
    [0.00000000352, 4.0475161448, 180.7951340927],
    [0.00000000458, 4.95302010209, 619.2903584945],
    [0.00000000358, 0.16212320594, 1190.7858800591],
    [0.00000000356, 3.19289330603, 21.1976286505],
    [0.00000000406, 3.72223708907, 3116.2676309979],
    [0.00000000341, 3.05116722794, 15.7810026791],
    [0.00000000352, 2.38001884804, 511.5954083047],
    [0.00000000376, 3.67717394221, 328.2407190726],
    [0.0000000037, 0.17259001853, 6531.661656265],
    [0.00000000378, 4.72535454314, 30.5987975117],
    [0.00000000456, 0.83406682485, 674.8007441043],
    [0.00000000376, 5.91068811321, 1617.3840709351],
    [0.00000000392, 1.90856045571, 25863.55834587229],
    [0.00000000332, 0.85733579829, 749.2098356561],
    [0.00000000321, 2.59404134515, 1300.9922012785],
    [0.00000000444, 0.92962461992, 98.3574718034],
    [0.00000000338, 4.15717957485, 21.1494445407],
    [0.00000000317, 3.90481203904, 38.6061163898],
    [0.00000000346, 1.30799145303, 321.7603115182],
    [0.00000000387, 3.06870543578, 1012.9115072732],
    [0.00000000324, 6.11165016338, 696.5196376166],
    [0.00000000335, 1.33853903231, 172.4577468145],
    [0.00000000314, 4.56810921721, 1681.1199692385],
    [0.0000000031, 5.02963877803, 1811.773159583],
    [0.00000000382, 5.26829613655, 67.0773507355],
    [0.00000000394, 4.26717713334, 304.2342036999],
    [0.00000000406, 3.58469900333, 26013.1215430069],
    [0.00000000309, 2.68348239684, 248.7238180901],
    [0.00000000372, 1.99921282497, 192.8040422031],
    [0.0000000037, 4.11260458857, 239.1625905345],
    [0.00000000299, 3.9646896095, 20277.0078952874],
    [0.00000000305, 6.24476771738, 501.3797894433],
    [0.00000000298, 2.7391535245, 143.9341228421],
    [0.00000000362, 5.98792551264, 920.8644333185],
    [0.00000000298, 3.52867456736, 21.4582610814],
    [0.00000000375, 5.43269388058, 625.9945152181],
    [0.00000000331, 2.33574542436, 229.4526051326],
    [0.0000000037, 3.51055181581, 91.4563731237],
    [0.00000000308, 5.60489714954, 445.3481389717],
    [0.00000000317, 4.34771147014, 217.4436970222],
    [0.00000000294, 6.15987510624, 19.9737883731],
    [0.00000000414, 4.81163687199, 589.4947101349],
    [0.00000000302, 5.2607933805, 27.5604161259],
    [0.00000000372, 2.20287549079, 44.070926471],
    [0.0000000039, 1.77880995993, 419.4846438752],
    [0.00000000371, 0.30454914535, 6283.0758499914],
    [0.00000000292, 0.17009533973, 455.6601260527],
    [0.0000000037, 2.48289171331, 376.1956146969],
    [0.00000000315, 2.97527331738, 236.8749686741],
    [0.00000000319, 4.13089051068, 81.2620061217],
    [0.0000000029, 2.63347600042, 454.1586070019],
    [0.000000003, 1.28922027378, 799.6124118352],
    [0.0000000035, 4.25460254325, 227.5261894396],
    [0.00000000289, 6.1262719817, 132.8884225782],
    [0.0000000036, 3.48063709609, 44.6134431922],
    [0.00000000393, 5.1250897637, 3192.5337022735],
    [0.00000000365, 0.55471648096, 285.6330134505],
    [0.00000000311, 3.5680168599, 288.7350853111],
    [0.00000000333, 4.95319798125, 881.5075574033],
    [0.00000000385, 4.98242164368, 572.2292347475],
    [0.00000000339, 5.65360136491, 195.7729876197],
    [0.00000000363, 0.98999016221, 839.7030009333],
    [0.00000000386, 3.32408807296, 25939.82441714789],
    [0.00000000289, 3.00353602984, 204.7010757289],
    [0.00000000374, 0.90849814157, 549.7284439425],
    [0.00000000321, 1.6541217086, 90.2807169561],
    [0.00000000383, 3.00200467817, 551.2129166508],
    [0.00000000279, 4.06882632435, 904.1896587621],
    [0.00000000366, 6.15032242763, 491.8185618877],
    [0.00000000341, 3.73123892015, 452.4616859725],
    [0.0000000036, 3.29825671883, 104.5290628171],
    [0.00000000319, 5.57991791116, 459.3627846522],
    [0.00000000386, 4.71096019501, 901.9544265284],
    [0.00000000296, 2.33233720412, 89.5993933999],
    [0.00000000348, 0.93025072898, 29.7474642498],
    [0.00000000308, 1.48912863494, 1530.8060125785],
    [0.00000000272, 2.84186859971, 2045.4667345194],
    [0.00000000327, 2.25624475244, 272.5815756165],
    [0.00000000333, 3.58076165959, 428.0826635843],
    [0.00000000349, 2.34615857088, 6069.7767545534],
    [0.00000000278, 5.33956009504, 335.7749571987],
    [0.0000000027, 5.72961044984, 450.1740641121],
    [0.00000000282, 2.51807549695, 156.043604689],
    [0.00000000334, 3.79230663769, 697.8071683688],
    [0.0000000027, 0.49362216969, 320.3240229197],
    [0.00000000321, 0.71639963302, 320.2758388099],
    [0.00000000296, 2.51339170311, 266.1011680621],
    [0.0000000027, 4.99754135777, 309.2783226558],
    [0.00000000265, 3.33672155263, 639.897286314],
    [0.00000000324, 5.54296698387, 1507.1777497157],
    [0.00000000282, 0.62853626574, 263.962304048],
    [0.00000000366, 5.89950070572, 268.9582388941],
    [0.00000000285, 4.23006264357, 177.3049238143],
    [0.00000000347, 4.708520824, 282.1428031721],
    [0.00000000332, 0.7653592353, 50.66320861],
    [0.00000000284, 2.87061321749, 883.7951792637],
    [0.00000000333, 6.24087751277, 563.6312150384],
    [0.00000000363, 3.29320353192, 378.9039276826],
    [0.00000000336, 3.79029047358, 9999.986450773],
    [0.00000000259, 4.37287015895, 1310.3933701397],
    [0.00000000255, 4.84760640021, 229.7614216733],
    [0.00000000286, 3.72531001807, 230.9370778409],
    [0.00000000332, 2.36777399155, 2274.5468326365],
    [0.00000000325, 5.91384585098, 9990.4252232174],
    [0.0000000026, 5.92834225229, 455.0694252217],
    [0.00000000274, 0.53976988872, 380.2396425446],
    [0.00000000319, 4.92433309582, 1140.38330388],
    [0.00000000259, 3.15728798274, 454.7493078329],
    [0.00000000293, 3.80820074659, 194.1766403268],
    [0.00000000264, 0.34153729395, 1193.9672737968],
    [0.00000000296, 2.31655276454, 422.7142217227],
    [0.00000000303, 0.17738702664, 384.5811860849],
    [0.00000000285, 1.29732672572, 25.1297819136],
    [0.00000000251, 1.67282111226, 447.2051186955],
    [0.00000000251, 3.03412113376, 117.3198682202],
    [0.00000000326, 1.68159391466, 161.7208630913],
    [0.00000000248, 5.85392046839, 229.340730548],
    [0.00000000258, 5.02749399426, 406.954470903],
    [0.00000000264, 6.15508431133, 1385.174968707],
    [0.00000000276, 1.5783145232, 336.8387387817],
    [0.00000000264, 2.90833578247, 75.1541055828],
    [0.00000000284, 5.70644286377, 92.4195809702],
    [0.00000000273, 3.78780023228, 380.0158933754],
    [0.00000000252, 2.00771359511, 85.9391734158],
    [0.00000000255, 5.06133623645, 102.523325247],
    [0.00000000257, 1.34131613295, 304.1223291153],
    [0.00000000244, 2.73811369909, 445.7206459872],
    [0.00000000265, 3.0254012179, 454.7974919427],
    [0.00000000274, 1.36882612211, 188.6594406189],
    [0.00000000239, 5.33018322578, 293.7097682978],
    [0.00000000235, 5.60412059654, 437.6438911399],
    [0.00000000276, 5.62363398057, 187.1749679106],
    [0.00000000278, 3.81695614226, 31.5407534988],
    [0.00000000292, 4.64128185538, 151.850818995],
    [0.00000000314, 3.86400459047, 734.4557312983],
    [0.00000000234, 1.80885124531, 1503.2455964526],
    [0.00000000322, 2.35445171313, 122.4758617607],
    [0.00000000258, 6.05880184188, 455.0212411119],
    [0.00000000238, 2.56020773425, 170.0100662597],
    [0.00000000232, 4.77316690974, 73.3453099688],
    [0.00000000232, 5.10057210704, 263.0203480609],
    [0.0000000024, 2.9977784079, 1147.4968508808],
    [0.00000000281, 4.15776226983, 279.4826742962],
    [0.00000000257, 3.04913300739, 436.8138097374],
    [0.00000000235, 3.02410451628, 361.3778198643],
    [0.00000000255, 0.88643610795, 418.5214360287],
    [0.00000000264, 1.89462495453, 74.4090915518],
    [0.00000000268, 0.38577446389, 444.2361732789],
    [0.00000000222, 4.53746462038, 230.8252032563],
    [0.00000000241, 2.49671371454, 548.2439712342],
    [0.00000000239, 4.41496531562, 213.9534867438],
    [0.00000000237, 3.26466054351, 535.9107402181],
    [0.0000000022, 0.41236373275, 448.3170843883],
    [0.00000000226, 3.93834877953, 754.0357607965],
    [0.00000000237, 2.40162775612, 827.9235874865],
    [0.0000000024, 1.77900522919, 380.3884003909],
    [0.00000000224, 0.05082919493, 76.2178871658],
    [0.00000000258, 4.48552116447, 551.1010420662],
    [0.00000000278, 4.63839965274, 341.9947323222],
    [0.000000003, 1.76109411385, 371.5297482509],
    [0.00000000287, 3.90151164865, 531.978586955],
    [0.00000000274, 1.99452951365, 968.1380053866],
    [0.00000000262, 6.12295568294, 311.2840602259],
    [0.00000000264, 5.76806626227, 635.9651330509],
    [0.00000000214, 1.90097549431, 208.8456773131],
    [0.00000000221, 5.7356410833, 1136.4511506169],
    [0.00000000279, 2.40796258509, 1670.0742689746],
    [0.00000000247, 4.10467533143, 962.5089310941],
    [0.00000000251, 0.65896974227, 423.6292454594],
    [0.00000000273, 4.48420386716, 6060.2155269978],
    [0.00000000284, 1.98517323011, 402.2191684878],
    [0.00000000213, 0.40391978805, 197.7999770492],
    [0.00000000271, 3.29944247062, 749.5823426716],
    [0.00000000214, 1.77108713711, 358.4088744477],
    [0.00000000212, 1.30757526648, 74.1484591209],
    [0.00000000285, 3.45237643998, 299.7170951002],
    [0.00000000215, 0.11685291153, 893.3564068193],
    [0.00000000226, 4.36569336172, 450.7165808333],
    [0.00000000285, 0.89336265206, 81.6345131372],
    [0.00000000276, 2.67678282261, 310.9752436852],
    [0.00000000237, 4.64910992307, 385.7568422525],
    [0.00000000233, 5.3964471152, 245.5424243524],
    [0.00000000266, 0.21523688619, 148.8124376092],
    [0.00000000222, 1.64662422921, 76.42612997],
    [0.00000000271, 2.94530770298, 763.4369296577],
    [0.00000000209, 5.56347456206, 78.9262001515],
    [0.0000000025, 1.28952902548, 421.1815649046],
    [0.00000000254, 2.61839399513, 525.2375469697],
    [0.00000000221, 2.85700154975, 104.5772469269],
    [0.00000000235, 0.29404113312, 6057.2465815812],
    [0.00000000213, 1.81939118803, 104.8378793578],
    [0.00000000219, 4.81031857297, 377.6800874052],
    [0.00000000239, 4.14502038477, 260.360219185],
    [0.00000000259, 6.22064928944, 305.6068018236],
    [0.00000000241, 4.25260400494, 1478.8665740644],
    [0.0000000026, 6.06592450487, 586.3133163972],
    [0.00000000215, 2.19677481542, 1321.4390704036],
    [0.0000000024, 6.18410669894, 689.6185389369],
    [0.00000000204, 0.09387343234, 945.2434557067],
    [0.00000000219, 0.49807555465, 507.5995645668],
    [0.00000000203, 1.80599017081, 1072.7152523135],
    [0.00000000212, 5.16316390795, 256.4280659219],
    [0.00000000262, 2.82472906853, 971.1069508032],
    [0.0000000028, 3.80946061981, 67.9286839974],
    [0.00000000212, 3.61675003861, 75.4147380137],
    [0.00000000205, 0.30735417946, 461.1291416508],
    [0.00000000222, 3.52840777605, 511.5317178299],
    [0.00000000198, 4.47397050345, 289.5651667136],
    [0.00000000271, 3.44737698948, 564.8550553158],
    [0.00000000234, 0.17593976046, 251.1714986449],
    [0.00000000199, 4.86362206373, 76.7873361374],
    [0.00000000211, 1.0554409044, 257.3912737684],
    [0.00000000214, 3.97499500159, 370.5665404044],
    [0.00000000211, 4.12360308875, 695.5564297701],
    [0.00000000196, 3.96250134928, 412.3710968744],
    [0.00000000229, 5.00491031721, 103.9865460959],
    [0.00000000242, 5.74082244878, 340.5102596139],
    [0.0000000023, 2.56838559117, 147.5574595645],
    [0.00000000208, 3.79662225345, 325.3836482406],
    [0.00000000258, 0.01795959348, 2199.7652340692],
    [0.00000000213, 5.89130495905, 170.1701249541],
    [0.00000000267, 0.78536095157, 976.7360250957],
    [0.00000000218, 1.97075089989, 569.0478410098],
    [0.00000000257, 1.38354609083, 360.4146120178],
    [0.00000000195, 3.26824797258, 984.7122062065],
    [0.00000000251, 4.87361192641, 516.0488264296],
    [0.00000000202, 4.03331754714, 187.2755416471],
    [0.00000000223, 0.97997805412, 627.3671133418],
    [0.00000000205, 5.2807414321, 223.3815878554],
    [0.00000000224, 5.24077049451, 206.706813299],
    [0.0000000026, 5.90070113141, 520.129737539],
    [0.00000000188, 1.49833733081, 26.826702943],
    [0.00000000205, 5.05597552852, 772.7857088922],
    [0.00000000228, 3.64861995308, 367.5975949878],
    [0.00000000237, 2.97607548462, 271.61836777],
    [0.00000000224, 1.2520150817, 161.4120465506],
    [0.00000000185, 4.50042780818, 224.8660605637],
    [0.00000000236, 5.41408651212, 550.1378342197],
    [0.00000000192, 2.35024531733, 236.1936451179],
    [0.00000000237, 3.66086044285, 1106.6555022573],
    [0.00000000225, 1.66222054133, 1366.2125722902],
    [0.00000000193, 3.0143183166, 164.3809919672],
    [0.00000000218, 5.46588301502, 1500.0642027149],
    [0.00000000207, 5.55969556391, 332.6941371975],
    [0.00000000208, 4.68503146595, 448.9714756941],
    [0.00000000211, 0.34453145739, 980.6681783588],
    [0.00000000217, 3.70105940449, 655.938921424],
    [0.0000000019, 1.69474626512, 1031.87390369],
    [0.00000000254, 2.52997093206, 58.1705144857],
    [0.00000000242, 4.63165125809, 167.7224443993],
    [0.00000000182, 0.38822952347, 249.9476583675],
    [0.00000000229, 2.97276294509, 676.2852168126],
    [0.00000000184, 0.87882802865, 947.6911362615],
    [0.00000000203, 3.17061034955, 846.0828347512],
    [0.00000000181, 4.5754808316, 343.2185725996],
    [0.0000000025, 3.61454066264, 452.2010535416],
    [0.00000000181, 0.8050526257, 168.3131452303],
    [0.00000000187, 0.91771297573, 556.5176680376],
    [0.00000000199, 1.94637571303, 253.4591205053],
    [0.00000000191, 0.61001202802, 394.9455627926],
    [0.0000000018, 3.74457885445, 1447.4263943021],
    [0.00000000179, 5.35660015345, 122.0551706354],
    [0.00000000231, 6.22502194357, 1610.2705239343],
    [0.0000000024, 6.0370383453, 898.7730327907],
    [0.00000000218, 2.33495824686, 623.4349600787],
    [0.00000000181, 1.91828280417, 337.5894983071],
    [0.00000000221, 2.8913812666, 238.9019581036],
    [0.00000000209, 1.03618779316, 6212.2264046872],
    [0.00000000213, 1.02918228734, 657.1627617014],
    [0.00000000183, 2.72582542773, 332.1728723357],
    [0.00000000204, 4.6751275615, 377.4194549743],
    [0.00000000205, 5.62140485721, 388.4651552382],
    [0.00000000219, 2.76359711762, 561.8861098992],
    [0.00000000212, 3.46768338211, 181.6464673546],
    [0.00000000211, 4.59763685784, 1109.6244476739],
    [0.00000000212, 2.99004198457, 559.6990617753],
    [0.00000000174, 2.21353674595, 887.7273325268],
    [0.00000000173, 1.74529912106, 365.149914433],
    [0.00000000174, 2.45391768476, 1332.4847706675],
    [0.0000000024, 4.85443977637, 761.7400086283],
    [0.00000000178, 0.05006039446, 941.3113024436],
    [0.00000000195, 2.37804209176, 444.8268741099],
    [0.00000000242, 4.29915867363, 6244.9428143536],
    [0.00000000172, 3.87569337913, 389.6889955156],
    [0.00000000188, 2.26967965211, 90.9351082619],
    [0.00000000217, 1.72840709072, 10213.285546211],
    [0.00000000221, 3.92472409608, 562.6680071919],
    [0.00000000173, 4.18722182816, 247.8300462128],
    [0.00000000174, 2.94442479945, 454.8611824175],
    [0.00000000239, 3.42577256015, 188.2387494936],
    [0.00000000174, 6.14174672485, 454.9575506371],
    [0.00000000191, 0.05959544276, 429.7795846137],
    [0.00000000199, 4.06645118654, 6204.362098161],
    [0.00000000232, 0.73635761605, 525.7588118315],
    [0.0000000019, 3.21864199482, 473.4623726669],
    [0.00000000184, 2.09184439155, 262.8078997398],
    [0.00000000204, 2.53426014155, 128.4350044533],
    [0.00000000199, 5.18040948653, 517.4214245533],
    [0.00000000169, 3.32081675151, 442.3791935551],
    [0.00000000194, 1.70394842618, 454.6487340964],
    [0.00000000174, 0.92072543792, 298.2326223919],
    [0.00000000197, 2.45889996723, 10142.4361009068],
    [0.00000000169, 2.85071771667, 182.279606801],
    [0.00000000176, 3.0680256881, 594.9113361063],
    [0.0000000017, 1.61438641294, 1512.8068240082],
    [0.00000000181, 5.5485277762, 388.2045228073],
    [0.00000000205, 2.42849105018, 179.3106613844],
    [0.00000000168, 0.36331522083, 597.3590166611],
    [0.00000000233, 4.13122108092, 544.5087599272],
    [0.00000000212, 1.16230626511, 268.6976064632],
    [0.00000000164, 4.16304107762, 433.7117378768],
    [0.00000000184, 4.13171323402, 78114.14622758799],
    [0.00000000216, 4.13270907264, 375.6743498351],
    [0.00000000164, 3.48735100134, 1521.4048437173],
    [0.00000000166, 3.69271105852, 381.0909758065],
    [0.00000000215, 3.01465140857, 3191.0492295652],
    [0.0000000021, 0.51797558404, 987.7817253596],
    [0.00000000196, 1.96055142388, 255.8373650909],
    [0.00000000188, 1.75260412819, 9987.4562778008],
    [0.00000000183, 1.55394479952, 545.2750258176],
    [0.00000000162, 3.53658533673, 477.0007670551],
    [0.00000000197, 1.23651696009, 873.1701701251],
    [0.00000000228, 5.72185284514, 10175.1525105732],
    [0.00000000221, 1.65277750718, 630.3360587584],
    [0.00000000166, 4.86610094513, 1440.9941708575],
    [0.00000000177, 3.02796963506, 5983.9494557222],
    [0.0000000017, 2.58560048709, 1515.7757694248],
    [0.00000000177, 2.88506192589, 240.125798381],
    [0.00000000208, 2.04949512692, 302.3772239761],
    [0.00000000189, 5.8294637878, 36.1754821775],
    [0.00000000216, 0.68196473963, 1363.2436268736],
    [0.00000000175, 2.61001153558, 885.4397106664],
    [0.0000000021, 2.6555551593, 224.4566702865],
    [0.0000000016, 3.50517836979, 150.31395666],
    [0.00000000174, 0.49467967031, 369.9758395734],
    [0.00000000188, 5.48911204749, 10134.5717943806],
    [0.00000000191, 5.68393131484, 662.6430781476],
    [0.00000000205, 0.92509219538, 548.4409131903],
    [0.00000000206, 6.10268880505, 1054.9285120643],
    [0.00000000185, 0.91857524328, 440.8947208468],
    [0.00000000189, 2.67822187732, 2250.1678102483],
    [0.00000000184, 5.67663245346, 409.9234163196],
    [0.00000000207, 3.01561723041, 95.2766518022],
    [0.00000000192, 3.38477678765, 141.1776257466],
    [0.00000000175, 3.98637627601, 354.9979860464],
    [0.00000000179, 1.06144138645, 455.1699989582],
    [0.00000000185, 1.48084539492, 226.7924762567],
    [0.00000000172, 2.45526838627, 398.2870152247],
    [0.00000000203, 4.82705125287, 6737.9852165187],
    [0.00000000159, 3.62343847192, 73.9784494152],
    [0.00000000215, 3.25584948597, 125.1841747464],
    [0.00000000205, 0.77710214764, 769.8167634756],
    [0.00000000164, 4.68848272913, 6607.9277275406],
    [0.00000000215, 1.66517240781, 118.0706277456],
    [0.00000000164, 0.87369484245, 774.4826299216],
    [0.0000000016, 3.32460761773, 138.5656809805],
    [0.00000000161, 2.52319991589, 409.0720830577],
    [0.00000000173, 3.15899401917, 70.0462961521],
    [0.00000000158, 0.06255653314, 138.4693127609],
    [0.00000000154, 5.92679370788, 224.2329211173],
    [0.00000000166, 4.16626167677, 72.0732855816],
    [0.00000000183, 2.68426170572, 838.0060799039],
    [0.00000000193, 1.38193725138, 154.6710065653],
    [0.00000000188, 3.61481992714, 517.1607921224],
    [0.00000000189, 0.667494835, 484.917463208],
    [0.00000000203, 2.66775880985, 327.4375699205],
    [0.00000000193, 4.43470193645, 832.0681890707],
    [0.00000000159, 0.56494121338, 379.1645601135],
    [0.00000000166, 4.45048519194, 9914.1591519418],
    [0.00000000168, 3.52621114631, 464.9918589447],
    [0.00000000196, 6.24770073617, 10668.1949127383],
    [0.00000000151, 5.72816916526, 59.5912967192],
    [0.00000000181, 0.32013093352, 421.2297490144],
    [0.00000000205, 6.02871481422, 772.5887669361],
    [0.00000000176, 4.99216368664, 123.0183784819],
    [0.0000000016, 1.37750465628, 308.6876218248],
    [0.00000000202, 1.13801628591, 508.6264628881],
    [0.00000000177, 3.63679025498, 1291.4309737229],
    [0.00000000151, 1.15330259215, 1116.0042814918],
    [0.00000000178, 4.93531001103, 349.3689117539],
    [0.00000000205, 2.81769329338, 225.3080035484],
    [0.00000000182, 0.9147484027, 3189.5647568569],
    [0.00000000156, 2.37674956845, 151.260118164],
    [0.00000000154, 2.76526452323, 78263.70942472259],
    [0.00000000162, 5.62540185969, 1123.1178284926],
    [0.00000000182, 0.63986108075, 274.5873131866],
    [0.00000000156, 4.83915698384, 753.1419889192],
    [0.00000000167, 6.27621577207, 757.8078553652],
    [0.00000000151, 1.69627858213, 325.9530972122],
    [0.00000000149, 2.40009261288, 210.8514148832],
    [0.00000000149, 5.09330665926, 509.0840372751],
    [0.00000000179, 0.93833237775, 196.8367692027],
    [0.00000000195, 0.2327276971, 984.4884570373],
    [0.00000000147, 2.15520667674, 73.2489417492],
    [0.00000000166, 4.95085074433, 276.9231191568],
    [0.00000000194, 5.71948163347, 6136.4815982734],
    [0.00000000148, 1.50337825489, 1525.3369969804],
    [0.00000000205, 0.81050821834, 6171.6456884946],
    [0.00000000195, 5.02600286169, 415.2918581812],
    [0.00000000147, 4.88804405947, 683.0262567979],
    [0.00000000168, 4.68232587155, 519.6084726772],
    [0.00000000161, 1.71491481543, 277.146868326],
    [0.00000000185, 5.8624034365, 1743.3713948336],
    [0.00000000177, 5.39738308693, 25936.85547173129],
    [0.00000000159, 3.71583639802, 6604.958782124],
    [0.00000000152, 3.76465336789, 768.8535556291],
    [0.00000000191, 4.45675615557, 340.8827666294],
    [0.00000000147, 6.01587695039, 369.342700127],
    [0.00000000148, 1.70522713789, 1523.6924655777],
    [0.00000000144, 1.19516771137, 95.9792272178],
    [0.00000000181, 4.75684140426, 71.1582618449],
    [0.00000000145, 3.15169720832, 523.4711899711],
    [0.00000000146, 4.40646311724, 2014.0265547571],
    [0.00000000162, 4.76511090288, 245.4942402426],
    [0.00000000195, 1.45876037172, 281.4884118663],
    [0.00000000155, 2.45354382334, 557.0389328994],
    [0.00000000149, 2.09335099835, 273.8536000037],
    [0.00000000187, 1.77504712447, 995.6460318858],
    [0.00000000151, 3.12279980744, 746.7621551013],
    [0.00000000147, 5.09554340545, 466.7582159433],
    [0.00000000172, 1.4253511108, 276.0717858949],
    [0.0000000019, 0.86480008, 10066.691294493],
    [0.00000000154, 2.07677643107, 91.2439248026],
    [0.00000000142, 2.70241566553, 1367.6970449985],
    [0.00000000185, 0.07257813358, 548.6533615114],
    [0.0000000014, 2.61987335792, 76.3142553854],
    [0.00000000154, 3.03571181321, 714.6788848813],
    [0.00000000169, 5.57948514798, 163.5778428151],
    [0.00000000186, 4.76535517241, 197.257460328],
    [0.00000000153, 3.32414222326, 138.4056222861],
    [0.00000000167, 5.32278498942, 457.3570470821],
    [0.00000000142, 4.15791797624, 156.6767441354],
    [0.00000000151, 4.34031737599, 147.9668498417],
    [0.00000000183, 6.17032359307, 132.5796060375],
    [0.00000000138, 2.1381195819, 540.0553418023],
    [0.00000000138, 5.01289623723, 144.8973306886],
    [0.00000000167, 2.14405503902, 343.7398374614],
    [0.00000000152, 3.1101565976, 1381.2428154439],
    [0.00000000177, 1.05125544318, 586.377006872],
    [0.00000000149, 4.87184568681, 130.552616608],
    [0.00000000155, 5.70008442904, 115.6229471908],
    [0.00000000149, 4.3313015842, 223.8235308401],
    [0.00000000181, 4.1377051741, 267.5856407704],
    [0.00000000154, 2.83750308914, 108.982480942],
    [0.00000000163, 2.53865234151, 743.7932096847],
    [0.00000000165, 3.41287686341, 247.2393453818],
    [0.00000000151, 2.20235595263, 476.3194434989],
    [0.00000000144, 0.01781384847, 164.5410506616],
    [0.0000000013, 2.21675074014, 1596.9895914367],
    [0.00000000139, 1.43423426981, 73.5577582899],
    [0.0000000013, 2.59858785273, 317.8763423649],
    [0.00000000151, 0.90758816089, 156.4642958143],
    [0.00000000132, 5.78977405289, 262.0571402144],
    [0.0000000015, 3.82803929273, 523.7530742614],
    [0.00000000128, 1.75773422282, 77.7023598741],
    [0.00000000129, 2.46767229126, 680.0573113813],
    [0.00000000133, 2.63453025078, 973.554631358],
    [0.00000000141, 3.2165757437, 710.7467316182],
    [0.00000000135, 4.39682615321, 153.186533857],
    [0.00000000164, 0.99473913469, 94.4253185403],
    [0.00000000145, 5.12015953658, 677.7696895209],
    [0.00000000126, 1.32965975637, 400.5746370851],
    [0.00000000141, 1.24113752853, 460.8472573605],
    [0.00000000133, 4.6173080944, 250.6020496733],
    [0.00000000129, 5.27547517603, 88.274979386],
    [0.00000000127, 0.42170103072, 913.7508863177],
    [0.00000000163, 4.54645286709, 346.4481504471],
    [0.00000000125, 3.65991404025, 191.3195694948],
    [0.00000000145, 2.22528076208, 673.316271396],
    [0.00000000126, 4.73776902368, 1063.3140834523],
    [0.00000000134, 1.14931407095, 725.0914456988],
    [0.00000000129, 3.47362853744, 1257.7031721002],
    [0.00000000124, 5.93939315836, 354.7855377253],
    [0.00000000136, 2.59497163361, 1119.1856752295],
    [0.00000000154, 0.69730597728, 365.9006739584],
    [0.0000000014, 0.6554324722, 73.0364934281],
    [0.00000000146, 2.80047542494, 188.9200730498],
    [0.00000000154, 1.87714738928, 164.1203595363],
    [0.00000000125, 2.18116740243, 764.1876891831],
    [0.00000000155, 1.28214942977, 148.1905990109],
    [0.00000000132, 0.29965207574, 255.57673266],
    [0.00000000125, 1.04485712681, 415.6643651967],
    [0.00000000137, 2.18373893649, 765.8846102125],
    [0.00000000127, 2.93669188864, 147.8662761052],
    [0.0000000014, 0.7686003141, 273.1510245881],
    [0.00000000142, 4.10293143898, 309.7995875176],
    [0.00000000118, 5.29215987279, 346.1875180162],
    [0.00000000118, 5.64065029465, 430.5303441391],
    [0.00000000117, 4.70740499014, 346.3999663373],
    [0.00000000159, 3.17545315975, 587.8614795803],
    [0.0000000013, 4.93752382941, 112.3933693433],
    [0.00000000123, 2.01301867655, 376.8769382531],
    [0.00000000131, 5.76525549509, 75.4359898731],
    [0.00000000152, 4.20648305698, 76.5267037065],
    [0.00000000133, 0.27916246107, 221.1634019642],
    [0.00000000115, 6.2695499475, 226.6324175623],
    [0.00000000159, 6.17088331412, 269.0701134787],
    [0.00000000114, 3.58569184745, 1048.3362299253],
    [0.00000000152, 2.72945581345, 639.6366538831],
    [0.00000000121, 4.6766183437, 1222.2784494481],
    [0.00000000119, 4.81856456066, 73.4571845534],
    [0.00000000125, 0.74436796006, 280.2163874791],
    [0.00000000117, 4.00334187137, 107.918699359],
    [0.00000000113, 2.15393931454, 303.0585475323],
    [0.00000000128, 0.04409162068, 76.1060125812],
    [0.00000000142, 0.57614004948, 246.4361962297],
    [0.00000000138, 5.48635616668, 392.6579409322],
    [0.00000000156, 4.96860085576, 552.6973893591],
    [0.00000000112, 4.3135786833, 74.3240241803],
    [0.00000000116, 3.19955309317, 71.8608372605],
    [0.00000000112, 0.38818418554, 75.2391729543],
    [0.0000000011, 1.3527736469, 376.9463742223],
    [0.00000000152, 0.76257718923, 956.2891559706],
    [0.00000000116, 4.73215012461, 1052.2683831884],
    [0.00000000137, 2.4089304502, 488.5889840402],
    [0.00000000121, 4.23091725782, 115.3623147599],
    [0.00000000131, 0.45681197732, 1261.6353253633],
    [0.00000000142, 1.8732433243, 175.4266922311],
    [0.00000000128, 2.98656300188, 694.8382229522],
    [0.00000000107, 5.62518758086, 582.3811631341],
    [0.00000000134, 4.02062578806, 57.7980074702],
    [0.00000000112, 1.06960066812, 481.7360694703],
    [0.00000000106, 1.01847069745, 625.8826406335],
    [0.00000000125, 1.1476668453, 688.4428827693],
    [0.0000000011, 1.50687781826, 1083.7609525774],
    [0.00000000122, 3.47813324957, 763.2244813366],
    [0.00000000109, 0.4799155699, 143.3434220111],
    [0.00000000109, 2.37913722341, 313.6835566709],
    [0.00000000112, 4.82305132773, 323.5054166574],
    [0.00000000133, 3.91778366061, 9988.9407505091],
    [0.00000000117, 5.79438398039, 383.3091616977],
    [0.00000000143, 2.38142377439, 355.7487455718],
    [0.00000000104, 6.22747103073, 166.237971691],
    [0.00000000125, 0.93541375535, 532.8723588323],
    [0.00000000136, 3.34772962822, 624.5100425098],
    [0.00000000111, 2.80052858233, 185.5786206177],
    [0.00000000122, 0.66856217536, 499.895316735],
    [0.00000000129, 5.71746410559, 388.7257876691],
    [0.00000000124, 0.47197488986, 480.8847362084],
    [0.00000000099, 2.73963726422, 469.7271613599],
    [0.00000000135, 0.43811617647, 1286.0143477515],
    [0.00000000118, 5.62193572572, 386.9806825299],
    [0.00000000098, 6.12967230866, 1830.6831663731],
    [0.00000000109, 2.38141278301, 73.9302653054],
    [0.00000000131, 5.44225511718, 74.1272072615],
    [0.000000001, 3.99996377183, 313.9441891018],
    [0.00000000097, 0.80340713292, 840.6662087798],
    [0.00000000113, 4.35141023213, 904.4021070832],
    [0.00000000108, 1.53330326885, 215.7467759928],
    [0.00000000113, 0.54441962592, 1250.5896250994],
    [0.00000000098, 1.38351669708, 1218.1338478639],
    [0.00000000102, 5.79129370115, 65.3804297061],
    [0.00000000106, 3.94341216754, 678.3603903519],
    [0.00000000124, 1.28838964889, 664.1275508559],
    [0.00000000099, 0.02552769353, 117.36805233],
    [0.00000000131, 2.67824794719, 981.6313862053],
    [0.00000000119, 3.92954881851, 6134.9971255651],
    [0.00000000128, 4.11821528752, 632.7837393132],
    [0.0000000011, 3.43940323812, 78.9743842613],
    [0.00000000124, 4.84054644412, 1162.4747044078],
    [0.00000000098, 4.25775813209, 199.8057146193],
    [0.00000000125, 2.27613295738, 424.1505103212],
    [0.00000000126, 3.91634098527, 26086.4186688659],
    [0.00000000101, 5.1361968957, 915.4478073471],
    [0.00000000113, 4.93378111345, 108.7218485111],
    [0.00000000105, 3.71144437242, 107.0249274817],
    [0.00000000125, 5.71482360911, 3339.1279539915],
    [0.00000000097, 5.84826276361, 739.0579072695],
    [0.00000000106, 2.53486223474, 76.0054388447],
    [0.00000000111, 1.67593033062, 1002.7595788866],
    [0.00000000105, 3.08951960134, 598.5346728287],
    [0.00000000109, 5.84626924359, 51.8870488874],
    [0.00000000115, 4.28360700908, 172.1971143836],
    [0.00000000097, 3.02476841325, 669.0116111174],
    [0.00000000104, 3.79048221012, 661.1586054393],
    [0.00000000128, 4.12077041398, 537.3952129264],
    [0.00000000119, 5.28769603458, 151.1595444275],
    [0.00000000123, 0.7671758747, 566.600160455],
    [0.00000000125, 2.4609349466, 686.958410061],
    [0.0000000011, 0.48706972538, 367.8582274187],
    [0.00000000091, 1.20582179592, 1134.1635287565],
    [0.00000000127, 5.92519293974, 322.6116447801],
    [0.00000000095, 1.48492429003, 70.5888128733],
    [0.00000000105, 1.25919493117, 524.0618908021],
    [0.00000000109, 2.16321134153, 506.3757242894],
    [0.00000000096, 5.79387198359, 335.1418177523],
    [0.000000001, 0.1643562606, 1895.9035373848],
    [0.00000000104, 6.19360690877, 150.3663462867],
    [0.00000000127, 2.12085008036, 6206.8097787158],
    [0.00000000116, 1.93143384597, 636.6677084665],
    [0.00000000094, 3.60705393791, 1226.2106027112],
    [0.00000000101, 0.24474158501, 170.7126416753],
    [0.00000000091, 2.18722199515, 294.3004691288],
    [0.00000000092, 5.62416527287, 798.1279391269],
    [0.00000000115, 0.61012607379, 583.8656358424],
    [0.00000000102, 4.71122439335, 924.0458270562],
    [0.00000000089, 5.21344736627, 207.6700211455],
    [0.00000000094, 3.70231426761, 63.2146334416],
    [0.00000000091, 3.75312295357, 923.1520551789],
    [0.0000000011, 3.96973294508, 154.5591319807],
    [0.00000000109, 1.01882208456, 748.0978699633],
    [0.00000000118, 0.99881794452, 134.3728952865],
    [0.0000000009, 0.41169241547, 318.679491517],
    [0.00000000107, 3.76840018527, 882.9920301116],
    [0.00000000088, 5.47502707027, 70.6369969831],
    [0.00000000088, 0.90750547659, 612.1768114937],
    [0.00000000118, 3.14225356391, 37.1698277913],
    [0.00000000106, 5.71907464992, 1101.0264279648],
    [0.00000000092, 1.60540815321, 213.4109700226],
    [0.00000000108, 2.73050081078, 73.0846775379],
    [0.00000000091, 0.73982044423, 320.1639642253],
    [0.00000000095, 3.37355805725, 190.665178189],
    [0.0000000009, 2.58787034269, 75.5153117502],
    [0.00000000102, 2.92980359364, 533.4630596633],
    [0.00000000092, 4.94283886398, 1055.4497769261],
    [0.00000000113, 2.3554198498, 176.6505325085],
    [0.00000000098, 6.04221644753, 1357.6145525811],
    [0.00000000086, 2.90604124166, 234.4967240885],
    [0.00000000085, 0.83669286935, 301.4140161296],
    [0.00000000098, 0.8515463012, 1131.1945833399],
    [0.00000000112, 0.92696951989, 590.8304249969],
    [0.00000000112, 5.45918572076, 705.1176573257],
    [0.00000000101, 4.26515214526, 195.4004806042],
    [0.00000000102, 5.81318586612, 1396.2206689709],
    [0.00000000084, 3.86583598631, 913.0001267923],
    [0.00000000101, 0.14878503401, 702.1487119091],
    [0.00000000098, 0.30973273548, 12.1576659567],
    [0.00000000094, 5.53729042047, 178.1350052168],
    [0.0000000009, 1.42741371964, 592.2030231206],
    [0.00000000103, 3.56392656212, 487.1045113319],
    [0.00000000114, 1.71224480179, 216.2680408546],
    [0.00000000098, 6.12303086368, 575.2676161333],
    [0.00000000082, 3.07432558693, 315.1680293792],
    [0.00000000099, 0.95472771381, 176.3899000776],
    [0.00000000114, 2.59949812888, 75.6329318292],
    [0.00000000091, 5.72899997508, 196.8849533125],
    [0.00000000098, 1.78363341484, 259.769518354],
    [0.00000000113, 1.70438642876, 150.9357952583],
    [0.00000000081, 6.19017012933, 154.2290635806],
    [0.00000000087, 2.6792993877, 539.0921339558],
    [0.0000000008, 2.38043346629, 1053.7528558967],
    [0.00000000084, 3.41034232685, 1349.7502460549],
    [0.00000000088, 0.14553753672, 1062.3508756058],
    [0.00000000092, 0.39976274896, 576.1613880106],
    [0.0000000008, 6.14901515198, 515.463871093],
    [0.00000000084, 4.08795854193, 323.2447842265],
    [0.00000000079, 3.44985050546, 71.7007785661],
    [0.00000000103, 0.24719113679, 395.105621487],
    [0.00000000081, 2.61930932018, 623.2225117576],
    [0.00000000079, 0.90143680512, 718.6110381444],
    [0.00000000079, 2.22415153671, 74.0478853844],
    [0.00000000092, 2.57503576494, 302.164775655],
    [0.00000000094, 4.1347259059, 64.2571631652],
    [0.0000000009, 3.55225063298, 495.9631634719],
    [0.00000000097, 5.23472340611, 1112.0721282287],
    [0.00000000088, 5.01537308962, 1297.8631971675],
    [0.0000000009, 1.32491876418, 724.8308132679],
    [0.00000000106, 5.11210367902, 74.1908977363],
    [0.00000000084, 2.69256231569, 27.7417266797],
    [0.00000000083, 3.61925786724, 514.7131115676],
    [0.0000000008, 4.91927269399, 347.3631741838],
    [0.00000000077, 5.57198158633, 74.9940468884],
    [0.00000000082, 2.2288257386, 469.8872200543],
    [0.00000000089, 6.06487552896, 75.3722993983],
    [0.00000000078, 3.25878759023, 394.3548619616],
    [0.00000000104, 3.00022428298, 532.6599105112],
    [0.00000000079, 4.37011833943, 396.5419100855],
    [0.00000000103, 3.64560367439, 540.7366653585],
    [0.00000000082, 4.43941220587, 432.8179659995],
    [0.00000000101, 5.81737971094, 658.1896600227],
    [0.00000000097, 2.59101775215, 690.1398037987],
    [0.00000000082, 5.40861394405, 529.57909051],
    [0.00000000081, 2.52312280794, 384.9536931004],
    [0.00000000076, 4.43418522057, 818.574808252],
    [0.00000000081, 0.95220782125, 73.6696328745],
    [0.00000000087, 5.5722785666, 6284.5603226997],
    [0.00000000094, 6.23547840274, 305.7186764082],
    [0.00000000075, 4.35228806434, 112.4939430798],
    [0.00000000096, 1.1290951463, 123.960334469],
    [0.00000000095, 2.73244270397, 934.1977554428],
    [0.00000000097, 4.75415372291, 90.5626012464],
    [0.00000000088, 5.23693832326, 434.6749457233],
    [0.00000000076, 4.86126967725, 72.4939767069],
    [0.00000000104, 5.37590823539, 543.9180590962],
    [0.00000000091, 1.04794288604, 938.1299087059],
    [0.00000000099, 2.19698635547, 1129.7101106316],
    [0.00000000074, 3.27934639338, 89.0086925689],
    [0.000000001, 4.59916398079, 461.7622810972],
    [0.00000000074, 5.6349392604, 233.533516242],
    [0.00000000074, 3.03606610688, 1531.5567721039],
    [0.00000000099, 0.64774167845, 554.1818620674],
    [0.00000000084, 3.14436294064, 370.0452755426],
    [0.00000000077, 1.33778374453, 1022.3126761344],
    [0.00000000081, 3.36096602483, 292.0128472684],
    [0.00000000081, 4.15588604506, 432.2272651685],
    [0.00000000074, 2.91359929208, 302.7497309916],
    [0.00000000092, 5.11372489097, 912.7876784712],
    [0.00000000073, 5.42920211703, 539.2521926502],
    [0.00000000081, 5.25618688362, 311.6565672414],
    [0.00000000082, 0.77806577612, 591.9423906897],
    [0.00000000074, 0.16737907492, 1374.1292684431],
    [0.00000000077, 3.20203134483, 527.2432845398],
    [0.00000000081, 3.80903070318, 75.8935642601],
    [0.00000000097, 4.67281118685, 16.9835910971],
    [0.00000000077, 2.10541189728, 139.1718881765],
    [0.00000000091, 4.67274741065, 84.8640909847],
    [0.00000000098, 2.37249774428, 566.3395280241],
    [0.00000000082, 2.1607075811, 529.8028396792],
    [0.00000000072, 3.47566702228, 1086.0485744378],
    [0.00000000092, 0.21608932947, 1297.0600480154],
    [0.00000000093, 4.30059085579, 224.9354965329],
    [0.00000000086, 3.02917299294, 126.5085887603],
    [0.00000000079, 1.29816054687, 683.9894646444],
    [0.00000000095, 2.46862196214, 9917.1280973584],
    [0.00000000076, 2.48420575089, 37.7123445125],
    [0.00000000097, 0.68274913158, 207.3612046048],
    [0.00000000096, 4.16112194001, 1042.9196039539],
    [0.00000000071, 6.0413083451, 223.4510238246],
    [0.00000000076, 3.37676835926, 502.8642621516],
    [0.00000000084, 3.24912782551, 628.9634606347],
    [0.00000000073, 0.7311360743, 390.4921446677],
    [0.00000000071, 4.64209882547, 72.5463663336],
    [0.00000000073, 3.31815515601, 356.2700104336],
    [0.00000000072, 2.60766427215, 602.0248831071],
    [0.00000000074, 5.76600995478, 1424.5318446222],
    [0.00000000074, 4.22820017237, 1274.9686474876],
    [0.00000000074, 2.78217896807, 1522.2079928694],
    [0.00000000074, 4.38596183925, 1372.6447957348],
];

const VSOP87_L1: Vsop87Element = [
    [74.7815986091],
    [0.00154332863, 5.24158770553, 74.7815985673],
    [0.00024456474, 1.71260334156, 1.4844727083],
    [0.00009258442, 0.4282973235, 11.0457002639],
    [0.00008265977, 1.50218091379, 63.7358983034],
    [0.0000915016, 1.41213765216, 149.5631971346],
    [0.00003899108, 0.4648357916, 3.9321532631],
    [0.00002277065, 4.17199181523, 76.2660712756],
    [0.0000192747, 0.52976188479, 2.9689454166],
    [0.00001232725, 1.58632088145, 70.8494453042],
    [0.00000791201, 5.43640595978, 3.1813937377],
    [0.00000766954, 1.99425624214, 73.297125859],
    [0.00000481813, 2.98574070918, 85.8272988312],
    [0.00000449635, 4.14242946378, 138.5174968707],
    [0.00000565091, 3.87400932383, 224.3447957019],
    [0.000004266, 4.73158166033, 71.8126531507],
    [0.00000347745, 2.45368882357, 9.5612275556],
    [0.00000332699, 2.55525645638, 148.0787244263],
    [0.00000317054, 5.57858240166, 52.6901980395],
    [0.00000179897, 5.68365861477, 12.5301729722],
    [0.00000171119, 3.00040981195, 78.7137518304],
    [0.00000205579, 2.36242761009, 2.4476805548],
    [0.00000158038, 2.90930836614, 0.9632078465],
    [0.0000018909, 4.20258063269, 56.6223513026],
    [0.00000202696, 0.34360451816, 151.0476698429],
    [0.00000154762, 5.59005854748, 4.4534181249],
    [0.00000143472, 2.59047613814, 62.2514255951],
    [0.00000151459, 2.93993108236, 77.7505439839],
    [0.00000153561, 4.65220425575, 35.1640902212],
    [0.00000121462, 4.14937021194, 127.4717966068],
    [0.00000115538, 3.73245717203, 65.2203710117],
    [0.00000102213, 4.18917777961, 145.6310438715],
    [0.00000101894, 6.03382617339, 0.1118745846],
    [0.00000088409, 3.99004756152, 18.1592472647],
    [0.00000087591, 6.15639888455, 202.2533951741],
    [0.00000080591, 2.64095955809, 22.0914005278],
    [0.00000072047, 6.04586846354, 70.3281804424],
    [0.00000068727, 4.05075598128, 77.962992305],
    [0.00000059329, 3.70581611259, 67.6680515665],
    [0.00000047388, 3.54091852775, 351.8165923087],
    [0.00000042712, 5.72066604839, 5.4166259714],
    [0.00000044405, 5.91042456876, 7.1135470008],
    [0.00000035784, 3.29585017124, 8.0767548473],
    [0.00000035724, 3.32933903151, 71.6002048296],
    [0.00000036081, 5.89881403933, 33.6796175129],
    [0.00000041676, 4.94718694607, 222.8603229936],
    [0.00000031215, 5.48938304422, 160.6088973985],
    [0.00000031453, 5.62016551866, 984.6003316219],
    [0.00000035171, 5.07842850969, 38.1330356378],
    [0.00000035543, 0.0550243966, 299.1263942692],
    [0.0000003081, 5.49604033608, 59.8037450403],
    [0.00000028883, 4.51759500034, 84.3428261229],
    [0.00000026705, 5.53637447019, 131.4039498699],
    [0.00000029956, 1.66046193211, 447.7958195265],
    [0.00000029206, 1.14722620686, 462.0229135281],
    [0.00000025811, 4.99049651973, 137.0330241624],
    [0.00000025474, 5.73884476629, 380.12776796],
    [0.00000021683, 2.80603505468, 69.3649725959],
    [0.00000023016, 2.24983506758, 111.4301614968],
    [0.00000019228, 3.55594434001, 54.1746707478],
    [0.00000021696, 0.9887213968, 213.299095438],
    [0.00000019457, 1.86460184285, 108.4612160802],
    [0.0000001614, 3.10230818045, 14.977853527],
    [0.00000013138, 1.95065801902, 87.3117715395],
    [0.00000013904, 1.5420709382, 340.7708920448],
    [0.00000013543, 4.38430774439, 5.9378908332],
    [0.00000016493, 2.80104132725, 225.8292684102],
    [0.00000013111, 5.88308816286, 6.2197751235],
    [0.00000011811, 0.32606713574, 35.4247226521],
    [0.00000012471, 0.32808369953, 51.2057253312],
    [0.00000010981, 1.6929966677, 45.5766510387],
    [0.00000010888, 5.970420479, 265.9892934775],
    [0.00000011433, 3.37877229066, 72.3339180125],
    [0.00000012003, 3.60398124894, 269.9214467406],
    [0.00000012936, 5.38263455371, 152.5321425512],
    [0.00000011674, 1.74413259892, 79.2350166922],
    [0.00000010446, 4.16878885118, 24.3790223882],
    [0.00000010634, 3.06878261442, 284.1485407422],
    [0.00000009674, 5.51339189448, 153.4953503977],
    [0.0000000959, 0.49485192598, 209.3669421749],
    [0.00000009269, 3.5458995448, 41.6444977756],
    [0.00000009568, 5.59970406046, 82.8583534146],
    [0.0000000931, 4.49468477512, 20.6069278195],
    [0.00000009632, 1.00932793597, 68.8437077341],
    [0.00000008745, 3.91021963381, 60.7669528868],
    [0.00000010176, 3.51758777802, 529.6909650946],
    [0.00000010048, 4.64919764888, 77.2292791221],
    [0.00000008679, 1.96792212254, 195.1398481733],
    [0.00000008387, 4.41835912213, 134.5853436076],
    [0.00000007983, 5.35924979986, 75.7448064138],
    [0.00000009263, 3.95182354442, 39.6175083461],
    [0.00000007594, 5.77307721631, 73.8183907208],
    [0.00000007713, 4.44174669087, 14.0146456805],
    [0.0000000749, 2.17900285342, 145.1097790097],
    [0.00000007873, 5.74835382023, 184.7272873558],
    [0.00000007688, 2.41795807218, 146.594251718],
    [0.00000006438, 0.84540553248, 32.1951448046],
    [0.00000006256, 2.17063033953, 74.8934731519],
    [0.00000007937, 0.1717266497, 120.358249606],
    [0.0000000702, 4.12096862702, 191.2076949102],
    [0.00000006862, 2.13341287037, 116.4260963429],
    [0.00000005208, 3.11117214481, 106.9767433719],
    [0.00000004811, 2.25140758551, 46.2097904851],
    [0.00000004566, 3.45427623308, 0.7507595254],
    [0.00000004473, 3.94632863732, 6.592282139],
    [0.00000005202, 1.15450734319, 112.9146342051],
    [0.00000004323, 5.15540388592, 144.1465711632],
    [0.00000004746, 5.18244413774, 81.0013736908],
    [0.00000004232, 0.2192191002, 92.940845832],
    [0.00000004323, 2.52442111234, 99.1606209555],
    [0.00000003879, 2.78711315762, 565.1156877467],
    [0.00000004332, 5.91118459987, 221.3758502853],
    [0.00000003801, 0.75135339336, 58.1068240109],
    [0.00000003812, 3.23225846555, 479.2883889155],
    [0.00000003656, 5.27986185627, 66.9172920411],
    [0.00000003811, 4.92593102646, 125.9873238985],
    [0.00000004172, 2.28697665136, 109.9456887885],
    [0.00000003472, 2.95403921517, 74.6697239827],
    [0.00000003501, 4.89811329155, 28.3111756513],
    [0.00000004495, 4.1545333789, 344.7030453079],
    [0.00000004258, 2.68419933901, 7.8643065262],
    [0.00000003456, 0.02638325764, 140.001969579],
    [0.00000004181, 1.90641663083, 277.0349937414],
    [0.00000003644, 5.32238666094, 408.4389436113],
    [0.00000003205, 0.05087987138, 220.4126424388],
    [0.0000000319, 1.48430670387, 128.9562693151],
    [0.00000003901, 6.25926496244, 0.8937718773],
    [0.00000003788, 0.03327505225, 152.7445908723],
    [0.000000032, 0.52009458683, 2.2876218604],
    [0.00000003011, 1.93475294714, 80.1982245387],
    [0.00000004054, 5.23320423468, 96.8729990951],
    [0.00000003798, 4.97868021019, 36.6485629295],
    [0.00000003895, 1.10480659598, 297.6419215609],
    [0.00000003295, 4.80719384894, 422.6660376129],
    [0.00000003192, 2.81905779664, 453.424893819],
    [0.00000002804, 6.19069392998, 135.5485514541],
    [0.00000003469, 5.88266049174, 16.6747745564],
    [0.00000002785, 1.35852942533, 404.5067903482],
    [0.00000002892, 0.53676605577, 159.1244246902],
    [0.00000003232, 1.54622440929, 23.5758732361],
    [0.00000002958, 6.25751544465, 456.3938392356],
    [0.00000002542, 1.85372598824, 490.3340891794],
    [0.00000002547, 5.19766530615, 173.9422195228],
    [0.00000003118, 6.10201148242, 142.4496501338],
    [0.00000002762, 3.51066557656, 288.0806940053],
    [0.00000002793, 3.90482859776, 358.9301393095],
    [0.00000002958, 5.31404018803, 55.1378785943],
    [0.00000002387, 1.31646029756, 211.8146227297],
    [0.00000002413, 4.38647851761, 60.5545045657],
    [0.00000002285, 2.31869038469, 31.492569389],
    [0.00000002366, 2.21968144549, 66.70484372],
    [0.00000002779, 4.72642945119, 186.2117600641],
    [0.0000000227, 3.49350071105, 206.1855484372],
    [0.00000002224, 0.41045917285, 81.3738807063],
    [0.00000002196, 0.76298510234, 17.5261078183],
    [0.00000002115, 3.58641580944, 333.657345044],
    [0.00000002575, 0.73175693995, 200.7689224658],
    [0.00000002158, 2.61976125405, 13.3333221243],
    [0.00000002041, 6.27470432139, 98.8999885246],
    [0.00000002212, 2.36295359318, 347.8844390456],
    [0.00000002183, 2.4900467683, 76.4785195967],
    [0.00000002032, 1.6748491158, 235.3904959658],
    [0.00000002226, 5.9732773815, 1514.2912967165],
    [0.00000001858, 2.20139550864, 203.7378678824],
    [0.00000002127, 2.52590780597, 373.9079928365],
    [0.00000001865, 4.9820720428, 5.1078094307],
    [0.00000001822, 2.44474441003, 55.6591434561],
    [0.00000002037, 5.80360322726, 146.3818033969],
    [0.00000001894, 4.32787921047, 49.5088043018],
    [0.00000001841, 3.35082910127, 143.6253063014],
    [0.00000001717, 3.95035994581, 24.1183899573],
    [0.00000001684, 1.28092098597, 103.0927742186],
    [0.00000002042, 5.48498644784, 373.0142209592],
    [0.0000000172, 2.35857527806, 1.6445314027],
    [0.00000001637, 2.99504798037, 391.1734682239],
    [0.00000001605, 0.97423033751, 977.4867846211],
    [0.00000001678, 4.97988460684, 387.2413149608],
    [0.0000000152, 3.15010457259, 7.4223635415],
    [0.00000001505, 2.89631333643, 19.643719973],
    [0.00000001574, 1.61508712335, 991.7138786227],
    [0.00000001509, 3.32685682695, 909.8187330546],
    [0.00000001674, 4.30506338212, 305.3461693927],
    [0.00000001412, 4.53556726512, 81.8951455681],
    [0.00000001375, 2.49046817916, 426.598190876],
    [0.00000001373, 5.7533763715, 19.1224551112],
    [0.0000000134, 3.94224997586, 61.2882177486],
    [0.00000001367, 4.39913585014, 27.0873353739],
    [0.00000001385, 2.20171302118, 67.3592350258],
    [0.00000001351, 4.36029315547, 70.1157321213],
    [0.00000001304, 2.79975533399, 25.6028626656],
    [0.00000001313, 3.73575380324, 628.8515860501],
    [0.00000001338, 4.92441744235, 617.8058857862],
    [0.00000001361, 0.72643457214, 546.956440482],
    [0.00000001273, 3.20493914871, 92.0470739547],
    [0.00000001228, 5.92585113207, 415.5524906121],
    [0.00000001242, 4.09549754457, 443.8636662634],
    [0.00000001552, 5.05296247763, 10.2949407385],
    [0.0000000121, 4.83276785889, 100.3844612329],
    [0.00000001236, 4.30781434404, 67.8804998876],
    [0.00000001173, 5.32389543861, 17.2654753874],
    [0.00000001352, 3.55425818464, 230.5645708254],
    [0.00000001437, 6.1841765396, 14.2270940016],
    [0.00000001248, 0.16711396982, 29.2049475286],
    [0.00000001169, 3.31424750673, 44.7253177768],
    [0.00000001259, 1.88793196065, 0.6543913058],
    [0.00000001311, 5.72020892609, 329.7251917809],
    [0.00000001155, 2.04134400388, 30.7106720963],
    [0.00000001101, 1.5235036511, 157.6399519819],
    [0.0000000107, 2.89562175028, 543.0242872189],
    [0.00000001121, 4.49662162318, 162.0933701068],
    [0.00000001417, 2.04676765553, 181.7583419392],
    [0.00000001258, 0.23621358146, 561.1835344836],
    [0.00000001255, 1.26185998194, 155.7829722581],
    [0.0000000104, 2.92622745204, 241.6102710893],
    [0.00000001057, 3.26987298875, 28.5718080822],
    [0.00000001122, 1.06425470357, 88.1149206916],
    [0.00000001174, 5.28477501625, 300.6108669775],
    [0.00000001229, 3.103550368, 454.9093665273],
    [0.00000001065, 0.29391740657, 58.319272332],
    [0.0000000096, 5.20482964431, 42.5382696529],
    [0.00000001015, 4.37032150952, 13.4933808187],
    [0.00000000982, 4.89018485859, 465.9550667912],
    [0.00000000889, 3.09788627376, 110.2063212194],
    [0.00000001102, 1.70896942951, 43.1289704839],
    [0.00000000867, 4.22078052532, 20.4468691251],
    [0.00000000897, 0.17179849041, 604.4725636619],
    [0.00000000937, 0.09295857555, 273.1028404783],
    [0.00000000829, 5.25281847981, 472.1748419147],
    [0.00000000864, 4.75896276795, 33.1371007917],
    [0.00000000877, 4.34963188052, 105.4922706636],
    [0.00000000882, 0.53648210499, 80.7194894005],
    [0.00000000966, 2.82647414963, 41.1019810544],
    [0.00000000805, 3.53324257123, 39.3568759152],
    [0.00000001087, 2.79964970506, 48.7580447764],
    [0.00000000861, 4.69150625691, 1059.3819301892],
    [0.00000000846, 1.65248920316, 554.0699874828],
    [0.00000000891, 2.85006063739, 32.2433289144],
    [0.00000000938, 1.90783329336, 259.5088859231],
    [0.00000000876, 0.83921717739, 4.7353024152],
    [0.00000000964, 1.56609888164, 227.3137411185],
    [0.00000000707, 6.16918394997, 3.6233367224],
    [0.00000000689, 0.64981694232, 88.7962442478],
    [0.0000000083, 0.39292254125, 378.6432952517],
    [0.00000000708, 5.49627918383, 558.0021407459],
    [0.00000000787, 1.95609328363, 16.4623262353],
    [0.00000000901, 1.83265668559, 258.8757464767],
    [0.00000000786, 2.26160622294, 16.04163511],
    [0.0000000064, 4.15920545966, 141.6988906084],
    [0.00000000672, 1.00050394612, 522.5774180938],
    [0.00000000625, 5.82930714013, 89.7594520943],
    [0.00000000619, 4.31040053451, 455.8725743738],
    [0.00000000619, 4.77556598161, 453.9461586808],
    [0.00000000666, 2.80724719033, 68.5618234438],
    [0.00000000754, 4.22436113545, 486.4019359163],
    [0.00000000665, 0.76096162867, 120.9913890524],
    [0.00000000636, 5.75172788892, 119.5069163441],
    [0.00000000595, 3.92147529886, 25.2727942655],
    [0.00000000629, 1.79018286231, 440.6822725257],
    [0.00000000719, 4.27356498725, 50.4025761791],
    [0.00000000598, 0.22963306541, 117.9105690512],
    [0.00000000706, 0.45734010595, 536.8045120954],
    [0.00000000691, 6.14152846301, 258.0244132148],
    [0.00000000588, 5.49070240544, 767.3690829208],
    [0.0000000058, 0.63199844828, 95.3885263868],
    [0.00000000739, 1.12968525578, 129.9194771616],
    [0.00000000625, 0.60601623675, 152.0108776894],
    [0.00000000684, 3.48227286692, 835.0371344873],
    [0.00000000657, 0.08702780614, 114.3991069134],
    [0.00000000611, 4.15939229748, 154.0166152595],
    [0.00000000592, 1.93836345843, 106.2741679563],
    [0.00000000528, 5.94363613171, 518.6452648307],
    [0.00000000508, 1.4393186126, 218.9281697305],
    [0.00000000505, 4.39807654944, 121.8427223143],
    [0.00000000526, 0.30539221936, 756.3233826569],
    [0.00000000492, 0.02248323091, 106.0135355254],
    [0.00000000483, 0.69881109315, 264.5048207692],
    [0.00000000483, 3.75988497269, 342.2553647531],
    [0.00000000631, 2.23161489343, 218.4069048687],
    [0.00000000587, 0.18557468628, 458.090760265],
    [0.00000000582, 6.01383333156, 47.061123747],
    [0.00000000566, 1.9438866407, 699.7010313543],
    [0.00000000469, 2.00109396664, 275.5505210331],
    [0.00000000469, 0.07681059856, 216.4804891757],
    [0.00000000465, 4.97885409598, 458.8415197904],
    [0.0000000045, 2.93431036585, 692.5874843535],
    [0.00000000546, 2.42033648569, 339.2864193365],
    [0.00000000543, 2.61197344648, 451.7279727896],
    [0.00000000433, 2.83073694779, 32.7164096664],
    [0.00000000497, 4.22419242251, 166.828672522],
    [0.00000000436, 2.61151229793, 685.4739373527],
    [0.00000000501, 0.18281416681, 331.3215390738],
    [0.00000000447, 4.51662766639, 142.1408335931],
    [0.00000000419, 1.92148690569, 148.5999892881],
    [0.00000000466, 0.96357284606, 760.25553592],
    [0.00000000554, 5.40626840965, 278.5194664497],
    [0.0000000041, 4.63543184365, 40.1600250673],
    [0.00000000445, 1.00949029615, 468.2426886516],
    [0.00000000415, 5.68097308082, 92.3077063856],
    [0.00000000397, 3.98144952901, 31.2319369581],
    [0.00000000421, 5.47567810199, 104.0077979553],
    [0.00000000403, 5.19002062014, 22.633917249],
    [0.00000000428, 3.48886570846, 180.2738692309],
    [0.00000000412, 1.02398688739, 469.1364605289],
    [0.00000000385, 3.7901438429, 450.9772132642],
    [0.00000000424, 2.40007672624, 39.0962434843],
    [0.00000000469, 2.07500437056, 296.1574488526],
    [0.00000000367, 5.39331524988, 874.3940104025],
    [0.00000000439, 5.75684595296, 183.2428146475],
    [0.0000000044, 0.36377653224, 367.9701020033],
    [0.00000000409, 4.21847176009, 181.0557665236],
    [0.00000000367, 0.97754899263, 113.8778420516],
    [0.00000000427, 3.32207591906, 114.9416236346],
    [0.00000000361, 2.87413243525, 384.0599212231],
    [0.00000000388, 5.441319019, 26.0235537909],
    [0.00000000361, 0.18436557007, 184.0941479094],
    [0.00000000397, 4.78908291565, 268.4369740323],
    [0.00000000375, 5.66345783317, 353.301065017],
    [0.0000000042, 3.84692082861, 254.9435932136],
    [0.00000000356, 2.4675080892, 210.3301500214],
    [0.00000000352, 0.124985429, 142.6620984549],
    [0.00000000367, 2.92343694465, 291.262087743],
    [0.00000000395, 4.76556910944, 109.3125493421],
    [0.00000000349, 0.36426017087, 46.470422916],
    [0.00000000358, 2.75549207793, 295.1942410061],
    [0.00000000412, 2.43295972201, 483.2205421786],
    [0.00000000352, 1.24968669034, 97.4155158163],
    [0.00000000442, 1.88628680612, 123.5396433437],
    [0.00000000385, 3.26394747049, 79.4474650133],
    [0.00000000406, 2.53016887679, 255.0554677982],
    [0.0000000037, 4.14864372053, 282.6640680339],
    [0.00000000347, 1.94674357151, 173.6815870919],
    [0.0000000034, 1.34666529473, 34.2008823747],
    [0.00000000372, 1.86781055268, 207.8824694666],
    [0.00000000353, 2.64173549643, 162.8965192589],
    [0.0000000037, 1.88031244406, 192.6921676185],
    [0.00000000358, 4.58259834086, 149.6750717192],
    [0.00000000369, 2.15183429984, 555.5544601911],
    [0.00000000329, 0.89991825345, 905.8865797915],
    [0.00000000322, 3.40065562385, 309.2783226558],
    [0.00000000361, 2.19153615911, 562.6680071919],
    [0.00000000335, 5.03174519184, 189.7232222019],
    [0.0000000033, 4.23716253952, 75.3028634291],
    [0.00000000366, 1.74722181798, 545.4719677737],
    [0.00000000309, 4.56448107045, 350.3321196004],
    [0.00000000317, 0.98960192882, 335.1418177523],
    [0.00000000359, 5.76812959678, 916.9322800554],
    [0.00000000295, 1.33754315792, 150.5264049811],
    [0.00000000329, 1.82999432252, 706.8145783551],
    [0.00000000305, 2.85945986335, 267.4737661858],
    [0.00000000384, 4.2560215439, 198.321241911],
    [0.00000000296, 1.71949913712, 394.3548619616],
    [0.00000000285, 0.69559923528, 312.4597163935],
    [0.00000000311, 1.47691197071, 375.3924655448],
    [0.000000003, 5.09637659621, 376.1956146969],
    [0.00000000359, 2.54874884785, 9988.9407505091],
    [0.00000000283, 3.06617758884, 193.655375465],
    [0.000000003, 5.92918355218, 124.2904028691],
    [0.0000000029, 4.90172200702, 681.5417840896],
    [0.00000000276, 4.65186244616, 332.1728723357],
    [0.00000000285, 4.83606028553, 68.1893164283],
    [0.0000000031, 3.75000484412, 253.5709950899],
    [0.00000000294, 0.92142971378, 610.6923387854],
    [0.00000000304, 5.60868779754, 271.4059194489],
    [0.000000003, 2.69560181941, 548.4409131903],
    [0.00000000266, 1.57547215891, 369.0820676961],
    [0.0000000027, 2.12904548682, 778.4147831847],
    [0.00000000278, 3.38349188253, 346.3999663373],
    [0.00000000288, 2.78232740152, 1812.5239191084],
    [0.00000000274, 4.87674891727, 831.1049812242],
    [0.00000000306, 5.1589262602, 285.6330134505],
    [0.0000000026, 0.96985733128, 90.8232336773],
    [0.00000000289, 3.99815838405, 451.9404211107],
    [0.00000000341, 3.64288743408, 187.6962327724],
    [0.00000000262, 5.24129067312, 94.4253185403],
    [0.00000000255, 5.62384661312, 691.1030116452],
    [0.00000000278, 2.76955704952, 657.1627617014],
    [0.00000000314, 1.67255558365, 25.8634950965],
    [0.00000000252, 1.20515376123, 134.0640787458],
    [0.0000000027, 5.95275530301, 362.8622925726],
    [0.0000000025, 1.95456834458, 497.4476361802],
    [0.00000000331, 2.03342131435, 445.3481389717],
    [0.00000000255, 1.8286784763, 180.1619946463],
    [0.0000000028, 1.1541422757, 986.0848043302],
    [0.00000000247, 5.99403279584, 147.1155165798],
    [0.00000000291, 2.41284857072, 381.6122406683],
    [0.00000000251, 5.78452299837, 630.3360587584],
    [0.00000000297, 1.5777424273, 49.7212526229],
    [0.00000000244, 4.93404985518, 107.4980082337],
    [0.00000000249, 5.56442927723, 133.1008708993],
    [0.0000000024, 2.84851616507, 44.0921783304],
    [0.00000000248, 1.97763922353, 593.426863398],
    [0.00000000233, 0.16241159105, 124.5028511902],
    [0.00000000238, 4.32756553343, 823.9914342234],
    [0.00000000249, 2.86247259468, 226.7924762567],
    [0.00000000261, 2.27307279052, 73.0846775379],
    [0.00000000233, 2.20084586652, 894.8408795276],
    [0.00000000229, 6.25761030439, 122.4758617607],
    [0.00000000244, 5.76540363539, 135.336103133],
    [0.00000000306, 1.55862796103, 3191.0492295652],
    [0.00000000288, 5.81344092057, 902.7051860538],
    [0.00000000302, 5.76656213355, 219.891377577],
    [0.00000000247, 4.80414025079, 204.7010757289],
    [0.00000000264, 0.01674333019, 294.6729761443],
    [0.00000000245, 5.89659082767, 507.5995645668],
    [0.00000000253, 0.68155783879, 43.2890291783],
    [0.00000000259, 0.32203683101, 105.380396079],
    [0.0000000024, 1.26452469031, 559.6990617753],
    [0.00000000237, 2.9026340439, 156.1554792736],
    [0.00000000299, 3.55325980025, 397.3932433474],
    [0.00000000244, 1.77778279869, 411.620337349],
    [0.00000000211, 0.44507165688, 597.3590166611],
    [0.00000000209, 6.2774334636, 470.6903692064],
    [0.00000000226, 2.98952389106, 25.1297819136],
    [0.00000000293, 4.38922897212, 334.2904844904],
    [0.00000000278, 3.98468567421, 477.8039162072],
    [0.00000000206, 1.00879014806, 175.1660598002],
    [0.00000000246, 2.70487794377, 227.5261894396],
    [0.00000000237, 2.74955785783, 446.3113468182],
    [0.00000000242, 1.94330310979, 228.276948965],
    [0.0000000022, 2.21089026533, 460.5384408198],
    [0.00000000247, 3.57103210654, 372.4235201282],
    [0.00000000279, 1.3658752909, 118.8737768977],
    [0.00000000218, 3.73553622758, 449.2802922348],
    [0.00000000216, 4.40353401308, 10063.7223490764],
    [0.0000000023, 4.66927758266, 535.3200393871],
    [0.00000000197, 2.20805345461, 473.068613792],
    [0.00000000229, 3.19497593427, 463.5073862364],
    [0.00000000201, 5.34615119244, 480.7728616238],
    [0.00000000193, 6.19624242617, 820.0592809603],
    [0.00000000242, 1.96036147638, 988.532484885],
    [0.0000000019, 3.13243705705, 136.0698163159],
    [0.00000000193, 4.07671504865, 143.9341228421],
    [0.00000000202, 1.83078684759, 72.4939767069],
    [0.00000000228, 3.34903021483, 95.9792272178],
    [0.00000000208, 4.8113324768, 377.1588225434],
    [0.000000002, 0.61839132774, 236.8749686741],
    [0.00000000235, 3.6743683926, 838.218528225],
    [0.00000000193, 2.15481780749, 74.9416572617],
    [0.00000000187, 2.81310936004, 572.2292347475],
    [0.00000000213, 1.61813973088, 42.5864537627],
    [0.00000000207, 6.03862516281, 524.0618908021],
    [0.00000000203, 5.04988207039, 457.8783119439],
    [0.00000000203, 1.0475888918, 409.9234163196],
    [0.00000000188, 2.07982369812, 976.0023119128],
    [0.0000000021, 5.85785362661, 196.6243208816],
    [0.00000000192, 3.61383045656, 993.198351331],
    [0.00000000209, 3.17349988395, 1587.5884225755],
    [0.00000000184, 1.85051728434, 908.3342603463],
    [0.00000000192, 5.22508686633, 450.4559484024],
    [0.0000000018, 5.28618792228, 21.1976286505],
    [0.00000000213, 5.58315163677, 538.2889848037],
    [0.00000000176, 5.03044627538, 170.7608257851],
    [0.00000000203, 5.80938645616, 624.919432787],
    [0.0000000018, 2.51990272877, 1044.4040766622],
    [0.00000000179, 6.05515483358, 525.7588118315],
    [0.00000000175, 1.96452622716, 520.129737539],
    [0.00000000199, 0.52713547564, 457.3570470821],
    [0.00000000185, 2.84806428136, 1293.8786542777],
    [0.00000000175, 1.54398883192, 15.1903018481],
    [0.00000000174, 4.6639424451, 9947.0556815321],
    [0.00000000185, 5.46594207951, 981.6313862053],
    [0.00000000171, 5.673899584, 114.1384744825],
    [0.00000000182, 1.04937888593, 532.6599105112],
    [0.00000000178, 0.51114232798, 172.1971143836],
    [0.00000000169, 3.11804373794, 978.9712573294],
    [0.00000000176, 3.74915826552, 920.8644333185],
    [0.0000000018, 1.07197408549, 586.3133163972],
    [0.00000000166, 1.9368297112, 449.4927405559],
    [0.00000000169, 0.5930651065, 983.1158589136],
    [0.00000000178, 3.92600130864, 621.7380390493],
    [0.00000000174, 4.32154318588, 280.9671470045],
    [0.00000000191, 0.54024876337, 424.1505103212],
    [0.00000000189, 0.10678158871, 406.954470903],
    [0.00000000205, 0.52365243803, 653.9813679637],
    [0.00000000168, 3.54301022192, 414.0680179038],
    [0.00000000164, 1.87404692874, 171.6545976624],
    [0.00000000185, 5.12729146826, 521.0929453855],
    [0.00000000172, 0.39423495673, 328.2407190726],
    [0.00000000172, 0.34793158963, 2349.3284312038],
    [0.0000000018, 0.37372289781, 661.0949149645],
    [0.0000000017, 5.79397661496, 421.1815649046],
    [0.00000000159, 2.25636452893, 539.2521926502],
    [0.00000000193, 1.65109454411, 91.4563731237],
    [0.00000000166, 2.23770488518, 80.9319377216],
    [0.00000000183, 3.00393831502, 286.596221297],
    [0.00000000166, 0.92209664824, 444.8268741099],
    [0.0000000017, 0.39414968415, 417.0369633204],
    [0.00000000162, 3.23150668653, 177.8743727859],
    [0.00000000181, 4.00504030975, 388.7257876691],
    [0.00000000153, 2.20468918814, 749.2098356561],
    [0.00000000163, 3.73110852012, 216.9224321604],
    [0.00000000212, 4.72231132508, 833.552661779],
    [0.00000000198, 6.18808818431, 346.1875180162],
    [0.00000000177, 2.13790488243, 66.1835788582],
    [0.00000000189, 0.61299968484, 8.5980197091],
    [0.00000000213, 4.78511947496, 1190.0351205337],
    [0.00000000164, 4.63818971012, 178.7893965226],
    [0.0000000018, 1.93178230246, 248.7238180901],
    [0.00000000158, 6.1394207787, 782.3469364478],
    [0.00000000206, 0.89126217502, 260.9933586314],
    [0.00000000176, 3.10085327825, 233.9060232575],
    [0.00000000149, 3.08021590217, 386.3475430835],
    [0.0000000015, 5.07107463854, 293.188503436],
    [0.0000000018, 6.18875446783, 526.722019678],
    [0.00000000164, 4.49121433201, 374.4986936675],
    [0.00000000189, 1.11458377928, 6058.7310542895],
    [0.00000000147, 3.01754055024, 670.4960838257],
    [0.00000000168, 3.76331368122, 74.2603337055],
    [0.00000000144, 2.31996539469, 294.3004691288],
    [0.00000000167, 5.42159494206, 22.8945496799],
    [0.00000000144, 5.81822380109, 75.5323580927],
    [0.00000000157, 0.40945769911, 88.274979386],
    [0.00000000175, 4.5376133901, 184.9879197867],
    [0.00000000153, 0.48543215446, 144.8973306886],
    [0.0000000016, 2.60794839561, 1055.4497769261],
    [0.00000000179, 4.37562818485, 764.1876891831],
    [0.00000000143, 1.99453048271, 354.9979860464],
    [0.00000000146, 5.69235209707, 600.5404103988],
    [0.00000000177, 3.90369220329, 1396.2206689709],
    [0.00000000193, 2.53328556634, 189.1807054807],
    [0.00000000155, 4.70126542016, 306.830642101],
    [0.00000000154, 4.62870568847, 154.979823106],
    [0.00000000164, 6.02390945956, 383.0967133766],
    [0.00000000187, 4.84188822839, 432.8179659995],
    [0.00000000185, 3.23152718658, 683.9894646444],
    [0.00000000152, 3.68645778017, 1439.5096981492],
    [0.00000000135, 0.15727475865, 115.3623147599],
    [0.00000000183, 3.27617419135, 331.2096644892],
    [0.00000000143, 5.46480801118, 74.0308390419],
    [0.00000000144, 4.20445488125, 237.6781178262],
    [0.00000000133, 4.32149882064, 515.463871093],
    [0.00000000167, 4.08839285774, 74.5209661364],
    [0.00000000136, 1.71455645866, 93.9040536785],
    [0.00000000135, 3.91190350483, 232.4215505492],
    [0.00000000162, 1.97790343838, 221.1634019642],
    [0.00000000132, 2.82624616573, 385.7568422525],
    [0.0000000016, 1.35947259957, 514.5643537213],
    [0.00000000126, 3.80235468146, 491.8185618877],
    [0.00000000141, 2.57765836949, 217.2312487011],
    [0.00000000124, 0.99583430014, 541.5398145106],
    [0.00000000167, 3.31937662997, 6133.5126528568],
    [0.00000000141, 2.6341144147, 323.5054166574],
    [0.00000000128, 5.08522615028, 448.6895914038],
    [0.00000000157, 5.87846003299, 149.45132255],
    [0.00000000163, 6.15363541244, 3340.6124266998],
    [0.00000000145, 0.39378158577, 357.4456666012],
    [0.0000000013, 0.87687909058, 234.4967240885],
    [0.00000000132, 4.39790926475, 686.958410061],
    [0.00000000118, 2.97103357711, 163.5778428151],
    [0.00000000149, 3.44120121334, 371.5297482509],
    [0.00000000128, 2.90544144809, 537.3952129264],
    [0.00000000118, 4.93654738085, 771.3012361839],
    [0.00000000138, 1.60526889301, 229.0800981171],
    [0.0000000014, 0.19423734509, 103.3534066495],
    [0.00000000138, 0.41128239547, 175.4266922311],
    [0.00000000155, 3.98039100074, 302.0953396858],
    [0.00000000127, 2.98955690598, 328.3525936572],
    [0.00000000114, 2.38099208126, 10213.285546211],
    [0.00000000127, 2.38558048946, 842.1506814881],
    [0.00000000131, 3.01936629873, 635.9651330509],
    [0.00000000138, 0.44662144244, 838.9692877504],
    [0.00000000129, 4.25513451348, 310.1720945331],
    [0.00000000148, 0.41799256546, 594.9113361063],
    [0.00000000149, 4.10330124264, 98.3574718034],
    [0.00000000109, 2.88811868696, 42.0651889009],
    [0.00000000109, 3.78134972711, 40.5807161926],
    [0.00000000108, 2.55916728156, 199.2844497575],
    [0.00000000125, 0.48048283452, 404.6186649328],
    [0.00000000135, 2.87189439592, 167.7224443993],
    [0.00000000118, 3.07682081692, 327.4375699205],
    [0.00000000119, 5.78903264789, 260.360219185],
    [0.00000000111, 3.22737687538, 15.4991183888],
    [0.00000000109, 6.27549146354, 73.1370671646],
    [0.00000000109, 4.70945671248, 76.42612997],
    [0.00000000126, 2.80187501225, 639.897286314],
    [0.00000000105, 1.48616898015, 405.9912630565],
    [0.00000000116, 4.85863853667, 1515.7757694248],
    [0.00000000114, 2.76818793591, 291.7040307277],
    [0.00000000107, 1.11766952208, 271.61836777],
    [0.00000000111, 2.87343319463, 410.1358646407],
    [0.00000000111, 0.27810454195, 255.8373650909],
    [0.00000000118, 5.07878372226, 679.2541622292],
    [0.00000000099, 1.51676782588, 194.2885149114],
    [0.00000000099, 1.03758417112, 703.6331846174],
    [0.0000000013, 1.66666180289, 403.0223176399],
    [0.00000000123, 6.11422629384, 365.0011565867],
    [0.00000000104, 5.23997703346, 141.4864422873],
    [0.00000000115, 6.23621039514, 214.7835681463],
    [0.00000000096, 0.43424417561, 35.685355083],
    [0.00000000103, 1.06002930749, 76.3779458602],
    [0.00000000104, 2.65595803065, 742.9900605326],
    [0.00000000115, 5.22994397833, 511.5317178299],
    [0.00000000094, 2.74704482453, 80.4106728598],
    [0.00000000128, 0.77030466848, 806.725958836],
    [0.0000000011, 5.29132647687, 274.5873131866],
    [0.00000000114, 2.57034943327, 69.1525242748],
    [0.00000000095, 2.6283493608, 217.4436970222],
    [0.00000000113, 0.31878741567, 228.7982138268],
    [0.00000000094, 1.09024515607, 779.899255893],
    [0.00000000104, 1.63565182098, 1438.0252254409],
    [0.00000000123, 0.31994708206, 205.2223405907],
    [0.00000000089, 3.89481868438, 273.8536000037],
    [0.00000000111, 5.23314925278, 115.8835796217],
    [0.0000000009, 0.08059052014, 543.9180590962],
    [0.00000000103, 1.50283068334, 316.3918696566],
    [0.00000000114, 4.07327336627, 303.8616966844],
    [0.00000000121, 2.40722327908, 89.0086925689],
    [0.00000000085, 2.88976414563, 481.7360694703],
    [0.00000000102, 3.36728076478, 731.9443602687],
    [0.00000000095, 4.08252009963, 223.4510238246],
    [0.00000000103, 1.17394061445, 30.5987975117],
    [0.00000000082, 2.2522100728, 180.7951340927],
    [0.00000000088, 3.62556128338, 73.1852512744],
    [0.00000000106, 5.05420123147, 82.6459050935],
    [0.0000000008, 6.02853833502, 343.2185725996],
    [0.00000000086, 5.34618023172, 107.0249274817],
    [0.00000000096, 1.56226891458, 768.8535556291],
    [0.0000000009, 5.07169537551, 534.4262675098],
    [0.00000000098, 4.9225249206, 582.3811631341],
    [0.00000000101, 0.84796065157, 602.9880909536],
    [0.00000000083, 1.65460715725, 753.1419889192],
    [0.00000000078, 5.51638181769, 74.7334144575],
    [0.00000000093, 5.84400145456, 774.4826299216],
    [0.00000000089, 0.95563866426, 6.9010986797],
    [0.00000000087, 4.41987284863, 552.5855147745],
    [0.00000000103, 4.60346642754, 370.9390474199],
    [0.00000000077, 4.7740441983, 242.5040429666],
    [0.00000000075, 3.39192079177, 118.0224436358],
    [0.00000000076, 1.05747326519, 79.889407998],
    [0.00000000079, 3.54181953824, 758.7710632117],
    [0.00000000074, 3.98963783883, 301.4140161296],
    [0.00000000078, 1.82705732908, 74.8297826771],
    [0.00000000074, 1.08013205637, 107.918699359],
    [0.00000000074, 5.37621944193, 473.659314623],
    [0.00000000078, 2.52470639403, 103.9865460959],
    [0.00000000073, 1.33099035143, 117.3198682202],
    [0.00000000073, 3.86314726423, 47.6942631934],
    [0.00000000079, 3.79190807969, 243.9885156749],
    [0.00000000079, 1.85527149881, 495.9631634719],
    [0.00000000083, 4.63377403454, 147.8662761052],
    [0.00000000075, 3.25894652055, 195.7729876197],
    [0.00000000083, 2.51263535489, 73.88782669],
    [0.00000000076, 0.65318077927, 6283.0758499914],
    [0.00000000074, 2.98225723938, 77.0692204277],
    [0.00000000095, 1.54407527959, 210.8514148832],
    [0.00000000072, 5.49406740322, 74.6215398729],
    [0.00000000083, 3.32264980311, 1366.2125722902],
    [0.00000000074, 3.656968537, 69.6737891366],
    [0.00000000074, 3.23127044816, 208.8456773131],
    [0.0000000008, 4.36056904242, 1662.9607219738],
    [0.00000000073, 5.2653129037, 130.4407420234],
    [0.00000000071, 4.81609825971, 321.1271720718],
    [0.00000000076, 2.5184813688, 84.9335269539],
    [0.00000000097, 2.40670778188, 75.6753704446],
    [0.00000000078, 5.68434801179, 221.8971151471],
];

const VSOP87_L2: Vsop87Element = [
    [0.00002349469, 2.26708640433, 74.7815985673],
    [0.00000848806, Math.PI],
    [0.00000768983, 4.52562378749, 11.0457002639],
    [0.00000551555, 3.2581932204, 63.7358983034],
    [0.00000541559, 2.27572631399, 3.9321532631],
    [0.00000529491, 4.92336172394, 1.4844727083],
    [0.00000257527, 3.69060540044, 3.1813937377],
    [0.00000182036, 6.21866555925, 70.8494453042],
    [0.00000184429, 5.05954505833, 149.5631971346],
    [0.00000049505, 6.03085160423, 56.6223513026],
    [0.00000053456, 1.45801353517, 76.2660712756],
    [0.00000038334, 1.78433163102, 52.6901980395],
    [0.00000044885, 3.90644983662, 2.4476805548],
    [0.00000044623, 0.81232539761, 85.8272988312],
    [0.00000037373, 4.46132739805, 2.9689454166],
    [0.00000033044, 0.86461989031, 9.5612275556],
    [0.00000024305, 2.10670976428, 18.1592472647],
    [0.0000002925, 5.09724793503, 73.297125859],
    [0.00000022309, 4.81978108793, 78.7137518304],
    [0.00000022283, 5.99230347559, 138.5174968707],
    [0.0000001723, 2.53731197138, 145.6310438715],
    [0.00000021416, 2.39692592406, 77.962992305],
    [0.00000015114, 1.43013979998, 224.3447957019],
    [0.00000016756, 3.46508324378, 12.5301729722],
    [0.00000012003, 0.01666017885, 22.0914005278],
    [0.00000010497, 4.47250656935, 62.2514255951],
    [0.00000010943, 0.08477481315, 127.4717966068],
    [0.00000008683, 4.25475342937, 7.1135470008],
    [0.00000010478, 5.16510093405, 71.6002048296],
    [0.00000007208, 1.25579094145, 5.4166259714],
    [0.00000008383, 5.49939298653, 67.6680515665],
    [0.00000006079, 5.44023447414, 65.2203710117],
    [0.00000005718, 1.83543074459, 202.2533951741],
    [0.00000006109, 3.36329480272, 447.7958195265],
    [0.00000006002, 5.72509014963, 462.0229135281],
    [0.00000005684, 4.14533132422, 151.0476698429],
    [0.00000005091, 3.52369031374, 59.8037450403],
    [0.00000005147, 1.05915315998, 131.4039498699],
    [0.00000004917, 3.38475371297, 4.4534181249],
    [0.00000004818, 1.20436413021, 71.8126531507],
    [0.00000004697, 6.13059120042, 148.0787244263],
    [0.0000000395, 0.69544777458, 77.7505439839],
    [0.00000003655, 1.75283968054, 351.8165923087],
    [0.00000003144, 3.30914690507, 160.6088973985],
    [0.0000000317, 6.13784634729, 77.2292791221],
    [0.00000003149, 3.83524373649, 45.5766510387],
    [0.00000003616, 4.56973348262, 454.9093665273],
    [0.00000002673, 1.05631111199, 69.3649725959],
    [0.0000000266, 5.35501232753, 269.9214467406],
    [0.00000002315, 2.61423820966, 84.3428261229],
    [0.00000002258, 5.07517615514, 14.977853527],
    [0.00000002249, 1.37812609668, 284.1485407422],
    [0.00000002072, 4.3496677836, 984.6003316219],
    [0.00000002101, 2.31175293338, 120.358249606],
    [0.00000001808, 0.52249831108, 137.0330241624],
    [0.00000001849, 5.69618054054, 54.1746707478],
    [0.00000001983, 3.87043200848, 195.1398481733],
    [0.00000001632, 5.07069503204, 209.3669421749],
    [0.00000001578, 2.91229378751, 51.2057253312],
    [0.00000001722, 6.25913624391, 41.6444977756],
    [0.00000001656, 6.26113629911, 277.0349937414],
    [0.00000001822, 1.24304611018, 35.1640902212],
    [0.00000001345, 2.04057300383, 70.3281804424],
    [0.00000001253, 2.65486278486, 134.5853436076],
    [0.00000001239, 4.63255501972, 92.940845832],
    [0.00000001369, 6.08201469405, 87.3117715395],
    [0.00000001277, 5.87454788183, 60.5545045657],
    [0.00000001281, 2.51504858314, 72.3339180125],
    [0.0000000125, 1.09008933023, 213.299095438],
    [0.00000001055, 4.00338488062, 299.1263942692],
    [0.00000001133, 4.64929170681, 152.7445908723],
    [0.00000001082, 1.07336611951, 153.4953503977],
    [0.00000001037, 4.82158521698, 116.4260963429],
    [0.00000000863, 3.56774115747, 340.7708920448],
    [0.00000000957, 2.11521253777, 20.6069278195],
    [0.00000000952, 2.4717064451, 380.12776796],
    [0.00000000836, 6.12347738126, 49.5088043018],
    [0.00000000808, 0.29677438017, 191.2076949102],
    [0.00000000808, 4.08162792952, 14.2270940016],
    [0.00000000792, 6.1709106312, 344.7030453079],
    [0.00000000791, 2.37030711541, 58.1068240109],
    [0.00000000914, 2.11419968166, 14.0146456805],
    [0.00000000788, 0.75228496417, 408.4389436113],
    [0.00000000763, 2.38121244677, 222.8603229936],
    [0.00000000891, 2.04340711828, 265.9892934775],
    [0.0000000073, 3.10064098912, 422.6660376129],
    [0.00000000765, 0.7772382722, 76.4785195967],
    [0.00000000645, 2.77108845143, 96.8729990951],
    [0.00000000745, 2.35633194869, 358.9301393095],
    [0.0000000062, 1.98188971784, 33.6796175129],
    [0.00000000655, 3.8541585028, 16.6747745564],
    [0.00000000608, 0.15790159997, 28.3111756513],
    [0.00000000587, 1.09637968292, 55.1378785943],
    [0.00000000617, 1.70137701054, 8.0767548473],
    [0.00000000645, 5.17890892522, 23.5758732361],
    [0.00000000589, 3.39293635432, 144.1465711632],
    [0.00000000598, 3.77279530334, 80.1982245387],
    [0.00000000562, 4.90624120147, 35.4247226521],
    [0.00000000587, 4.33026772564, 29.2049475286],
    [0.00000000474, 0.88680405794, 565.1156877467],
    [0.00000000477, 3.44956358856, 128.9562693151],
    [0.00000000432, 1.05836005695, 19.643719973],
    [0.0000000048, 5.27492573341, 206.1855484372],
    [0.00000000454, 6.05565972578, 70.1157321213],
    [0.00000000413, 0.42595505653, 225.8292684102],
    [0.00000000458, 5.47151191138, 333.657345044],
    [0.00000000528, 2.2702575842, 38.1330356378],
    [0.00000000447, 0.91893151458, 373.0142209592],
    [0.00000000511, 1.59897693264, 142.4496501338],
    [0.0000000042, 5.77293204332, 146.594251718],
    [0.00000000383, 1.91679738697, 5.6290742925],
    [0.00000000382, 3.0433966022, 152.5321425512],
    [0.00000000418, 1.05236603665, 125.9873238985],
    [0.00000000372, 2.85710020233, 200.7689224658],
    [0.00000000496, 1.92980650193, 415.5524906121],
    [0.0000000037, 3.2221242722, 387.2413149608],
    [0.00000000387, 2.79134085638, 81.8951455681],
    [0.00000000357, 4.64158965749, 220.4126424388],
    [0.00000000345, 2.98021540638, 429.7795846137],
    [0.00000000335, 5.29062985955, 13.3333221243],
    [0.0000000032, 1.62674909598, 99.1606209555],
    [0.0000000032, 0.74685145174, 347.8844390456],
    [0.00000000288, 2.44437048636, 546.956440482],
    [0.00000000275, 0.62680026669, 31.492569389],
    [0.00000000281, 6.04447663913, 456.3938392356],
    [0.0000000027, 2.7937834555, 977.4867846211],
    [0.00000000268, 4.64955164739, 230.5645708254],
    [0.00000000271, 0.59225635449, 1894.4190646765],
    [0.00000000263, 3.49309481771, 440.6822725257],
    [0.00000000253, 1.90016027905, 129.9194771616],
    [0.00000000271, 4.82853730065, 561.1835344836],
    [0.00000000259, 0.27190856999, 373.9079928365],
    [0.00000000314, 1.47136601206, 24.3790223882],
    [0.00000000261, 0.09830739366, 991.7138786227],
    [0.00000000235, 5.13968661425, 479.2883889155],
    [0.00000000231, 1.3810636328, 391.1734682239],
    [0.0000000023, 4.81251240097, 159.1244246902],
    [0.00000000305, 4.4551845892, 112.9146342051],
    [0.00000000311, 4.82238770299, 108.4612160802],
    [0.00000000233, 4.25631985431, 365.9006739584],
    [0.00000000261, 1.59315260466, 17.2654753874],
    [0.00000000233, 2.83623217386, 376.1956146969],
    [0.00000000294, 1.66582514618, 124.2904028691],
    [0.00000000213, 1.07884329091, 288.0806940053],
    [0.00000000207, 5.03566431809, 297.6419215609],
    [0.00000000201, 1.68940522081, 135.5485514541],
    [0.00000000231, 2.24878224928, 152.0108776894],
    [0.00000000216, 6.19661665314, 490.3340891794],
    [0.00000000236, 4.93084016804, 458.090760265],
    [0.00000000225, 0.22664678208, 254.9435932136],
    [0.00000000213, 0.12942394964, 411.620337349],
    [0.00000000193, 3.70727194044, 353.301065017],
    [0.00000000214, 2.37863059014, 184.0941479094],
    [0.00000000211, 2.16158427984, 162.0933701068],
    [0.00000000208, 3.81481624262, 258.8757464767],
    [0.00000000188, 0.23642242835, 74.8934731519],
    [0.00000000229, 5.33297149225, 827.1728279611],
    [0.00000000196, 3.41624470471, 173.9422195228],
    [0.00000000186, 1.25407717254, 74.6697239827],
    [0.00000000219, 1.22774377372, 305.3461693927],
    [0.00000000184, 0.07653324668, 969.6224780949],
    [0.00000000181, 5.5026898635, 983.1158589136],
    [0.00000000234, 1.43222813448, 146.3818033969],
    [0.00000000191, 4.02315888568, 774.4826299216],
    [0.00000000176, 0.36587651982, 100.3844612329],
    [0.00000000174, 0.35464783229, 354.9979860464],
    [0.00000000174, 2.8120362685, 140.001969579],
    [0.00000000201, 1.04955848325, 316.3918696566],
    [0.00000000172, 0.67782414229, 167.7224443993],
    [0.00000000175, 5.90738517293, 235.3904959658],
    [0.00000000171, 1.90443657327, 33.1371007917],
    [0.00000000174, 5.60867787733, 469.1364605289],
    [0.00000000179, 2.38892600195, 486.4019359163],
    [0.00000000171, 1.27067391131, 291.262087743],
    [0.00000000175, 3.15884013286, 66.9172920411],
    [0.00000000209, 5.78799629527, 111.4301614968],
    [0.00000000171, 5.43315629209, 42.5382696529],
    [0.00000000203, 1.58369655553, 298.2326223919],
    [0.00000000166, 4.78948867256, 1514.2912967165],
    [0.00000000174, 0.56063488876, 521.0929453855],
    [0.00000000205, 3.48282420941, 404.5067903482],
    [0.00000000171, 2.91325849153, 535.3200393871],
    [0.00000000177, 0.86306620537, 472.1748419147],
    [0.00000000184, 2.92293138603, 881.5075574033],
    [0.00000000166, 4.78927133151, 109.9456887885],
    [0.00000000188, 0.57920908215, 369.0820676961],
    [0.00000000155, 1.28199332469, 89.7594520943],
    [0.00000000156, 2.77376676007, 141.6988906084],
    [0.00000000163, 6.18149717003, 1357.6145525811],
    [0.00000000154, 6.1325559281, 218.9281697305],
    [0.00000000151, 2.6977364819, 132.8884225782],
    [0.00000000164, 5.23606804941, 1094.8066528413],
    [0.00000000157, 3.34238375767, 268.4369740323],
    [0.00000000169, 1.82777920099, 398.2870152247],
    [0.00000000178, 3.45386061878, 685.4739373527],
    [0.00000000148, 2.9887327609, 211.8146227297],
    [0.00000000155, 1.72159478356, 679.2541622292],
    [0.00000000148, 0.95649146876, 867.2804634017],
    [0.00000000191, 3.62538073529, 554.0699874828],
    [0.00000000178, 2.10923963877, 661.0949149645],
    [0.00000000135, 6.06368720482, 980.6681783588],
    [0.00000000135, 5.9685748351, 91.4563731237],
    [0.0000000013, 4.36914393286, 273.1028404783],
    [0.00000000153, 3.49640803991, 228.276948965],
    [0.0000000013, 2.72570287614, 522.5774180938],
    [0.00000000143, 5.02900860888, 536.8045120954],
    [0.00000000126, 1.93883254906, 909.8187330546],
    [0.00000000127, 1.78014700856, 205.4347889118],
    [0.0000000014, 0.83038018169, 535.9107402181],
    [0.00000000127, 5.06009501625, 275.5505210331],
    [0.00000000129, 3.77988686343, 483.2205421786],
    [0.00000000118, 5.83292150811, 703.6331846174],
    [0.0000000013, 4.52188865601, 216.4804891757],
    [0.00000000117, 3.97236048113, 135.336103133],
    [0.0000000011, 4.10507371008, 433.7117378768],
    [0.00000000113, 1.51901732866, 384.0599212231],
    [0.00000000107, 0.99334138425, 295.1942410061],
    [0.00000000131, 3.98415139373, 73.0846775379],
    [0.00000000108, 4.07981007546, 203.7378678824],
    [0.00000000109, 3.04776608048, 300.6108669775],
    [0.00000000109, 1.22958797958, 525.7588118315],
    [0.00000000131, 2.99178036398, 75.7448064138],
    [0.00000000103, 4.46390192594, 579.3427817483],
    [0.00000000109, 1.9918256593, 60.7669528868],
    [0.00000000121, 0.73822914508, 248.7238180901],
    [0.00000000106, 2.04571727537, 2043.9822618111],
    [0.00000000102, 4.88960169615, 831.1049812242],
    [0.00000000099, 3.81282044986, 73.8183907208],
    [0.00000000094, 5.78362714209, 350.3321196004],
    [0.00000000114, 2.09397520178, 278.5194664497],
    [0.00000000089, 5.90655259674, 79.2350166922],
    [0.00000000097, 2.67425330058, 221.3758502853],
    [0.00000000089, 6.25528198072, 234.4967240885],
    [0.00000000085, 0.13307608646, 639.897286314],
    [0.0000000009, 5.53000751155, 827.9235874865],
    [0.0000000008, 5.34711145866, 181.0557665236],
    [0.00000000079, 0.95205771963, 426.598190876],
    [0.00000000084, 3.97140652554, 336.8387387817],
    [0.0000000008, 5.24056087129, 504.561183181],
    [0.00000000078, 2.26526379571, 450.9772132642],
    [0.00000000081, 1.32480509617, 89.0086925689],
    [0.00000000108, 1.50473495412, 25.2727942655],
    [0.00000000077, 0.31815291828, 447.2051186955],
    [0.00000000081, 4.64364910706, 1208.0513554465],
    [0.00000000077, 5.90631938483, 515.463871093],
    [0.00000000095, 5.82143764459, 453.424893819],
    [0.00000000077, 3.56359211434, 82.8583534146],
    [0.00000000093, 0.3830174579, 699.7010313543],
    [0.00000000076, 4.16820366863, 95.3885263868],
    [0.00000000076, 1.49535232496, 849.2642284889],
    [0.00000000099, 2.79074529357, 184.7272873558],
    [0.00000000076, 6.13770068285, 123.5396433437],
    [0.00000000104, 6.2565394264, 443.8636662634],
    [0.00000000073, 3.57936315445, 180.1619946463],
    [0.00000000083, 1.56888177127, 306.830642101],
    [0.00000000087, 0.74135830037, 227.5261894396],
    [0.00000000079, 1.91762400825, 901.9544265284],
    [0.00000000089, 3.64708770174, 810.6581120991],
    [0.00000000084, 1.50560186863, 419.4846438752],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000122192, 0.02112102225, 74.7815985673],
    [0.00000068195, 4.12138633187, 3.9321532631],
    [0.00000052729, 2.38808499397, 11.0457002639],
    [0.00000043714, 2.95937380925, 1.4844727083],
    [0.00000045405, 2.04405402149, 3.1813937377],
    [0.00000024903, 4.886800756, 63.7358983034],
    [0.00000021004, 4.54879176205, 70.8494453042],
    [0.00000008985, 1.58255257968, 56.6223513026],
    [0.00000009158, 2.57000447334, 149.5631971346],
    [0.00000010361],
    [0.00000004261, 0.22780215466, 18.1592472647],
    [0.00000003625, 5.3836730459, 76.2660712756],
    [0.00000003244, 5.01058611704, 85.8272988312],
    [0.00000003488, 4.13160885916, 52.6901980395],
    [0.0000000357, 0.94065081296, 77.962992305],
    [0.00000002738, 0.4034653554, 78.7137518304],
    [0.00000002233, 0.87157987676, 145.6310438715],
    [0.00000001948, 2.67957461817, 7.1135470008],
    [0.0000000212, 5.64073933192, 9.5612275556],
    [0.00000001566, 5.46300116637, 73.297125859],
    [0.00000001308, 1.25835033636, 12.5301729722],
    [0.00000001616, 0.49324165265, 71.6002048296],
    [0.0000000123, 3.93093451148, 22.0914005278],
    [0.00000000906, 2.17573166732, 127.4717966068],
    [0.00000000811, 5.08300105756, 447.7958195265],
    [0.000000008, 4.00214562488, 462.0229135281],
    [0.00000000718, 0.34600103024, 5.6290742925],
    [0.00000000718, 1.19635899416, 138.5174968707],
    [0.0000000068, 2.9444450611, 131.4039498699],
    [0.00000000581, 5.14726797687, 224.3447957019],
    [0.00000000406, 4.33376335103, 120.358249606],
    [0.00000000376, 0.75784834422, 269.9214467406],
    [0.00000000347, 5.94165731686, 284.1485407422],
    [0.00000000345, 3.05968942771, 561.1835344836],
    [0.00000000343, 4.01891371998, 546.956440482],
    [0.00000000376, 5.9584406066, 45.5766510387],
    [0.00000000334, 1.61761448243, 151.0476698429],
    [0.00000000284, 1.1286389648, 134.5853436076],
    [0.00000000278, 3.4313540142, 202.2533951741],
    [0.00000000374, 3.31569280991, 152.7445908723],
    [0.00000000268, 3.24741531524, 536.8045120954],
    [0.00000000358, 1.10916640253, 333.657345044],
    [0.00000000355, 2.95198893484, 153.4953503977],
    [0.00000000236, 4.64852235589, 387.2413149608],
    [0.00000000223, 5.11416165165, 347.8844390456],
    [0.00000000245, 5.194366284, 81.8951455681],
    [0.00000000228, 3.7413893183, 87.3117715395],
    [0.00000000226, 4.29682981394, 77.7505439839],
    [0.00000000234, 5.80540756495, 67.6680515665],
    [0.00000000288, 5.72707827196, 195.1398481733],
    [0.00000000201, 1.74602592032, 213.299095438],
    [0.00000000204, 5.81145810966, 373.0142209592],
    [0.00000000187, 2.35512484122, 124.2904028691],
    [0.00000000185, 3.12619552579, 148.0787244263],
    [0.0000000017, 1.91718323832, 59.8037450403],
    [0.00000000165, 3.46463258943, 209.3669421749],
    [0.00000000171, 6.12119673115, 351.8165923087],
    [0.00000000191, 5.50650694321, 73.0846775379],
    [0.00000000154, 2.74592153459, 92.940845832],
    [0.00000000187, 2.88710400041, 146.3818033969],
    [0.00000000142, 3.34786225013, 72.3339180125],
    [0.0000000013, 1.06884333081, 84.3428261229],
    [0.00000000156, 1.27379656026, 160.6088973985],
    [0.00000000112, 2.52374006072, 62.2514255951],
    [0.00000000096, 2.43808447701, 288.0806940053],
    [0.00000000104, 4.80942792304, 144.1465711632],
    [0.0000000009, 4.64083951502, 411.620337349],
    [0.0000000008, 3.36996054975, 497.4476361802],
    [0.00000000085, 2.90593266919, 483.2205421786],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000005536, 4.57721551627, 74.7815985673],
    [0.00000003183, 0.34467460171, 11.0457002639],
    [0.00000001207, 3.40871377105, 56.6223513026],
    [0.00000000634, 4.65445189526, 18.1592472647],
    [0.00000000359, 0.67024156853, 149.5631971346],
    [0.00000000247, 2.07784257495, 63.7358983034],
    [0.00000000109, 2.7551433797, 85.8272988312],
    [0.00000000092, 5.02598538441, 131.4039498699],
];

const VSOP87_L5: Vsop87Element = [[Math.LN2]];

const VSOP87_B0: Vsop87Element = [
    [0.01346277648, 2.61877810547, 74.7815985673],
    [0.000623414, 5.08111189648, 149.5631971346],
    [0.00061601196, Math.PI],
    [0.00009963722, 1.61603805646, 76.2660712756],
    [0.0000992616, 0.57630380333, 73.297125859],
    [0.00003259466, 1.26119342526, 224.3447957019],
    [0.00002972303, 2.24367206357, 1.4844727083],
    [0.00002010275, 6.05550884547, 148.0787244263],
    [0.00001522163, 0.27959645002, 63.7358983034],
    [0.00000924064, 4.03822512696, 151.0476698429],
    [0.0000076064, 6.13999362624, 71.8126531507],
    [0.00000420265, 5.21280055515, 11.0457002639],
    [0.00000430661, 3.55443947716, 213.299095438],
    [0.00000436847, 3.38081057022, 529.6909650946],
    [0.00000522314, 3.32086440954, 138.5174968707],
    [0.00000434627, 0.34063199763, 77.7505439839],
    [0.0000046263, 0.74256687606, 85.8272988312],
    [0.00000232667, 2.25715668168, 222.8603229936],
    [0.00000215848, 1.59122810633, 38.1330356378],
    [0.00000244698, 0.787951741, 2.9689454166],
    [0.00000179936, 3.72487768728, 299.1263942692],
    [0.00000174896, 1.23550822483, 146.594251718],
    [0.00000173648, 1.93654971482, 380.12776796],
    [0.00000160368, 5.33635511113, 111.4301614968],
    [0.00000144064, 5.96238846558, 35.1640902212],
    [0.00000102049, 2.61876132065, 78.7137518304],
    [0.00000116363, 5.73877137488, 70.8494453042],
    [0.00000106444, 0.94095705978, 70.3281804424],
    [0.0000008616, 0.70251751041, 39.6175083461],
    [0.00000072611, 0.205721589, 225.8292684102],
    [0.00000071172, 0.83343109173, 109.9456887885],
    [0.00000057495, 2.67048156941, 108.4612160802],
    [0.00000054263, 3.35177461012, 184.7272873558],
    [0.00000044471, 2.74407889623, 152.5321425512],
    [0.00000038592, 5.1739053114, 202.2533951741],
    [0.00000039159, 2.17111197275, 351.8165923087],
    [0.00000041362, 3.22138743484, 160.6088973985],
    [0.00000035132, 4.00123533788, 112.9146342051],
    [0.00000033091, 3.6137250502, 221.3758502853],
    [0.00000031332, 2.71938965609, 145.1097790097],
    [0.0000003734, 4.0208394424, 52.6901980395],
    [0.00000032034, 1.29143160665, 145.6310438715],
    [0.00000027569, 3.70085992486, 36.6485629295],
    [0.00000024272, 2.85050776068, 127.4717966068],
    [0.00000024635, 1.11646359832, 3.9321532631],
    [0.00000024309, 5.48949970007, 79.2350166922],
    [0.00000021418, 0.63723215666, 277.0349937414],
    [0.00000019832, 2.59336449599, 84.3428261229],
    [0.00000022368, 5.73729035268, 4.4534181249],
    [0.00000019125, 1.30093692086, 62.2514255951],
    [0.00000019796, 4.72268731719, 297.6419215609],
    [0.00000020298, 1.06069563441, 454.9093665273],
    [0.00000019769, 5.77906677614, 305.3461693927],
    [0.00000021357, 1.01279253027, 33.6796175129],
    [0.00000015136, 2.91791848257, 426.598190876],
    [0.0000001601, 1.95529008632, 186.2117600641],
    [0.00000013804, 2.67173362271, 74.6697239827],
    [0.00000011468, 5.7330316553, 41.1019810544],
    [0.00000010741, 3.73406242289, 1059.3819301892],
    [0.00000011468, 3.98150176278, 106.9767433719],
    [0.00000010365, 4.75684964951, 183.2428146475],
    [0.00000010232, 6.18772944512, 373.9079928365],
    [0.00000013803, 5.70721417446, 74.8934731519],
    [0.00000010563, 3.78630189172, 490.3340891794],
    [0.00000011838, 5.96756141943, 87.3117715395],
    [0.00000010033, 1.74884568436, 22.0914005278],
    [0.00000010107, 0.92920871591, 65.2203710117],
    [0.00000009126, 5.11087748378, 153.4953503977],
    [0.00000012093, 2.53736478942, 9.5612275556],
    [0.00000008645, 4.18353789478, 12.5301729722],
    [0.00000009969, 5.83607933801, 604.4725636619],
    [0.00000011363, 2.12628390559, 68.8437077341],
    [0.00000008481, 3.37168822431, 72.3339180125],
    [0.0000000779, 5.1180289667, 77.962992305],
    [0.00000008306, 5.19333619113, 77.2292791221],
    [0.00000007701, 3.25277033035, 71.6002048296],
    [0.00000007521, 2.98280931167, 114.3991069134],
    [0.00000006948, 3.31879527596, 56.6223513026],
    [0.000000065, 0.88498775188, 288.0806940053],
    [0.00000006393, 3.51141825287, 220.4126424388],
    [0.00000006208, 0.58088443555, 340.7708920448],
    [0.00000006772, 4.09371704059, 137.0330241624],
    [0.00000005595, 5.68796827406, 259.5088859231],
    [0.00000005301, 2.65424478534, 300.6108669775],
    [0.0000000495, 4.99680523609, 219.891377577],
    [0.00000006424, 0.44994761517, 140.001969579],
    [0.00000004972, 4.06861003746, 143.6253063014],
    [0.00000005694, 3.76750788366, 67.6680515665],
    [0.00000004853, 2.03388920337, 415.5524906121],
    [0.00000003803, 1.26170663854, 75.3028634291],
    [0.00000003807, 2.2478190396, 909.8187330546],
    [0.00000003813, 3.1046677749, 181.7583419392],
    [0.0000000378, 5.19959127344, 227.3137411185],
    [0.00000003426, 5.91911283488, 296.1574488526],
    [0.00000003517, 5.44401451357, 628.8515860501],
    [0.00000003943, 4.9510920534, 265.9892934775],
    [0.00000003472, 0.34748263417, 131.4039498699],
    [0.000000034, 0.5368588001, 206.1855484372],
    [0.00000003039, 4.68312649973, 159.1244246902],
    [0.00000003189, 5.68771037501, 235.3904959658],
    [0.00000003303, 2.09359478408, 73.8183907208],
    [0.00000003062, 4.48989306244, 66.70484372],
    [0.00000003265, 0.01005829991, 75.7448064138],
    [0.00000002917, 4.21626758697, 258.0244132148],
    [0.00000003747, 0.82998936434, 74.2603337055],
    [0.00000002818, 3.96515762579, 82.8583534146],
    [0.00000002474, 3.81322641071, 7.1135470008],
    [0.00000002394, 2.21473666039, 54.1746707478],
    [0.00000002546, 2.97069404242, 378.6432952517],
    [0.00000002632, 1.55152764206, 154.0166152595],
    [0.00000002639, 2.28085213767, 32.1951448046],
    [0.00000002642, 3.96819246977, 381.6122406683],
    [0.00000002203, 3.06747152218, 59.8037450403],
    [0.00000002635, 0.54046453944, 211.8146227297],
    [0.00000002053, 1.98285180962, 18.1592472647],
    [0.00000002516, 0.63537765744, 187.6962327724],
    [0.00000002485, 3.55942732547, 96.8729990951],
    [0.00000001918, 1.6047957873, 80.1982245387],
    [0.00000002055, 4.49938733826, 5.9378908332],
    [0.00000002018, 2.97794616041, 191.2076949102],
    [0.00000001832, 1.96177252651, 81.8951455681],
    [0.00000001719, 2.22518862087, 479.2883889155],
    [0.00000001857, 1.66299721979, 984.6003316219],
    [0.00000001726, 3.22144940779, 218.4069048687],
    [0.0000000177, 5.24609773415, 105.4922706636],
    [0.0000000152, 0.94716593371, 372.4235201282],
    [0.00000001512, 6.03457842275, 99.1606209555],
    [0.00000001614, 3.39986737271, 230.5645708254],
    [0.00000001711, 3.4423248368, 522.5774180938],
    [0.00000001504, 1.34653259405, 74.5209661364],
    [0.00000001584, 4.37196518404, 80.7194894005],
    [0.0000000136, 5.4869124027, 74.8297826771],
    [0.00000001405, 0.33792710499, 142.4496501338],
    [0.00000001363, 4.56068902351, 42.5864537627],
    [0.00000001709, 3.63180456542, 554.0699874828],
    [0.0000000136, 2.89305157919, 74.7334144575],
    [0.0000000126, 5.50922979275, 74.9416572617],
    [0.00000001384, 4.40028240227, 260.9933586314],
    [0.00000001365, 2.15266243195, 162.0933701068],
    [0.00000001244, 4.97782030325, 149.45132255],
    [0.00000001278, 0.84565446273, 767.3690829208],
    [0.00000001263, 4.53422211084, 294.6729761443],
    [0.00000001322, 5.10927435201, 51.2057253312],
    [0.0000000118, 0.79757360842, 116.4260963429],
    [0.00000001495, 0.74986873597, 75.0422309982],
    [0.00000001213, 3.66821217363, 20.6069278195],
    [0.00000001248, 3.13317666641, 67.3592350258],
    [0.00000001171, 4.39747177706, 180.2738692309],
    [0.00000001125, 3.86202201629, 39.3568759152],
    [0.00000001263, 2.87116663203, 74.6215398729],
    [0.00000001376, 3.75596842702, 92.940845832],
    [0.00000001018, 6.20402800983, 835.0371344873],
    [0.00000000962, 3.30346641752, 255.0554677982],
    [0.00000001239, 1.73040337356, 149.6750717192],
    [0.0000000097, 1.71235586924, 115.8835796217],
    [0.00000000943, 3.07319537857, 8.0767548473],
    [0.00000001, 5.49989514567, 256.5399405065],
    [0.00000000911, 6.23756163651, 200.7689224658],
    [0.00000000908, 0.00832674265, 536.8045120954],
    [0.00000000969, 5.7757567523, 128.9562693151],
    [0.00000000952, 3.00463012001, 14.977853527],
    [0.00000000983, 0.35101173825, 404.5067903482],
    [0.00000000808, 3.21398175104, 28.3111756513],
    [0.00000000764, 3.45466431894, 214.7835681463],
    [0.00000001021, 1.79907610488, 3.1813937377],
    [0.00000000783, 4.1216774988, 125.9873238985],
    [0.00000000715, 5.80380056776, 157.6399519819],
    [0.00000000689, 1.84739011152, 41.6444977756],
    [0.00000000715, 5.56310287629, 146.3818033969],
    [0.00000000682, 5.16479782395, 74.0308390419],
    [0.00000000673, 2.65544175682, 75.5323580927],
    [0.00000000696, 3.59376281929, 362.8622925726],
    [0.00000000715, 4.76877987059, 331.3215390738],
    [0.00000000729, 2.25493921872, 453.424893819],
    [0.00000000648, 1.99137116455, 639.897286314],
    [0.00000000641, 5.77409064831, 110.2063212194],
    [0.00000000666, 5.97888465085, 135.5485514541],
    [0.00000000774, 0.42035537394, 565.1156877467],
    [0.00000000674, 5.3291350143, 142.1408335931],
    [0.00000000776, 5.57009796152, 2.4476805548],
    [0.00000000798, 0.90966507165, 152.0108776894],
    [0.0000000068, 2.94896042701, 60.7669528868],
    [0.00000000603, 2.0420815188, 195.1398481733],
    [0.0000000065, 4.5628702594, 216.9224321604],
    [0.00000000738, 5.07239490532, 89.7594520943],
    [0.00000000597, 1.91415368214, 203.7378678824],
    [0.00000000646, 2.79255070924, 50.4025761791],
    [0.00000000557, 2.9179539235, 68.1893164283],
    [0.00000000565, 2.77660876182, 14.0146456805],
    [0.00000000531, 3.75443696232, 617.8058857862],
    [0.0000000053, 3.51481429918, 291.7040307277],
    [0.00000000506, 4.94596553031, 81.3738807063],
    [0.00000000602, 2.45288547587, 81.0013736908],
    [0.00000000596, 5.42429198496, 692.5874843535],
    [0.00000000648, 5.7487776582, 141.4864422873],
    [0.00000000523, 4.97086637939, 387.2413149608],
    [0.00000000544, 2.99910796114, 152.7445908723],
    [0.00000000485, 2.36315064516, 448.6895914038],
    [0.00000000481, 5.8166549566, 134.5853436076],
    [0.0000000047, 1.3017484602, 228.276948965],
    [0.00000000475, 0.53495528828, 303.8616966844],
    [0.00000000584, 4.6786656527, 88.7962442478],
    [0.00000000461, 0.55903469027, 23.5758732361],
    [0.00000000478, 6.22340588748, 5.4166259714],
    [0.00000000426, 5.25039648756, 35.4247226521],
    [0.00000000446, 2.50203892379, 905.8865797915],
    [0.00000000441, 4.26182840333, 278.5194664497],
    [0.00000000501, 4.79995214429, 306.830642101],
    [0.00000000499, 5.86243513978, 293.188503436],
    [0.00000000474, 3.031176471, 286.596221297],
    [0.00000000506, 2.05350887377, 373.0142209592],
    [0.0000000041, 5.30618889138, 95.3885263868],
    [0.00000000395, 5.65591153137, 284.1485407422],
    [0.00000000478, 2.41099809344, 358.9301393095],
    [0.00000000536, 1.82605088834, 114.1384744825],
    [0.00000000383, 5.54529609922, 419.4846438752],
    [0.00000000413, 0.03790517946, 103.0927742186],
    [0.00000000368, 4.08523828488, 1589.0728952838],
    [0.0000000037, 1.82531607739, 334.2904844904],
    [0.00000000387, 0.56619512225, 602.9880909536],
    [0.00000000482, 5.58482619841, 68.5618234438],
    [0.00000000478, 0.17223161797, 120.358249606],
    [0.00000000419, 5.07107020071, 367.9701020033],
    [0.00000000342, 5.27207825111, 28.5718080822],
    [0.00000000406, 2.00845231847, 679.2541622292],
    [0.00000000381, 4.61323929793, 329.7251917809],
    [0.00000000388, 0.89083225227, 483.2205421786],
    [0.00000000376, 1.28833260468, 155.7829722581],
    [0.00000000326, 6.09139244001, 456.3938392356],
    [0.000000003, 5.11528183598, 375.3924655448],
    [0.00000000321, 0.11320249807, 69.3649725959],
    [0.00000000299, 6.0391232334, 332.8060117821],
    [0.00000000328, 3.47252263966, 73.4090004436],
    [0.00000000283, 1.81773059325, 647.0108333148],
    [0.00000000308, 3.50107540223, 30.7106720963],
    [0.00000000278, 3.85509473152, 760.25553592],
    [0.00000000293, 5.44449244354, 477.9157907918],
    [0.00000000319, 1.96492310465, 543.0242872189],
    [0.00000000275, 1.82480767582, 24.3790223882],
    [0.00000000254, 4.23529202563, 391.1734682239],
    [0.00000000248, 2.17740648239, 611.5861106627],
    [0.00000000271, 3.85067228463, 209.3669421749],
    [0.00000000245, 1.04008534095, 1332.4847706675],
    [0.00000000248, 6.19520746836, 1134.1635287565],
    [0.00000000317, 5.60194689908, 501.3797894433],
    [0.00000000242, 1.37720813333, 121.2520214833],
    [0.00000000234, 0.50970508504, 462.0229135281],
    [0.00000000236, 0.71434091094, 233.9060232575],
    [0.00000000319, 4.24234798459, 328.3525936572],
    [0.00000000245, 6.00685270776, 295.1942410061],
    [0.00000000224, 2.04173820334, 370.9390474199],
    [0.00000000226, 4.36158718577, 269.9214467406],
    [0.00000000222, 5.32240209336, 983.1158589136],
    [0.00000000219, 1.37802257893, 302.0953396858],
    [0.00000000301, 5.70756404145, 189.1807054807],
    [0.00000000244, 4.69736688026, 316.3918696566],
    [0.00000000267, 0.15744446717, 10213.285546211],
    [0.0000000021, 5.84976141374, 147.1155165798],
    [0.00000000224, 3.04838385551, 1439.5096981492],
    [0.00000000267, 2.78030672201, 144.1465711632],
    [0.00000000204, 2.37388505075, 275.5505210331],
    [0.00000000229, 2.33600590519, 150.5264049811],
    [0.00000000194, 5.11344829807, 1215.1649024473],
    [0.00000000215, 0.7013069954, 45.5766510387],
    [0.00000000198, 3.20849122961, 7.4223635415],
    [0.00000000196, 3.83527631644, 46.2097904851],
    [0.00000000195, 6.08813214815, 344.7030453079],
    [0.00000000179, 4.70649738298, 518.6452648307],
    [0.00000000176, 3.72183112618, 150.0844619964],
    [0.00000000222, 6.13768802796, 6.2197751235],
    [0.00000000174, 1.87343899875, 310.1720945331],
    [0.00000000168, 3.3420961142, 173.9422195228],
    [0.00000000192, 0.4164424183, 0.9632078465],
    [0.00000000141, 1.70340116374, 531.1754378029],
    [0.00000000149, 3.99276635695, 228.7982138268],
    [0.00000000137, 6.20556096334, 369.4545747116],
    [0.00000000145, 3.96204016046, 350.3321196004],
    [0.00000000126, 5.28560984253, 329.8370663655],
    [0.00000000132, 4.51993002555, 148.5999892881],
    [0.00000000125, 4.24716365077, 248.7238180901],
    [0.00000000131, 4.06190440824, 526.722019678],
    [0.0000000012, 4.08620475792, 154.979823106],
    [0.00000000134, 3.16619358295, 262.4778313397],
    [0.00000000121, 2.31292076167, 232.0490435337],
    [0.00000000125, 4.25542060721, 377.1588225434],
    [0.00000000119, 4.1219384181, 404.6186649328],
    [0.0000000013, 6.09762672394, 171.6545976624],
    [0.00000000127, 3.76800714166, 369.0820676961],
    [0.000000001, 2.65367785044, 703.6331846174],
    [0.00000000127, 3.335368644, 149.0419322728],
    [0.00000000116, 4.77834673196, 1289.9465010146],
    [0.00000000096, 2.4715516937, 210.3301500214],
    [0.00000000097, 1.08835035283, 156.1554792736],
    [0.00000000108, 3.07832539912, 6133.5126528568],
    [0.00000000108, 2.03236554349, 6283.0758499914],
    [0.000000001, 4.75380350867, 218.9281697305],
    [0.00000000093, 1.66567734962, 668.2084619653],
    [0.00000000097, 0.64083375068, 252.6559713532],
    [0.00000000091, 4.11478686503, 166.828672522],
    [0.00000000089, 4.92738306385, 353.301065017],
    [0.00000000081, 1.42684401779, 831.1049812242],
    [0.00000000084, 2.75226196759, 217.2312487011],
    [0.00000000083, 4.26421510316, 383.0967133766],
    [0.00000000098, 0.58553892847, 339.2864193365],
    [0.00000000101, 4.62998086587, 756.3233826569],
    [0.00000000079, 5.7969252212, 443.8636662634],
    [0.00000000075, 3.3904628513, 447.2051186955],
    [0.00000000076, 0.11314255037, 406.1031376411],
    [0.00000000074, 0.54434880673, 33.1371007917],
    [0.00000000075, 2.44458975326, 120.9913890524],
    [0.00000000074, 0.63126666381, 335.7749571987],
];

const VSOP87_B1: Vsop87Element = [
    [0.00034101978, 0.01321929936, 74.7815985673],
    [0.00002480115, 2.73961370453, 149.5631971346],
    [0.00001719377],
    [0.00000395276, 5.49322816551, 76.2660712756],
    [0.00000308903, 3.61139770633, 73.297125859],
    [0.00000181125, 5.32079457105, 224.3447957019],
    [0.0000014452, 4.22110521671, 63.7358983034],
    [0.00000076343, 4.54620999213, 85.8272988312],
    [0.00000072633, 5.97811706013, 1.4844727083],
    [0.00000065492, 2.77607065171, 11.0457002639],
    [0.00000063931, 6.15917217447, 138.5174968707],
    [0.00000050972, 1.79457572126, 151.0476698429],
    [0.0000003993, 3.59559614775, 148.0787244263],
    [0.00000036667, 3.82753352893, 70.8494453042],
    [0.00000026969, 4.71074996908, 78.7137518304],
    [0.00000027205, 4.22769491494, 71.8126531507],
    [0.00000022074, 4.76357435668, 213.299095438],
    [0.00000022655, 4.40615405121, 77.7505439839],
    [0.0000001572, 1.55930265947, 529.6909650946],
    [0.0000001009, 5.83224201984, 145.6310438715],
    [0.00000012912, 1.56375170441, 299.1263942692],
    [0.00000007956, 5.0228752619, 2.9689454166],
    [0.00000008579, 6.26698868752, 222.8603229936],
    [0.00000007534, 0.80106371071, 160.6088973985],
    [0.00000006679, 2.7852838806, 3.9321532631],
    [0.00000005496, 3.31254191722, 77.962992305],
    [0.00000005232, 5.06918050814, 71.6002048296],
    [0.00000004398, 4.52763457543, 380.12776796],
    [0.00000005025, 1.23324638522, 52.6901980395],
    [0.0000000516, 4.31709832477, 225.8292684102],
    [0.0000000331, 3.75868972095, 35.1640902212],
    [0.00000003866, 1.2637098235, 65.2203710117],
    [0.00000003055, 0.62704236969, 152.5321425512],
    [0.00000002433, 5.16881959896, 39.6175083461],
    [0.0000000304, 2.69522691477, 202.2533951741],
    [0.00000002312, 5.05125177167, 22.0914005278],
    [0.00000002685, 0.3934829935, 84.3428261229],
    [0.00000002372, 5.24162482086, 56.6223513026],
    [0.00000002088, 1.79153906168, 220.4126424388],
    [0.00000002085, 3.50728589034, 87.3117715395],
    [0.0000000217, 0.92046078692, 153.4953503977],
    [0.00000001813, 4.5820540042, 146.594251718],
    [0.00000001712, 3.46795755957, 111.4301614968],
    [0.00000001669, 0.52544187039, 184.7272873558],
    [0.0000000169, 3.51435037186, 351.8165923087],
    [0.00000001623, 1.83332553557, 72.3339180125],
    [0.00000001615, 3.22111940844, 79.2350166922],
    [0.00000001443, 0.38490278682, 9.5612275556],
    [0.00000001379, 2.25314683721, 131.4039498699],
    [0.00000001471, 5.65482351957, 67.6680515665],
    [0.00000001513, 1.70291762548, 12.5301729722],
    [0.00000001219, 1.01279910067, 127.4717966068],
    [0.00000001595, 5.26092020655, 62.2514255951],
    [0.00000001392, 2.1904421873, 206.1855484372],
    [0.00000001569, 3.39043730503, 277.0349937414],
    [0.0000000156, 3.27054489518, 36.6485629295],
    [0.00000001162, 0.53527505489, 77.2292791221],
    [0.00000001085, 1.27498553595, 73.8183907208],
    [0.00000001257, 0.04368108516, 18.1592472647],
    [0.00000001047, 0.81042117668, 75.7448064138],
    [0.00000001038, 3.90628138392, 4.4534181249],
    [0.00000000956, 3.66430920732, 74.8934731519],
    [0.00000001052, 2.41090141006, 297.6419215609],
    [0.00000000976, 5.46581402543, 70.3281804424],
    [0.00000001177, 0.17623728581, 426.598190876],
    [0.00000000853, 0.81527596999, 137.0330241624],
    [0.00000000862, 1.76954399486, 305.3461693927],
    [0.00000000726, 2.1975807679, 112.9146342051],
    [0.00000000791, 2.49340799866, 1059.3819301892],
    [0.00000000696, 4.12237397933, 109.9456887885],
    [0.00000000694, 1.89100616611, 92.940845832],
    [0.00000000711, 4.06903566155, 373.9079928365],
    [0.00000000584, 6.17026395543, 81.8951455681],
    [0.0000000066, 4.96483571441, 74.6697239827],
    [0.00000000566, 5.130465689, 490.3340891794],
    [0.00000000559, 0.90292303032, 221.3758502853],
    [0.00000000692, 0.12427497048, 3.1813937377],
    [0.00000000734, 0.6053195787, 38.1330356378],
    [0.00000000532, 3.98648434092, 604.4725636619],
    [0.00000000584, 5.0668954748, 288.0806940053],
    [0.00000000629, 0.54026926209, 96.8729990951],
    [0.00000000561, 4.73267608947, 454.9093665273],
    [0.0000000047, 3.9928038929, 41.1019810544],
    [0.00000000566, 6.02809954245, 191.2076949102],
    [0.00000000507, 2.22687412142, 265.9892934775],
    [0.00000000506, 1.87736218659, 7.1135470008],
    [0.00000000439, 3.41337176747, 80.1982245387],
    [0.0000000041, 2.50600627363, 142.4496501338],
    [0.00000000422, 3.31613690285, 235.3904959658],
    [0.00000000372, 4.59862949974, 536.8045120954],
    [0.00000000371, 0.79783261377, 108.4612160802],
    [0.00000000373, 4.5699608902, 415.5524906121],
    [0.00000000351, 5.99218780431, 186.2117600641],
    [0.00000000407, 4.34825659263, 340.7708920448],
    [0.00000000328, 0.6573822775, 66.70484372],
    [0.00000000372, 5.10831450067, 522.5774180938],
    [0.00000000343, 0.53613562161, 300.6108669775],
    [0.0000000027, 1.27650196236, 703.6331846174],
    [0.00000000278, 4.58530381992, 195.1398481733],
    [0.00000000239, 0.43515793516, 33.1371007917],
    [0.00000000237, 3.8204136745, 617.8058857862],
    [0.00000000235, 4.20082783313, 116.4260963429],
    [0.00000000235, 1.41272118988, 835.0371344873],
    [0.00000000245, 4.77313758758, 41.6444977756],
    [0.00000000198, 0.36712400018, 2.4476805548],
    [0.00000000193, 3.18074408969, 387.2413149608],
    [0.00000000204, 3.17054171814, 211.8146227297],
    [0.00000000242, 1.2387165217, 146.3818033969],
    [0.00000000227, 2.35811929824, 159.1244246902],
    [0.00000000186, 5.03606957476, 14.977853527],
    [0.00000000211, 3.80164653477, 373.0142209592],
    [0.00000000209, 3.12060090889, 227.3137411185],
    [0.00000000166, 3.2646448643, 259.5088859231],
    [0.00000000169, 1.43527176999, 152.7445908723],
    [0.00000000127, 2.56383866135, 140.001969579],
    [0.00000000124, 6.0393700405, 162.0933701068],
    [0.00000000118, 1.35527417493, 114.3991069134],
    [0.0000000011, 1.36513996746, 183.2428146475],
    [0.00000000109, 2.14362406822, 209.3669421749],
    [0.00000000116, 3.42267498449, 228.276948965],
    [0.00000000104, 5.33634525923, 378.6432952517],
    [0.00000000128, 5.42597035936, 230.5645708254],
    [0.00000000115, 1.15568409498, 909.8187330546],
    [0.00000000086, 1.55888062727, 344.7030453079],
    [0.00000000098, 5.72850189948, 154.0166152595],
    [0.00000000104, 5.06629922886, 145.1097790097],
    [0.00000000099, 3.88447445684, 33.6796175129],
    [0.00000000085, 6.1502517387, 269.9214467406],
    [0.00000000085, 3.47642579503, 296.1574488526],
    [0.00000000078, 0.83351167637, 144.1465711632],
];

const VSOP87_B2: Vsop87Element = [
    [0.00000764663, 1.74870957857, 74.7815985673],
    [0.00000055734, Math.PI],
    [0.00000025641, 5.67301557131, 149.5631971346],
    [0.00000013335, 5.92348443969, 73.297125859],
    [0.00000006636, 2.30241577514, 85.8272988312],
    [0.00000004926, 2.21241492976, 76.2660712756],
    [0.00000004368, 0.76649493506, 11.0457002639],
    [0.00000004095, 1.81604424547, 70.8494453042],
    [0.0000000355, 2.72620892642, 224.3447957019],
    [0.00000003556, 0.36898980602, 78.7137518304],
    [0.00000003799, 1.75732801545, 138.5174968707],
    [0.0000000182, 1.54477121376, 77.962992305],
    [0.00000001651, 1.41591379356, 1.4844727083],
    [0.00000001608, 6.22512841748, 213.299095438],
    [0.00000001452, 3.90164387464, 145.6310438715],
    [0.00000001245, 3.04960471697, 529.6909650946],
    [0.00000001689, 0.57422602041, 71.6002048296],
    [0.00000001082, 5.44260490226, 151.0476698429],
    [0.00000001033, 5.50906270157, 63.7358983034],
    [0.00000000979, 4.45089803473, 3.9321532631],
    [0.00000000895, 4.45228515086, 148.0787244263],
    [0.0000000061, 0.69755363233, 71.8126531507],
    [0.00000000724, 4.66998863825, 160.6088973985],
    [0.00000000377, 5.83975114717, 127.4717966068],
    [0.00000000395, 2.05229057211, 77.7505439839],
    [0.00000000333, 3.7658083465, 454.9093665273],
    [0.00000000309, 4.06945653305, 18.1592472647],
    [0.00000000286, 0.1071498385, 220.4126424388],
    [0.00000000281, 5.45374336062, 299.1263942692],
    [0.00000000323, 0.0494867586, 72.3339180125],
    [0.00000000365, 2.39747909046, 56.6223513026],
    [0.00000000258, 3.54572684987, 52.6901980395],
    [0.00000000214, 1.99573431344, 22.0914005278],
    [0.0000000022, 5.12637793339, 3.1813937377],
    [0.00000000134, 4.08992196303, 131.4039498699],
    [0.00000000147, 2.9213955648, 153.4953503977],
    [0.00000000096, 1.97465913947, 225.8292684102],
    [0.00000000076, 1.48178075191, 206.1855484372],
    [0.00000000085, 2.49786959141, 380.12776796],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000021201, 3.16540759295, 74.7815985673],
    [0.00000001182, 4.44441014271, 149.5631971346],
    [0.00000001184, Math.PI],
    [0.00000000433, 1.1037178034, 73.297125859],
    [0.00000000412, 0.43984657946, 76.2660712756],
    [0.00000000466, 5.92951996029, 70.8494453042],
    [0.00000000464, 1.88752032733, 78.7137518304],
    [0.00000000404, 6.16046303283, 85.8272988312],
    [0.00000000401, 1.6892195671, 63.7358983034],
    [0.00000000295, 5.96253146711, 77.962992305],
    [0.00000000294, 1.85767623542, 71.6002048296],
    [0.00000000174, 4.79023778832, 11.0457002639],
    [0.00000000099, 0.42283006135, 224.3447957019],
    [0.00000000088, 2.27837607751, 145.6310438715],
    [0.00000000079, 3.66485269931, 138.5174968707],
];

const VSOP87_B4: Vsop87Element = [[Math.LN2]];

const VSOP87_B5: Vsop87Element = [[Math.LN2]];

const VSOP87_R0: Vsop87Element = [
    [19.21264847206],
    [0.88784984413, 5.60377527014, 74.7815985673],
    [0.03440836062, 0.32836099706, 73.297125859],
    [0.0205565386, 1.7829515933, 149.5631971346],
    [0.0064932241, 4.52247285911, 76.2660712756],
    [0.00602247865, 3.86003823674, 63.7358983034],
    [0.00496404167, 1.40139935333, 454.9093665273],
    [0.00338525369, 1.58002770318, 138.5174968707],
    [0.00243509114, 1.57086606044, 71.8126531507],
    [0.00190522303, 1.99809394714, 1.4844727083],
    [0.00161858838, 2.79137786799, 148.0787244263],
    [0.00143706183, 1.38368544947, 11.0457002639],
    [0.00093192405, 0.17437220467, 36.6485629295],
    [0.00071424548, 4.24509236074, 224.3447957019],
    [0.00089806014, 3.66105364565, 109.9456887885],
    [0.00039009723, 1.66971401684, 70.8494453042],
    [0.00046677296, 1.39976401694, 35.1640902212],
    [0.00039025624, 3.36234773834, 277.0349937414],
    [0.00036755274, 3.88649278513, 146.594251718],
    [0.00030348723, 0.70100838798, 151.0476698429],
    [0.00029156413, 3.180563367, 77.7505439839],
    [0.00020471591, 1.55587964879, 202.2533951741],
    [0.00025620756, 5.25656086672, 380.12776796],
    [0.0002578588, 3.7853770987, 85.8272988312],
    [0.00022637073, 0.72518687029, 529.6909650946],
    [0.00020473534, 2.79640244248, 70.3281804424],
    [0.000179013, 0.55455066863, 2.9689454166],
    [0.00012328114, 5.96037276805, 127.4717966068],
    [0.00014701666, 4.90434516516, 108.4612160802],
    [0.0001149468, 0.43772043395, 65.2203710117],
    [0.00015502375, 5.35405396163, 38.1330356378],
    [0.00010792498, 1.42106296264, 213.299095438],
    [0.00011695693, 3.29824190199, 3.9321532631],
    [0.00011959076, 1.7504339214, 984.6003316219],
    [0.00012896452, 2.62154084288, 111.4301614968],
    [0.00011852959, 0.99344161196, 52.6901980395],
    [0.00009111621, 4.99633582839, 62.2514255951],
    [0.00008420792, 5.25351368389, 222.8603229936],
    [0.00007448995, 0.79495503123, 351.8165923087],
    [0.00008402384, 5.03876467031, 415.5524906121],
    [0.00006046221, 5.67958564987, 78.7137518304],
    [0.00005524411, 3.11493320824, 9.5612275556],
    [0.00007329301, 3.97276588872, 183.2428146475],
    [0.0000544457, 5.10574758517, 145.1097790097],
    [0.00005238203, 2.62960535651, 33.6796175129],
    [0.00004079523, 3.22064116734, 340.7708920448],
    [0.00003801645, 6.10982670905, 184.7272873558],
    [0.00003918728, 4.25017709085, 39.6175083461],
    [0.00002940764, 2.14649735789, 137.0330241624],
    [0.00003781197, 3.45840366912, 456.3938392356],
    [0.00002942224, 0.42392830457, 299.1263942692],
    [0.00003686324, 2.48725993956, 453.424893819],
    [0.00003101496, 4.14028619712, 219.891377577],
    [0.00002962643, 0.82981906774, 56.6223513026],
    [0.00002937579, 3.67652211319, 140.001969579],
    [0.00002864793, 0.30998964462, 12.5301729722],
    [0.0000253811, 4.85443168231, 131.4039498699],
    [0.00001962787, 5.24326793681, 84.3428261229],
    [0.00002363719, 0.44244699485, 554.0699874828],
    [0.00001978408, 6.12838999163, 106.9767433719],
    [0.00002182603, 2.94042519396, 305.3461693927],
    [0.00001963255, 0.04114614586, 221.3758502853],
    [0.00001829781, 4.01105197128, 68.8437077341],
    [0.0000164292, 0.35558129224, 67.6680515665],
    [0.00001584876, 3.16265838848, 225.8292684102],
    [0.00001848022, 2.91116293131, 909.8187330546],
    [0.00001632263, 4.23038575372, 22.0914005278],
    [0.00001402196, 1.3910671015, 265.9892934775],
    [0.00001404021, 5.63567908789, 4.4534181249],
    [0.00001656488, 1.96436491067, 79.2350166922],
    [0.00001248478, 5.44008558936, 54.1746707478],
    [0.00001563396, 1.47919498164, 112.9146342051],
    [0.00001248513, 4.88964506527, 479.2883889155],
    [0.00001197649, 2.52152454056, 145.6310438715],
    [0.00001506943, 5.2418542036, 181.7583419392],
    [0.00001481952, 5.66201356223, 152.5321425512],
    [0.00001439115, 1.53047702403, 447.7958195265],
    [0.00001408871, 4.41921152932, 462.0229135281],
    [0.00001477003, 4.32173218344, 256.5399405065],
    [0.00001228234, 5.97697848866, 59.8037450403],
    [0.00001249895, 6.24480493841, 160.6088973985],
    [0.00000906516, 5.62013120164, 74.6697239827],
    [0.00001090686, 4.15394319904, 77.962992305],
    [0.00000844827, 0.1296605606, 82.8583534146],
    [0.00000900579, 2.37303064621, 74.8934731519],
    [0.00001071649, 1.74298201693, 528.2064923863],
    [0.00000689518, 3.08087933344, 69.3649725959],
    [0.0000059401, 4.50031730404, 8.0767548473],
    [0.00000718644, 4.00028668863, 128.9562693151],
    [0.00000699874, 0.03990034416, 143.6253063014],
    [0.00000575672, 5.89553952415, 66.70484372],
    [0.00000758678, 2.1369380317, 692.5874843535],
    [0.00000710274, 5.41605211553, 218.4069048687],
    [0.00000548663, 5.62811775865, 3.1813937377],
    [0.00000651756, 4.42317051993, 18.1592472647],
    [0.0000053973, 6.20779847549, 71.6002048296],
    [0.00000544899, 5.69409543986, 203.7378678824],
    [0.00000710254, 4.21967520209, 381.6122406683],
    [0.00000594034, 3.83794153459, 32.1951448046],
    [0.00000709902, 4.48962691884, 293.188503436],
    [0.00000705697, 0.4551853916, 835.0371344873],
    [0.00000587851, 5.08268227675, 186.2117600641],
    [0.00000598191, 0.35792534475, 269.9214467406],
    [0.00000642152, 2.71090806243, 87.3117715395],
    [0.0000049564, 2.6511174264, 200.7689224658],
    [0.00000630166, 4.46153551027, 275.5505210331],
    [0.0000057495, 5.57877269214, 2.4476805548],
    [0.00000569622, 1.63924602135, 77.2292791221],
    [0.00000556672, 1.07231890667, 1059.3819301892],
    [0.00000449362, 0.27988155703, 617.8058857862],
    [0.00000463703, 1.43450762802, 297.6419215609],
    [0.00000436536, 0.52783902054, 209.3669421749],
    [0.0000046392, 2.35519668239, 211.8146227297],
    [0.00000435944, 2.10077178384, 1514.2912967165],
    [0.00000515533, 3.23274245907, 284.1485407422],
    [0.00000455004, 4.08342038147, 99.1606209555],
    [0.00000477251, 2.8938165321, 39.3568759152],
    [0.00000542691, 5.39457310701, 278.5194664497],
    [0.00000409903, 3.04961893378, 404.5067903482],
    [0.00000368389, 0.71079545635, 125.9873238985],
    [0.00000503183, 5.8391548775, 191.2076949102],
    [0.000004874, 0.06424307109, 60.7669528868],
    [0.0000045503, 2.59321031027, 490.3340891794],
    [0.00000436349, 2.08129398068, 51.2057253312],
    [0.00000435759, 2.79444435294, 75.7448064138],
    [0.0000032348, 4.82939220481, 195.1398481733],
    [0.00000359344, 0.00870449102, 35.4247226521],
    [0.00000429078, 3.08057776747, 41.1019810544],
    [0.00000319986, 5.48621997496, 14.977853527],
    [0.00000413961, 0.08822621279, 258.0244132148],
    [0.00000379728, 0.05834508997, 378.6432952517],
    [0.00000420206, 2.25392348451, 81.0013736908],
    [0.00000357527, 4.71408309367, 173.9422195228],
    [0.00000358938, 0.35269536425, 426.598190876],
    [0.00000405369, 6.12344979469, 24.3790223882],
    [0.00000365088, 5.59471873032, 255.0554677982],
    [0.00000308155, 3.92316644086, 116.4260963429],
    [0.00000325546, 4.71973290837, 134.5853436076],
    [0.00000292775, 3.99521624654, 72.3339180125],
    [0.00000386408, 0.68629232964, 230.5645708254],
    [0.0000030558, 3.76131538046, 344.7030453079],
    [0.00000286849, 1.8498761975, 153.4953503977],
    [0.00000353346, 4.65720677156, 329.8370663655],
    [0.00000301835, 0.13173596285, 565.1156877467],
    [0.00000241282, 1.6040006132, 81.3738807063],
    [0.00000249797, 4.24206827815, 75.3028634291],
    [0.00000245219, 5.94902281852, 20.6069278195],
    [0.00000248331, 1.06282358803, 105.4922706636],
    [0.00000305353, 2.55534744586, 6208.2942514241],
    [0.0000029637, 4.21095612809, 1364.7280995819],
    [0.00000219939, 2.96120542961, 120.358249606],
    [0.00000233643, 2.97217201792, 46.2097904851],
    [0.00000262427, 3.83657820849, 831.1049812242],
    [0.00000233512, 4.47917715806, 628.8515860501],
    [0.00000187419, 3.03519991355, 135.5485514541],
    [0.000002168, 3.42879551504, 241.6102710893],
    [0.0000025579, 1.16711533037, 177.8743727859],
    [0.00000220463, 0.19626840245, 180.2738692309],
    [0.00000224582, 0.4067414402, 114.3991069134],
    [0.00000205687, 2.30385491694, 259.5088859231],
    [0.00000211135, 4.93079268569, 103.0927742186],
    [0.00000175625, 5.51167774427, 7.1135470008],
    [0.00000188093, 2.23534719993, 5.4166259714],
    [0.00000171643, 5.21732384809, 41.6444977756],
    [0.00000176103, 1.95966779423, 756.3233826569],
    [0.00000170321, 4.95071878484, 206.1855484372],
    [0.00000169478, 4.04293214414, 55.6591434561],
    [0.00000219016, 0.24791955037, 294.6729761443],
    [0.0000018779, 2.04529505651, 408.4389436113],
    [0.00000182258, 0.70728907628, 391.1734682239],
    [0.00000191808, 5.76676964168, 291.7040307277],
    [0.00000153646, 4.7065704527, 543.0242872189],
    [0.00000169989, 4.50972133596, 288.0806940053],
    [0.00000163761, 5.22511628213, 67.3592350258],
    [0.00000194295, 6.11711108749, 414.0680179038],
    [0.00000168295, 5.25802294337, 518.6452648307],
    [0.00000156891, 0.66346387654, 220.4126424388],
    [0.00000182269, 0.78381581992, 417.0369633204],
    [0.000001675, 4.92284198283, 422.6660376129],
    [0.00000170706, 2.30954371717, 98.8999885246],
    [0.00000161764, 3.27144223053, 443.8636662634],
    [0.00000133098, 2.88847467964, 373.9079928365],
    [0.00000161139, 3.82341819072, 451.9404211107],
    [0.00000179288, 4.82418428313, 366.485629295],
    [0.00000178253, 3.98045379191, 10138.5039476437],
    [0.00000142045, 1.2689265649, 159.1244246902],
    [0.00000153749, 4.27847447687, 45.5766510387],
    [0.00000161285, 4.99511779244, 73.8183907208],
    [0.00000146245, 2.65555668221, 465.9550667912],
    [0.00000124849, 4.30472570922, 339.2864193365],
    [0.00000154661, 4.32026115082, 760.25553592],
    [0.00000142885, 2.07772801387, 457.8783119439],
    [0.00000152257, 4.64725594465, 155.7829722581],
    [0.00000116813, 4.43623541426, 5.9378908332],
    [0.0000011336, 4.65468501147, 80.1982245387],
    [0.00000108272, 3.76939374352, 142.4496501338],
    [0.0000013356, 5.30624966763, 14.0146456805],
    [0.0000011629, 2.51243579606, 296.1574488526],
    [0.00000129281, 0.36073764928, 96.8729990951],
    [0.00000122859, 2.38440865925, 141.4864422873],
    [0.00000101683, 1.05650638045, 92.3077063856],
    [0.00000114628, 6.24869783552, 767.3690829208],
    [0.00000113301, 0.83046410321, 100.3844612329],
    [0.00000107414, 2.39445059446, 347.8844390456],
    [0.00000095213, 0.79902536632, 342.2553647531],
    [0.0000011111, 0.38500786215, 216.9224321604],
    [0.00000127294, 0.4239525152, 331.3215390738],
    [0.00000112636, 0.08107841996, 558.0021407459],
    [0.00000103166, 0.69792291595, 358.9301393095],
    [0.00000111707, 0.75072196369, 80.7194894005],
    [0.00000090912, 5.16491055574, 144.1465711632],
    [0.00000090696, 0.2213237742, 333.657345044],
    [0.00000098568, 4.33164222339, 74.5209661364],
    [0.00000089282, 2.18851161054, 74.8297826771],
    [0.00000117046, 3.94988763259, 74.2603337055],
    [0.00000089282, 5.87783530506, 74.7334144575],
    [0.00000097479, 0.69714600982, 977.4867846211],
    [0.00000116587, 1.83677031992, 1289.9465010146],
    [0.00000085652, 5.79984896939, 6.592282139],
    [0.00000086998, 5.61960123914, 300.6108669775],
    [0.00000105424, 5.94521818668, 328.3525936572],
    [0.00000112185, 1.21210217535, 329.7251917809],
    [0.00000082982, 2.20797412496, 74.9416572617],
    [0.00000094527, 4.54115315196, 28.5718080822],
    [0.00000106878, 1.82068770403, 306.830642101],
    [0.00000103534, 2.9937266237, 6.2197751235],
    [0.00000106186, 0.81603278109, 1087.6931058405],
    [0.00000077777, 2.73309413665, 110.2063212194],
    [0.00000098378, 3.73478755861, 75.0422309982],
    [0.00000085982, 2.83236465462, 983.1158589136],
    [0.00000089038, 4.73790965769, 604.4725636619],
    [0.00000083329, 1.88332319315, 387.2413149608],
    [0.0000008516, 1.25690280514, 142.1408335931],
    [0.00000090074, 3.8029787264, 986.0848043302],
    [0.00000074695, 1.35103014238, 350.3321196004],
    [0.00000090483, 0.36671354002, 0.9632078465],
    [0.00000095775, 5.54841186043, 969.6224780949],
    [0.00000082748, 5.85591719177, 74.6215398729],
    [0.00000075723, 2.78001204936, 88.1149206916],
    [0.00000084009, 1.84380973979, 227.3137411185],
    [0.00000070483, 4.65532969655, 44.7253177768],
    [0.00000071348, 3.65007988636, 894.8408795276],
    [0.00000094503, 4.98848650229, 403.1341922245],
    [0.00000089085, 4.43916822737, 154.0166152595],
    [0.0000007939, 5.66990936464, 267.4737661858],
    [0.00000075695, 5.40808174797, 50.4025761791],
    [0.00000068583, 4.76679841387, 991.7138786227],
    [0.00000065256, 0.69286492023, 152.7445908723],
    [0.00000062931, 2.90223286898, 79.889407998],
    [0.00000064054, 0.09529052033, 681.5417840896],
    [0.00000080142, 2.97521726739, 526.722019678],
    [0.00000069651, 3.95227500507, 187.6962327724],
    [0.00000059427, 3.59867941503, 58.1068240109],
    [0.0000005924, 0.51080685499, 28.3111756513],
    [0.00000068652, 2.41879555463, 235.3904959658],
    [0.00000066216, 5.04460437297, 30.7106720963],
    [0.00000070223, 3.73647394236, 546.956440482],
    [0.00000066829, 0.85504819327, 522.5774180938],
    [0.00000062028, 2.3155351706, 74.0308390419],
    [0.00000062958, 0.29182779746, 119.5069163441],
    [0.00000071477, 3.16924790922, 23.5758732361],
    [0.00000074807, 5.36814054526, 373.0142209592],
    [0.00000063852, 2.36782311698, 157.6399519819],
    [0.00000070614, 0.5585579503, 92.940845832],
    [0.00000055762, 5.27011035858, 874.3940104025],
    [0.00000075741, 4.66371340256, 101.8689339412],
    [0.00000073741, 6.20569442158, 312.4597163935],
    [0.00000072959, 0.58417048033, 367.9701020033],
    [0.00000053182, 2.24688972584, 17.5261078183],
    [0.00000063238, 4.59765034931, 67.8804998876],
    [0.00000060717, 0.57546407104, 253.5709950899],
    [0.0000005284, 2.45780676537, 264.5048207692],
    [0.00000070508, 1.51929972323, 552.5855147745],
    [0.00000068624, 2.4450775445, 555.5544601911],
    [0.00000062796, 0.33786296182, 561.1835344836],
    [0.00000049353, 1.09630903572, 19.1224551112],
    [0.00000064619, 5.27406291626, 68.1893164283],
    [0.00000062909, 5.35706460122, 92.0470739547],
    [0.0000004764, 3.90841810802, 192.6921676185],
    [0.00000065137, 3.73959418275, 536.8045120954],
    [0.00000065253, 4.24102184816, 771.3012361839],
    [0.00000059404, 6.10556142565, 365.0011565867],
    [0.00000052269, 1.71514378709, 905.8865797915],
    [0.00000045962, 3.874335532, 210.3301500214],
    [0.0000006216, 2.68143699514, 130.4407420234],
    [0.00000046457, 5.97440565334, 477.8039162072],
    [0.00000046176, 3.89655419144, 48.7580447764],
    [0.00000042915, 3.81993104061, 61.2882177486],
    [0.00000047152, 0.99574606527, 166.828672522],
    [0.00000053843, 2.867487359, 353.301065017],
    [0.00000042114, 2.61910843789, 90.8232336773],
    [0.0000005261, 2.97705829152, 383.0967133766],
    [0.0000004318, 4.15850225489, 173.6815870919],
    [0.00000041297, 1.7992397018, 149.45132255],
    [0.00000044964, 1.76623473669, 0.5212648618],
    [0.00000042836, 1.56965438447, 120.9913890524],
    [0.00000049794, 4.03361534543, 303.8616966844],
    [0.00000045233, 3.5777862545, 97.4155158163],
    [0.00000038695, 2.3940421117, 31.492569389],
    [0.00000038067, 5.79467736188, 75.5323580927],
    [0.00000050252, 4.7645830025, 911.3032057629],
    [0.00000050884, 5.15513957128, 439.782755154],
    [0.0000004282, 5.17313041477, 162.0933701068],
    [0.00000042805, 0.84360648676, 58.319272332],
    [0.00000050343, 5.81599953406, 66.9172920411],
    [0.00000035657, 1.87511529678, 472.1748419147],
    [0.00000045667, 1.9211081498, 55.1378785943],
    [0.00000039992, 1.74263755793, 89.7594520943],
    [0.00000049427, 1.89225881347, 42.5864537627],
    [0.00000044919, 1.48348147872, 450.9772132642],
    [0.00000034282, 5.20397534102, 316.3918696566],
    [0.00000046407, 0.33922791761, 273.1028404783],
    [0.00000037265, 2.03623179153, 117.9105690512],
    [0.00000046107, 5.62298858989, 1819.6374661092],
    [0.00000039368, 4.19402801195, 486.4019359163],
    [0.00000041044, 4.82988044777, 149.6750717192],
    [0.00000044959, 0.72694662195, 3265.8308281325],
    [0.00000043756, 0.75422118122, 404.6186649328],
    [0.00000031823, 3.84768075664, 20.4468691251],
    [0.00000044288, 4.36757729571, 418.2608035978],
    [0.00000038, 3.03175184245, 167.0893049529],
    [0.00000043649, 1.57339867295, 491.5579294568],
    [0.00000033721, 1.26383804364, 260.9933586314],
    [0.00000031278, 4.16119477825, 13.3333221243],
    [0.0000003651, 2.58786153975, 68.5618234438],
    [0.00000039768, 2.8636569438, 468.2426886516],
    [0.0000003629, 1.35814658055, 59.2824801785],
    [0.00000032168, 3.12118521629, 103.3534066495],
    [0.00000033633, 0.15841728793, 24.1183899573],
    [0.00000033723, 0.75503571162, 290.2195580194],
    [0.0000002975, 5.33159349844, 1033.3583763983],
    [0.00000031989, 4.67688193416, 205.2223405907],
    [0.00000035268, 1.00718464333, 1108.1399749656],
    [0.00000030858, 4.62657701145, 258.8757464767],
    [0.0000003285, 5.25352681937, 114.1384744825],
    [0.00000033452, 3.40494756837, 43.1289704839],
    [0.00000031092, 2.26716508311, 104.0077979553],
    [0.00000029723, 5.64053362927, 254.9435932136],
    [0.00000031576, 3.7823710623, 152.0108776894],
    [0.00000034573, 5.17385991822, 25.6028626656],
    [0.00000028153, 3.9268752386, 199.2844497575],
    [0.00000028415, 1.76927009458, 820.0592809603],
    [0.00000028971, 2.58260543469, 76.4785195967],
    [0.00000033643, 5.79472403547, 274.0660483248],
    [0.00000031355, 1.39422550951, 178.7893965226],
    [0.00000029433, 5.93671324356, 280.9671470045],
    [0.00000030136, 0.443733256, 27.0873353739],
    [0.00000033815, 6.26141095251, 401.6497195162],
    [0.00000027513, 2.15290154943, 480.7728616238],
    [0.00000026821, 2.51632690244, 123.5396433437],
    [0.00000026229, 0.22582956326, 286.596221297],
    [0.00000026562, 3.88341102553, 372.4235201282],
    [0.00000034017, 1.44565808735, 88.7962442478],
    [0.0000002774, 4.64687309709, 198.321241911],
    [0.00000029859, 0.82891399431, 100.6450936638],
    [0.00000033948, 1.14432761269, 82.4858463991],
    [0.00000026493, 1.98025893553, 95.3885263868],
    [0.00000024352, 2.37812752505, 146.3818033969],
    [0.00000027244, 2.10487988447, 1057.8974574809],
    [0.00000026337, 0.39684584427, 106.0135355254],
    [0.00000024101, 6.21637542402, 16.6747745564],
    [0.00000031013, 5.3398578805, 476.4313180835],
    [0.00000027036, 0.71198582048, 248.7238180901],
    [0.00000023868, 3.42162769068, 1044.4040766622],
    [0.00000029026, 3.98796449555, 908.3342603463],
    [0.00000024251, 0.36629105441, 73.1852512744],
    [0.00000022897, 2.26875155959, 175.1660598002],
    [0.00000028024, 3.46485782344, 1439.5096981492],
    [0.00000022051, 0.05165872393, 33.1371007917],
    [0.00000022208, 5.32236354206, 483.2205421786],
    [0.00000021075, 0.37096066639, 214.7835681463],
    [0.00000020699, 1.79611118091, 118.0224436358],
    [0.00000027443, 5.75986647976, 1215.1649024473],
    [0.00000025481, 5.4969198547, 115.8835796217],
    [0.00000027703, 4.1192830645, 694.0719570618],
    [0.00000024828, 0.6523800562, 132.8884225782],
    [0.00000021295, 3.86501877873, 66.1835788582],
    [0.00000021146, 1.13726745832, 60.5545045657],
    [0.00000023959, 4.56157429146, 458.8415197904],
    [0.00000026221, 2.77532838847, 490.0734567485],
    [0.00000022973, 4.52937663566, 78.4049352897],
    [0.00000025273, 3.64987288394, 73.4090004436],
    [0.00000026408, 3.3724051836, 49.7212526229],
    [0.0000002687, 3.26028443561, 691.1030116452],
    [0.00000021053, 5.54284102969, 129.9194771616],
    [0.00000020861, 3.92598175503, 134.0640787458],
    [0.00000022933, 5.02405062369, 150.5264049811],
    [0.0000002298, 2.5672758855, 332.8060117821],
    [0.00000020836, 0.98988990409, 29.2049475286],
    [0.00000018891, 1.91272305963, 124.5028511902],
    [0.00000018755, 1.07911898423, 70.1157321213],
    [0.00000023454, 0.60524375676, 189.7232222019],
    [0.00000023104, 3.93171225238, 43.2890291783],
    [0.00000019351, 1.33568544736, 616.3214130779],
    [0.00000023769, 0.02170705684, 593.426863398],
    [0.00000021258, 0.90140026224, 326.8681209489],
    [0.00000019626, 1.40914183189, 1589.0728952838],
    [0.00000018282, 4.55112709109, 165.6048322446],
    [0.00000024502, 0.91753157942, 441.2672278623],
    [0.00000024938, 4.63474678982, 162.8965192589],
    [0.00000018904, 1.23360547168, 13.4933808187],
    [0.00000017364, 5.28602832892, 7.8643065262],
    [0.00000018603, 5.11206439748, 81.8951455681],
    [0.00000017341, 4.0647673679, 403.0223176399],
    [0.00000022513, 3.15059944802, 419.7452763061],
    [0.00000017912, 2.53786076055, 47.061123747],
    [0.00000021237, 2.14856256664, 75.5847477194],
    [0.00000016995, 2.48647736969, 2043.9822618111],
    [0.00000022639, 2.07623129511, 699.7010313543],
    [0.00000023531, 5.80237015057, 232.0490435337],
    [0.00000019255, 1.5662120398, 425.1137181677],
    [0.00000022735, 0.2827454276, 0.1118745846],
    [0.0000002091, 5.30767454224, 237.6781178262],
    [0.00000016146, 3.45551692754, 0.7507595254],
    [0.00000021076, 0.96002144676, 405.9912630565],
    [0.00000017963, 1.60799681102, 215.4379594521],
    [0.00000016289, 4.88888227946, 69.1525242748],
    [0.00000021756, 3.23184546146, 1744.8558675419],
    [0.00000021708, 0.88801367868, 344.9636777388],
    [0.00000015964, 0.34537232571, 77.0692204277],
    [0.00000017286, 6.02968524571, 32.2433289144],
    [0.00000015915, 2.96605572794, 25.8634950965],
    [0.0000001783, 4.01479681257, 280.003939158],
    [0.00000014755, 3.74119528291, 610.6923387854],
    [0.00000015023, 4.24763459617, 228.276948965],
    [0.00000015326, 0.22145354256, 17.2654753874],
    [0.00000015354, 0.25482391126, 661.0949149645],
    [0.00000016424, 3.43626239649, 147.1155165798],
    [0.00000014654, 1.14175759154, 823.9914342234],
    [0.00000015172, 5.07753627325, 114.9416236346],
    [0.00000014674, 1.6817792116, 207.8824694666],
    [0.00000017682, 5.94376629143, 624.919432787],
    [0.00000018848, 1.3845654645, 377.1588225434],
    [0.00000015425, 1.66489033237, 440.6822725257],
    [0.00000014513, 0.39264401278, 142.6620984549],
    [0.00000014672, 4.41834132435, 16.4623262353],
    [0.00000016992, 0.16042368544, 438.2982824457],
    [0.00000016587, 0.92058534977, 369.0820676961],
    [0.00000017239, 4.51659362028, 606.7601855223],
    [0.00000013222, 3.0434010617, 668.2084619653],
    [0.00000014458, 2.93327046597, 419.4846438752],
    [0.00000013238, 0.13650358961, 216.4804891757],
    [0.00000015722, 4.93688742368, 124.2904028691],
    [0.00000012927, 1.65950183059, 54.3347294422],
    [0.00000014216, 4.41971117975, 47.6942631934],
    [0.00000012751, 0.03041331624, 217.2312487011],
    [0.00000014006, 3.6887047076, 16.04163511],
    [0.00000014718, 1.08540409163, 49.5088043018],
    [0.00000017579, 5.05617037261, 564.8550553158],
    [0.00000012945, 1.53551413817, 218.9281697305],
    [0.00000013528, 4.80158552555, 72.7758609972],
    [0.00000012546, 3.43007050169, 958.576777831],
    [0.00000013034, 0.56491831473, 1171.875873269],
    [0.00000012452, 3.29205788475, 902.7051860538],
    [0.00000011963, 1.41057536904, 55.7710180407],
    [0.0000001647, 2.04067746898, 411.620337349],
    [0.00000015604, 1.53457514224, 833.552661779],
    [0.00000014914, 3.42772092084, 19.0105805266],
    [0.0000001204, 5.17744918756, 135.336103133],
    [0.00000014349, 4.18933467558, 89.338760969],
    [0.00000015553, 3.54672509714, 113.8778420516],
    [0.00000015574, 5.92871386562, 778.4147831847],
    [0.00000015424, 2.12697366276, 106.2741679563],
    [0.00000011957, 1.43314130608, 455.8725743738],
    [0.00000015933, 5.49557852242, 513.079881013],
    [0.00000013562, 4.11426797137, 95.2284676924],
    [0.00000012063, 0.20881650176, 65.8747623175],
    [0.00000015093, 1.86345091876, 7.7042478318],
    [0.00000015832, 3.42498484109, 79.5169009825],
    [0.00000011492, 4.6518745562, 149.6113812444],
    [0.00000014516, 3.35209961643, 19.643719973],
    [0.00000011406, 1.31085455047, 63.6240237188],
    [0.00000012043, 0.01569453703, 397.3932433474],
    [0.00000014157, 1.87440535402, 6283.0758499914],
    [0.00000011355, 0.19026820825, 5.6290742925],
    [0.00000014109, 0.09348109699, 6133.5126528568],
    [0.00000011659, 0.84853578994, 5.1078094307],
    [0.00000011052, 0.47607339293, 150.0844619964],
    [0.00000013908, 5.6551430952, 639.897286314],
    [0.00000011505, 5.1947564228, 1182.9215735329],
    [0.00000011492, 2.05801478182, 149.5150130248],
    [0.00000014974, 3.54838066958, 252.6559713532],
    [0.0000001155, 4.78304722906, 334.2904844904],
    [0.00000010671, 4.67373109923, 149.723255829],
    [0.00000010855, 4.52379396618, 453.9461586808],
    [0.00000014218, 0.08018756427, 240.3864308119],
    [0.00000011896, 1.4080319722, 26.0235537909],
    [0.00000013388, 0.76174926716, 37.8724032069],
    [0.0000001086, 4.40226202285, 57.1436161644],
    [0.00000010722, 5.34547451937, 331.2096644892],
    [0.00000012796, 3.70341837855, 67.0773507355],
    [0.00000013353, 0.86919663716, 22.8945496799],
    [0.00000010568, 5.80969806479, 193.655375465],
    [0.00000010324, 2.99970080363, 525.7588118315],
    [0.00000011331, 3.11771273798, 93.9040536785],
    [0.0000001431, 1.06766336398, 477.9157907918],
    [0.00000010296, 3.8144746384, 180.1619946463],
    [0.00000012341, 4.62813430525, 1894.4190646765],
    [0.00000011464, 0.93530139587, 121.8427223143],
    [0.00000012833, 0.31985851817, 474.9468453752],
    [0.00000012455, 2.84950981207, 184.0941479094],
    [0.0000001173, 1.07977388266, 363.5166838784],
    [0.00000010287, 6.03277961834, 43.2408450685],
    [0.00000011395, 4.25533440684, 181.0557665236],
    [0.00000010426, 1.46990536801, 80.4106728598],
    [0.0000001002, 6.22580063292, 84.1827674285],
    [0.00000013895, 3.4634353626, 157.2674449664],
    [0.00000009893, 2.72218970897, 384.0599212231],
    [0.00000010719, 2.47554935503, 140.6563608848],
    [0.00000010964, 3.74557708007, 494.2662424425],
    [0.00000012104, 2.69878200554, 369.4545747116],
    [0.00000009686, 0.0069758008, 40.1600250673],
    [0.00000012385, 1.71007866936, 229.0800981171],
    [0.00000012577, 4.66630955474, 64.6991061499],
    [0.0000001065, 1.78642598254, 252.0865223816],
    [0.00000011653, 5.70662425749, 39.0962434843],
    [0.00000011004, 3.58723041577, 449.2802922348],
    [0.00000010454, 2.81847601796, 1246.6574718363],
    [0.00000009326, 0.97605558757, 109.3125493421],
    [0.00000009261, 5.19861935669, 749.2098356561],
    [0.00000009811, 3.72249796639, 233.9060232575],
    [0.00000010264, 6.08657486312, 156.1554792736],
    [0.00000012406, 0.7620799857, 122.4758617607],
    [0.00000010249, 2.86919673355, 189.1807054807],
    [0.00000012671, 6.19797274264, 149.8238295655],
    [0.00000009589, 1.00839074495, 393.4610900843],
    [0.00000009106, 5.53296926826, 133.1008708993],
    [0.00000010449, 1.23520879648, 148.5999892881],
    [0.00000009923, 5.65994205559, 42.5382696529],
    [0.0000001237, 5.2960237032, 20.4950532349],
    [0.00000010304, 3.56303132976, 619.2903584945],
    [0.00000011103, 5.89715087659, 832.5894539325],
    [0.00000009313, 3.00333916453, 754.8389099486],
    [0.00000010342, 5.50503668014, 460.5384408198],
    [0.00000012219, 3.17057317997, 30.0562807905],
    [0.00000008998, 5.82877688374, 248.4631856592],
    [0.00000010082, 1.9111904865, 25.0603459444],
    [0.00000010991, 0.05720554764, 54.2865453324],
    [0.00000008638, 5.49106676064, 448.6895914038],
    [0.0000000939, 1.32674472289, 9.4011688612],
    [0.00000009621, 5.6909029939, 73.88782669],
    [0.00000010975, 4.40051429814, 63.847772888],
    [0.00000008365, 3.2694361084, 172.1971143836],
    [0.00000009674, 4.27052644727, 282.6640680339],
    [0.0000001077, 0.19304986906, 463.5073862364],
    [0.00000010666, 1.42510087091, 268.4369740323],
    [0.00000010567, 2.61602525339, 446.3113468182],
    [0.00000008495, 5.03708799595, 370.9390474199],
    [0.00000009888, 4.25430313596, 602.9880909536],
    [0.00000010101, 5.04200998723, 241.8709035202],
    [0.0000000889, 2.5332074673, 271.4059194489],
    [0.0000000908, 0.99121734894, 6.9010986797],
    [0.00000010416, 4.96315418372, 97.6761482472],
    [0.0000000879, 3.05434837439, 291.262087743],
    [0.00000007936, 5.71233384542, 541.5398145106],
    [0.00000010152, 1.90464684114, 91.4563731237],
    [0.00000007939, 0.88279344814, 154.979823106],
    [0.00000008212, 0.00845991197, 76.42612997],
    [0.00000007965, 2.36308659035, 196.6243208816],
    [0.00000008948, 4.31891786278, 469.1364605289],
    [0.0000000846, 0.14600703561, 262.4778313397],
    [0.00000009878, 0.61245182735, 308.3151148093],
    [0.0000000912, 5.03217831219, 450.4559484024],
    [0.00000010276, 3.58321573131, 842.1506814881],
    [0.00000008153, 4.60445400464, 69.6737891366],
    [0.00000010625, 2.28659627239, 194.2885149114],
    [0.00000007552, 4.86800510971, 1097.0942747017],
    [0.00000009019, 0.69841869766, 685.4739373527],
    [0.00000007451, 5.67442696266, 337.8019466282],
    [0.00000008011, 4.33417263028, 302.0953396858],
    [0.00000009132, 1.09206046595, 93.7921790939],
    [0.00000009342, 4.16662386065, 15.4991183888],
    [0.00000007411, 3.04632695464, 7.4223635415],
    [0.00000010072, 1.18952866918, 621.7380390493],
    [0.00000008913, 1.33679256423, 0.2606324309],
    [0.00000008189, 3.16576794671, 32.7164096664],
    [0.0000000785, 4.37236255826, 464.4705940829],
    [0.00000008734, 2.03651704284, 149.4031384402],
    [0.00000007745, 0.14834225031, 1404.0849754971],
    [0.00000009037, 3.53203542312, 636.6677084665],
    [0.00000010212, 2.58904966897, 711.4493070338],
    [0.00000008569, 2.47926109895, 497.4476361802],
    [0.00000009591, 1.33938357595, 142.9709149956],
    [0.00000007613, 1.86876737547, 31.6526280834],
    [0.00000008723, 5.88916926012, 82.2039621088],
    [0.00000008997, 2.37079010824, 76.154196691],
    [0.00000007128, 6.2445038363, 376.1956146969],
    [0.00000009686, 5.67475763163, 98.3574718034],
    [0.00000009993, 4.91667894523, 829.6205085159],
    [0.00000007745, 4.87945477576, 310.1720945331],
    [0.00000009812, 3.78656280821, 838.218528225],
    [0.00000008785, 6.14514661123, 17.6379824029],
    [0.000000095, 6.02030079251, 916.9322800554],
    [0.0000000844, 5.06400284478, 1.3725981237],
    [0.00000009802, 1.92874890805, 62.7726904569],
    [0.00000007059, 5.91499106809, 74.1484591209],
    [0.00000007016, 1.52544072246, 679.2541622292],
    [0.00000009577, 1.44268080407, 763.4369296577],
    [0.00000009562, 1.97733085047, 703.6331846174],
    [0.00000007059, 1.94098053303, 75.4147380137],
    [0.00000009214, 0.88741799785, 362.8622925726],
    [0.00000006823, 5.11460794174, 107.4980082337],
    [0.00000007148, 1.73466140387, 1190.7858800591],
    [0.00000009073, 4.31998777457, 16.1535096946],
    [0.00000009126, 3.74417362577, 4.665866446],
    [0.00000007923, 4.6451154044, 232.4215505492],
    [0.00000008828, 1.08177391234, 412.5835451955],
    [0.00000009169, 3.25102587429, 155.5010879678],
    [0.00000007624, 0.88232424215, 459.3627846522],
    [0.000000082, 1.51866334745, 10063.7223490764],
    [0.00000008005, 6.13208431788, 745.277682393],
    [0.00000008579, 2.377262345, 75.6753704446],
    [0.00000007597, 2.63491731877, 657.1627617014],
    [0.00000006398, 0.61376490225, 73.2489417492],
    [0.00000007149, 1.33917289544, 236.8749686741],
    [0.00000006577, 4.82504547981, 1072.7152523135],
    [0.0000000638, 3.20688120531, 73.3453099688],
    [0.00000007506, 0.67400214407, 228.7982138268],
    [0.00000007451, 3.06064473161, 171.6545976624],
    [0.00000006361, 6.05108999867, 95.9792272178],
    [0.00000007086, 4.88497877319, 6531.661656265],
    [0.00000006522, 4.0143169552, 118.8737768977],
    [0.00000006236, 1.08169162104, 143.9341228421],
    [0.000000072, 1.19830150903, 1617.3840709351],
    [0.00000006373, 3.2741194528, 116.5379709275],
    [0.0000000615, 0.03921300469, 627.3671133418],
    [0.00000008664, 5.60425824325, 2810.9214616052],
    [0.00000007635, 4.06598468585, 4.7353024152],
    [0.00000006147, 4.16482048084, 1300.9922012785],
    [0.00000007471, 0.45174255163, 192.8040422031],
    [0.00000008148, 3.11700641874, 10213.285546211],
    [0.00000008603, 3.80404544682, 25558.2121764796],
    [0.00000007593, 2.86863623528, 406.1031376411],
    [0.00000007725, 3.05989382335, 341.9947323222],
    [0.00000007063, 5.35078594952, 73.0364934281],
    [0.00000006762, 1.94867196735, 288.7350853111],
    [0.00000006102, 2.06174377751, 73.9784494152],
    [0.00000006993, 1.24520005325, 400.1652468079],
    [0.00000007856, 3.11320541136, 81.682697247],
    [0.00000006731, 0.00424999029, 572.2292347475],
    [0.00000006688, 0.03046234361, 90.2807169561],
    [0.00000007766, 2.87448427459, 79.4474650133],
    [0.00000007668, 1.71124875127, 104.5290628171],
    [0.00000008317, 2.40731767085, 674.8007441043],
    [0.00000006793, 1.29774355388, 22.633917249],
    [0.00000007732, 1.44266849755, 131.9252147317],
    [0.00000006034, 0.96635268225, 476.3194434989],
    [0.00000006, 3.24980736635, 76.7873361374],
    [0.00000006375, 1.37050567525, 75.1541055828],
    [0.00000005861, 4.31971360878, 86.6304479833],
    [0.0000000719, 3.21396773403, 71.1582618449],
    [0.00000006303, 2.24129466051, 1310.3933701397],
    [0.00000006628, 1.990437442, 1.5963472929],
    [0.00000006263, 3.47620738623, 346.3999663373],
    [0.00000006081, 1.2659989052, 61.448276443],
    [0.00000007312, 5.48372849636, 50.66320861],
    [0.000000073, 5.26774051203, 285.6330134505],
    [0.00000005727, 2.39389303582, 20277.0078952874],
    [0.00000007776, 5.47416512352, 416.7763308895],
    [0.00000005693, 1.13593628568, 445.3481389717],
    [0.00000005794, 2.43359359889, 180.7951340927],
    [0.00000006927, 4.19296597477, 525.2375469697],
    [0.00000007681, 5.64147063245, 549.7284439425],
    [0.0000000668, 5.36285833774, 452.4616859725],
    [0.00000007677, 0.71278975356, 44.070926471],
    [0.00000007734, 5.72717526802, 154.2984995498],
    [0.00000005932, 3.22993254909, 73.4571845534],
    [0.00000005683, 3.65029666464, 442.3791935551],
    [0.00000005788, 2.17544248991, 2.2876218604],
    [0.00000006685, 4.8497109273, 148.8124376092],
    [0.00000005797, 0.51568102763, 149.3025647037],
    [0.00000007739, 3.23104533276, 589.4947101349],
    [0.00000007474, 2.47202834062, 321.7603115182],
    [0.00000006106, 0.81922621826, 89.5993933999],
    [0.00000005522, 1.83812319711, 375.3924655448],
    [0.00000006706, 5.23367324742, 769.8167634756],
    [0.00000006168, 4.58379993316, 137.5542890242],
    [0.0000000721, 2.56243122515, 375.6743498351],
    [0.00000006777, 0.50997508166, 1147.4968508808],
    [0.0000000659, 3.39794943072, 389.6889955156],
    [0.00000006376, 0.24081237769, 881.5075574033],
    [0.00000005829, 6.04973118199, 172.4577468145],
    [0.00000005827, 2.19507738696, 8.9068362498],
    [0.00000005305, 1.977856112, 150.31395666],
    [0.00000005706, 1.66973662153, 70.0462961521],
    [0.00000005422, 1.21990761182, 332.1728723357],
    [0.00000006818, 1.98954025696, 105.380396079],
    [0.00000007235, 2.78896876234, 748.0978699633],
    [0.0000000636, 0.36304095923, 74.4090915518],
    [0.00000005612, 3.4988632804, 102.523325247],
    [0.00000006581, 4.48256802747, 31.2319369581],
    [0.00000006268, 3.59621382047, 488.8496164711],
    [0.0000000636, 0.66780746624, 272.5815756165],
    [0.00000006673, 0.77536194908, 6069.7767545534],
    [0.00000005279, 4.27436629709, 11.1575748485],
    [0.00000005611, 2.40776057824, 1286.0143477515],
    [0.000000059, 0.51262679903, 285.1117485887],
    [0.00000005898, 5.26174074234, 757.8078553652],
    [0.00000005385, 1.77116775784, 139.4807047172],
    [0.00000006198, 0.83056505252, 1507.1777497157],
    [0.00000005425, 1.93107713343, 40.8413486235],
    [0.00000006091, 5.18564204379, 487.1045113319],
    [0.00000005134, 2.61122038772, 194.1766403268],
    [0.00000005505, 1.31212823209, 883.7951792637],
    [0.00000005687, 1.96943472998, 394.3548619616],
    [0.00000006304, 3.02157380188, 442.7517005706],
    [0.00000005027, 4.45266598835, 12.0089081104],
    [0.00000005204, 3.39869589191, 1400.152822234],
    [0.00000006542, 2.31977509408, 328.2407190726],
    [0.00000004969, 6.27367198215, 0.1600586944],
    [0.00000005019, 2.43585264336, 742.9900605326],
    [0.00000005505, 0.3230734679, 40.5807161926],
    [0.00000006432, 2.21948959433, 9999.986450773],
    [0.00000006932, 1.71722830737, 378.9039276826],
    [0.00000005187, 3.04429850681, 1083.7609525774],
    [0.00000004893, 6.06127550285, 980.6681783588],
    [0.00000005791, 3.94061476239, 550.1378342197],
    [0.00000005054, 5.63164324182, 164.1203595363],
    [0.00000005481, 4.36493293939, 233.533516242],
    [0.00000005326, 0.06980162504, 336.8387387817],
    [0.00000006675, 4.68809907572, 312.1990839626],
    [0.00000005777, 2.24316510899, 230.9370778409],
    [0.00000004907, 2.9603946351, 361.3778198643],
    [0.00000006636, 0.3441507572, 511.5954083047],
    [0.00000006333, 0.96579519801, 249.9476583675],
    [0.00000006468, 3.02580538093, 298.2326223919],
    [0.00000005096, 4.22435065058, 65.3804297061],
    [0.00000005159, 3.77051984159, 57.255490749],
    [0.00000004974, 1.21594265105, 455.0694252217],
    [0.00000005785, 5.06114337982, 216.2680408546],
    [0.0000000496, 4.7280621023, 454.7493078329],
    [0.00000005619, 2.27500441196, 227.5261894396],
    [0.00000005161, 2.79823920744, 217.4436970222],
    [0.00000004791, 4.40314095945, 853.196381752],
    [0.0000000545, 6.00971547441, 25.1297819136],
    [0.00000005094, 3.96693309174, 1066.49547719],
    [0.00000006485, 3.02825531498, 167.7224443993],
    [0.00000005396, 5.62885554221, 418.5214360287],
    [0.00000005048, 2.46802064424, 987.5692770385],
    [0.00000006152, 0.79853332272, 2274.5468326365],
    [0.00000006507, 1.72872754258, 125.1841747464],
    [0.00000004734, 0.64940724791, 119.3950417595],
    [0.00000005785, 4.31238502962, 374.4986936675],
    [0.00000006209, 4.78522319194, 270.1820791715],
    [0.00000005381, 5.50204905208, 632.7837393132],
    [0.00000004921, 1.43037646364, 73.1370671646],
    [0.00000004596, 0.55370404346, 35.685355083],
    [0.00000005076, 1.34845106372, 455.0212411119],
    [0.0000000573, 3.30386575677, 88.274979386],
    [0.0000000507, 4.59616483078, 454.7974919427],
    [0.00000004547, 3.81754661073, 1329.3033769298],
    [0.00000006213, 2.58827935033, 544.5087599272],
    [0.00000004825, 6.08615762909, 304.1223291153],
    [0.00000004824, 6.00481294702, 226.7924762567],
    [0.00000005528, 5.69752791882, 548.4409131903],
    [0.00000006054, 0.84188900289, 10.0824924174],
    [0.00000005426, 2.44848284229, 531.978586955],
    [0.00000005047, 2.74537299312, 423.6292454594],
    [0.00000006017, 0.11706831045, 149.0419322728],
    [0.00000005671, 4.76092767065, 491.8185618877],
    [0.00000005866, 6.20513223441, 772.7857088922],
    [0.00000005334, 2.49860553733, 1131.1945833399],
    [0.00000004766, 0.19527580548, 380.3884003909],
    [0.00000004562, 0.55717668871, 253.4591205053],
    [0.00000005777, 4.22586873011, 208.8456773131],
    [0.00000005257, 4.72122908918, 535.3200393871],
    [0.00000004406, 3.42864201394, 144.8973306886],
    [0.00000005174, 1.37808288211, 520.129737539],
    [0.00000004469, 1.67012643165, 1261.6353253633],
    [0.00000004331, 2.64717426456, 1517.2602421331],
    [0.00000004802, 2.6056946352, 177.3049238143],
    [0.00000005206, 0.97973969441, 128.4350044533],
    [0.00000004368, 3.36272561974, 1503.2455964526],
    [0.00000004329, 2.73534631925, 289.5651667136],
    [0.0000000448, 1.66847193407, 357.4456666012],
    [0.00000005386, 5.84886051674, 268.6976064632],
    [0.00000005293, 1.36761627543, 271.61836777],
    [0.00000005277, 0.77780731413, 1670.0742689746],
    [0.00000004812, 4.95769337401, 545.4719677737],
    [0.00000005895, 2.03979596386, 8.5980197091],
    [0.0000000441, 3.23960763864, 973.554631358],
    [0.00000004201, 6.02802824632, 204.7010757289],
    [0.00000004947, 5.50324549674, 365.9006739584],
    [0.00000004553, 2.77414446606, 147.9668498417],
    [0.00000005351, 1.81217833246, 521.0929453855],
    [0.00000004218, 0.73689779266, 1321.4390704036],
    [0.00000005016, 1.91636964972, 535.9107402181],
    [0.00000005188, 1.30753762651, 436.8138097374],
    [0.00000005686, 2.54348150001, 501.3797894433],
    [0.00000004126, 3.00605697657, 136.0698163159],
    [0.00000004341, 3.74899549978, 263.0203480609],
    [0.00000004976, 2.82755706922, 360.4146120178],
    [0.0000000536, 3.99155865541, 92.4195809702],
    [0.00000004935, 5.04375067678, 697.8071683688],
    [0.00000004129, 1.50064332826, 71.8608372605],
    [0.00000004825, 2.90964137048, 551.1010420662],
    [0.00000005036, 4.66411186577, 305.6068018236],
    [0.00000004587, 4.78553156868, 95.931043108],
    [0.00000005054, 5.41201072891, 758.7710632117],
    [0.00000005012, 4.50266403787, 635.9651330509],
    [0.00000005151, 0.41217186078, 968.1380053866],
    [0.00000004247, 0.65406696565, 920.8644333185],
    [0.0000000515, 1.13490701556, 310.9752436852],
    [0.00000004941, 2.84565061722, 406.954470903],
    [0.00000004569, 5.19758291396, 10.2949407385],
    [0.00000004259, 5.53167973839, 184.9879197867],
    [0.00000004604, 2.51643176466, 962.5089310941],
    [0.00000004409, 1.59455204572, 367.5975949878],
    [0.00000005105, 1.26007002216, 971.1069508032],
    [0.000000045, 6.15657007891, 1052.2683831884],
    [0.00000003968, 0.07377679014, 77.7023598741],
    [0.000000039, 1.66467970991, 945.2434557067],
    [0.00000004137, 4.19706074841, 25.2727942655],
    [0.00000004237, 2.80797873442, 213.9534867438],
    [0.00000003899, 4.28674267073, 224.2329211173],
    [0.0000000503, 6.24112139947, 1162.4747044078],
    [0.00000004967, 2.58649417006, 358.4088744477],
    [0.00000003859, 2.72333630141, 818.574808252],
    [0.00000004889, 2.50485923786, 355.7487455718],
    [0.00000004626, 6.00420830249, 421.1815649046],
    [0.00000004765, 4.37822799323, 117.36805233],
    [0.00000003919, 4.81677862044, 893.3564068193],
    [0.00000004287, 3.15207047069, 846.0828347512],
    [0.00000003941, 0.04342429962, 1235.6117715724],
    [0.00000003816, 2.42145744929, 348.8476468921],
    [0.00000004756, 1.32234737789, 238.9019581036],
    [0.00000004077, 5.6885446997, 695.5564297701],
    [0.00000003842, 0.3742937338, 774.4826299216],
    [0.00000004674, 0.08112657673, 1366.2125722902],
    [0.00000005313, 4.38472090135, 689.6185389369],
    [0.00000004578, 0.36908312831, 168.3131452303],
    [0.00000004827, 1.26561568753, 170.7608257851],
    [0.00000004636, 5.93439675803, 148.1905990109],
    [0.00000005128, 0.17600223269, 433.7117378768],
    [0.00000004291, 3.12693688865, 377.4194549743],
    [0.00000003927, 5.59942396205, 1048.3362299253],
    [0.00000004226, 6.24596640453, 448.9714756941],
    [0.00000003776, 1.78756451192, 71.7007785661],
    [0.0000000385, 2.72007090628, 151.850818995],
    [0.00000004561, 0.07201979569, 2349.3284312038],
    [0.00000004291, 5.39929372298, 523.7530742614],
    [0.00000004143, 0.17158866287, 735.8765135318],
    [0.00000003694, 1.44652002583, 48.9181034708],
    [0.00000003728, 1.69745141654, 984.7122062065],
    [0.00000004173, 4.01017634093, 195.7729876197],
    [0.00000004986, 1.03560339271, 224.4566702865],
    [0.00000004031, 0.92145122185, 76.0054388447],
    [0.00000004097, 3.51219407937, 72.4939767069],
    [0.00000003812, 4.41246815759, 1511.3223512999],
    [0.00000004098, 2.39702785276, 239.1625905345],
    [0.00000003751, 5.81981147475, 450.7165808333],
    [0.00000003657, 1.4138849444, 117.3198682202],
    [0.00000004373, 4.08948598951, 75.4359898731],
    [0.00000004765, 4.44775874782, 51.8870488874],
    [0.000000037, 2.04103813925, 63.2146334416],
    [0.00000004436, 5.7658054565, 836.5216071956],
    [0.00000004648, 2.07482117651, 1106.6555022573],
    [0.00000004854, 5.26337784504, 601.5036182453],
    [0.00000003736, 1.46595907948, 138.6293714553],
    [0.00000004304, 3.03122452327, 1109.6244476739],
    [0.0000000402, 0.59697361731, 91.2439248026],
    [0.00000004937, 5.49417275871, 976.7360250957],
    [0.00000003719, 0.11762341199, 1031.87390369],
    [0.00000004036, 2.09041185441, 325.3836482406],
    [0.00000004373, 3.76648561161, 74.1272072615],
    [0.00000004545, 1.35255134812, 41.7563723602],
    [0.00000004172, 0.75349427039, 1500.0642027149],
    [0.0000000419, 5.82534911413, 346.4481504471],
    [0.00000003784, 0.83700163181, 827.9235874865],
    [0.00000004454, 1.87402712883, 141.1776257466],
    [0.00000004853, 0.95917381603, 58.1705144857],
    [0.00000004409, 0.16608106044, 630.3360587584],
    [0.00000003597, 1.02560564655, 515.463871093],
    [0.00000004822, 3.83570312464, 163.5778428151],
    [0.00000004021, 5.68447974866, 3.4902102784],
    [0.00000004244, 3.75845344717, 733.428832977],
    [0.00000003933, 4.55157642432, 240.125798381],
    [0.00000004421, 1.51263319894, 1610.2705239343],
    [0.0000000339, 4.00215380112, 74.9940468884],
    [0.00000004556, 3.41531360523, 1140.38330388],
    [0.00000004171, 0.76417016678, 623.4349600787],
    [0.00000003997, 5.74857613262, 6212.2264046872],
    [0.0000000454, 3.21454634514, 761.7400086283],
    [0.00000004232, 0.8388726758, 176.6505325085],
    [0.00000004098, 1.41920746453, 559.6990617753],
    [0.00000004553, 1.09016692751, 561.8861098992],
    [0.00000003828, 4.08837921098, 268.9582388941],
    [0.00000003598, 5.35099971703, 394.9455627926],
    [0.00000003484, 5.54596330164, 594.9113361063],
    [0.00000003564, 1.57868308864, 354.9979860464],
    [0.00000004279, 2.35436288262, 562.6680071919],
    [0.00000003896, 4.66682485035, 71.9245277353],
    [0.00000004485, 4.71272827101, 731.9443602687],
    [0.00000003398, 1.6208634854, 941.3113024436],
    [0.00000003299, 5.13632919725, 477.0007670551],
    [0.00000004623, 2.72836206211, 6244.9428143536],
    [0.00000003308, 2.60386718967, 14.8177948326],
    [0.00000003435, 2.96178781224, 995.6460318858],
    [0.0000000398, 3.73613153043, 673.316271396],
    [0.00000003623, 0.12701520068, 49.1787359017],
    [0.00000004377, 0.27353840833, 469.7271613599],
    [0.00000003255, 1.24513640154, 82.6459050935],
    [0.00000003323, 4.51516827363, 454.8611824175],
    [0.0000000332, 1.42938752044, 454.9575506371],
    [0.00000003495, 5.61859895107, 1116.0042814918],
    [0.00000003593, 5.35238853915, 57.5161231799],
    [0.00000004196, 1.04465999471, 743.7932096847],
    [0.00000003512, 6.09122971288, 70.5888128733],
    [0.00000003814, 2.49565462974, 6204.362098161],
    [0.00000003828, 4.39752166068, 586.3133163972],
    [0.00000003924, 1.1070704438, 686.958410061],
    [0.00000003356, 6.26211053275, 447.2051186955],
    [0.00000003639, 4.85097208169, 138.4056222861],
    [0.00000003518, 0.52105043625, 262.8078997398],
    [0.00000003671, 1.99667387765, 511.5317178299],
    [0.00000004167, 1.61938375536, 576.1613880106],
    [0.00000003263, 2.27802067614, 295.1942410061],
    [0.00000003215, 0.64628330219, 887.7273325268],
    [0.00000003232, 2.20615118349, 68.631259413],
    [0.00000003279, 3.50509705814, 256.4280659219],
    [0.00000003718, 3.27473813045, 454.6487340964],
    [0.00000003638, 2.63250736806, 455.1699989582],
    [0.00000003459, 3.18851975154, 377.6800874052],
    [0.00000003772, 0.88810300052, 10142.4361009068],
    [0.00000003669, 4.11456655271, 409.9234163196],
    [0.0000000353, 4.02075420346, 388.2045228073],
    [0.00000003163, 1.65300792599, 765.8846102125],
    [0.00000003568, 5.95965909592, 460.8472573605],
    [0.00000003188, 1.74587038709, 18.9100067901],
    [0.00000003305, 5.77382040863, 10.5244354021],
    [0.00000004026, 2.48487699537, 531.1754378029],
    [0.00000003345, 4.15802505352, 1515.7757694248],
    [0.00000003644, 1.78909340323, 251.1714986449],
    [0.00000003525, 2.56091667232, 78114.14622758799],
    [0.00000003147, 5.05814757549, 1521.4048437173],
    [0.00000003155, 0.65831540442, 74.0478853844],
    [0.0000000418, 1.168336748, 514.5643537213],
    [0.00000003255, 1.96741940264, 58.7399634573],
    [0.00000003212, 3.18682610058, 1512.8068240082],
    [0.00000003486, 0.22630227172, 36.5366883449],
    [0.00000003997, 5.58144993177, 57.7980074702],
    [0.00000003628, 2.42977552434, 230.8252032563],
    [0.00000003884, 5.6577084846, 94.4253185403],
    [0.00000003485, 3.26177495276, 36.7604375141],
    [0.00000003506, 6.26633354904, 545.2750258176],
    [0.00000003187, 1.62296832026, 138.4693127609],
    [0.00000003934, 2.86731965547, 832.0681890707],
    [0.00000003115, 5.67364420834, 73.5577582899],
    [0.00000003721, 2.55626754637, 279.4826742962],
    [0.00000003171, 4.85529878165, 138.5656809805],
    [0.00000003108, 3.14860474691, 72.5463663336],
    [0.00000003777, 5.94890597104, 873.1701701251],
    [0.00000004357, 4.15105623366, 10175.1525105732],
    [0.00000003525, 4.8031643597, 429.7795846137],
    [0.00000003382, 1.45717307307, 5983.9494557222],
    [0.00000004161, 5.39091883238, 1363.2436268736],
    [0.00000003537, 4.29176088936, 36.1754821775],
    [0.00000003115, 0.59873966282, 273.8536000037],
    [0.00000003457, 3.94796907904, 444.8268741099],
    [0.00000003593, 3.91831549069, 10134.5717943806],
    [0.000000037, 0.67445695843, 73.9302653054],
    [0.00000003547, 5.63096398237, 440.8947208468],
    [0.00000003622, 1.10742531477, 2250.1678102483],
    [0.00000003562, 3.80604468765, 1525.3369969804],
    [0.0000000333, 1.76480149289, 78.9743842613],
    [0.00000003013, 0.69171521367, 210.8514148832],
    [0.00000003241, 3.65013641564, 335.7749571987],
    [0.00000003032, 5.77852412826, 612.1768114937],
    [0.00000003978, 4.58297442673, 898.7730327907],
    [0.00000003337, 4.81258545559, 597.3590166611],
    [0.00000003141, 3.11768616608, 6607.9277275406],
    [0.00000003696, 1.76581280127, 384.5811860849],
    [0.00000003577, 3.95434949639, 179.3106613844],
    [0.0000000302, 5.0419340802, 197.7999770492],
    [0.00000004082, 3.52781255989, 402.2191684878],
    [0.00000003454, 3.41560919175, 912.7876784712],
    [0.00000003697, 0.89932694516, 75.6329318292],
    [0.00000003238, 1.15084522701, 104.8378793578],
    [0.00000003374, 0.40981508151, 677.7696895209],
    [0.000000035, 4.46985063604, 46.470422916],
    [0.00000003111, 1.88860295507, 34.2008823747],
    [0.00000003953, 0.25645102865, 517.1607921224],
    [0.00000003194, 4.56998602897, 1385.174968707],
    [0.00000003931, 1.09338513303, 388.4651552382],
    [0.0000000293, 4.8814435312, 455.6601260527],
    [0.0000000318, 1.03370427552, 885.4397106664],
    [0.00000003235, 5.09681747179, 464.9918589447],
    [0.00000003173, 5.68964342749, 4.192785694],
    [0.00000003181, 2.87968862974, 9914.1591519418],
    [0.00000003355, 5.45857968674, 73.0846775379],
    [0.00000003951, 5.81493541571, 586.377006872],
    [0.00000002899, 5.12928266291, 448.3170843883],
    [0.00000002903, 1.06370870134, 454.1586070019],
    [0.00000003706, 2.47342147635, 64.2571631652],
    [0.00000003649, 1.90256590579, 31.5407534988],
    [0.0000000336, 4.99299052479, 143.3434220111],
    [0.00000003657, 4.53797912903, 676.2852168126],
    [0.00000003488, 5.62713714766, 3189.5647568569],
    [0.0000000294, 4.33606107945, 78263.70942472259],
    [0.00000003309, 3.10770680369, 519.6084726772],
    [0.00000003781, 4.30315299354, 164.5410506616],
    [0.0000000403, 4.41794838679, 772.5887669361],
    [0.00000003058, 4.84465787968, 221.1634019642],
    [0.00000002867, 5.17129632099, 346.1875180162],
    [0.00000003842, 1.87994191354, 299.7170951002],
    [0.00000002844, 4.34268503622, 262.0571402144],
    [0.00000003724, 4.94511644698, 984.4884570373],
    [0.00000003216, 5.70775867303, 14.6690369863],
    [0.00000002923, 0.37358823115, 6.4804075544],
    [0.00000002931, 0.78809830626, 540.0553418023],
    [0.00000003707, 4.14868763219, 6136.4815982734],
    [0.00000003931, 5.52289695589, 6171.6456884946],
    [0.0000000283, 2.11705330414, 34.5309507748],
    [0.00000003348, 3.08775772849, 245.4942402426],
    [0.00000003394, 2.49196845335, 260.360219185],
    [0.00000003378, 3.82658652472, 25936.85547173129],
    [0.00000003041, 2.14503983522, 6604.958782124],
    [0.00000003657, 6.02755271763, 340.8827666294],
    [0.00000002818, 4.44508352472, 369.342700127],
    [0.00000002865, 3.21935127992, 3.8202786785],
    [0.00000003738, 5.38309514127, 980.146913497],
    [0.00000002797, 5.97725967979, 2014.0265547571],
    [0.0000000328, 0.74832416123, 422.7142217227],
    [0.00000003511, 1.92497000013, 343.4792050305],
    [0.00000002962, 2.29867992492, 661.1586054393],
    [0.00000003603, 2.72183511139, 508.6264628881],
    [0.0000000362, 5.57691156197, 10066.691294493],
    [0.00000003306, 6.20620840278, 11.5669651257],
    [0.00000003279, 6.13563821647, 276.0717858949],
    [0.00000002823, 1.19859134883, 1119.1856752295],
    [0.00000003302, 5.46042536571, 302.3772239761],
    [0.00000002747, 4.5747626302, 226.6324175623],
    [0.00000003814, 3.13695930196, 901.9544265284],
    [0.00000002707, 0.46257342768, 1458.472094566],
    [0.00000003402, 4.84131712548, 714.6788848813],
    [0.00000003346, 1.9097173874, 44.6134431922],
    [0.0000000296, 5.31788128818, 1467.0701142751],
    [0.00000003062, 1.93542241882, 987.7817253596],
    [0.00000003045, 4.24065596268, 170.1701249541],
    [0.00000003504, 4.10521239427, 6280.1069045748],
    [0.00000002674, 1.01129308948, 582.3811631341],
    [0.00000003584, 3.12196206765, 108.7218485111],
    [0.00000002975, 0.13746189123, 9987.4562778008],
    [0.00000002634, 5.61201014857, 412.3710968744],
    [0.00000003702, 0.66231252049, 10101.8553847142],
    [0.00000003526, 4.42297802934, 322.6116447801],
    [0.00000003261, 4.39228048501, 75.3722993983],
    [0.00000002939, 3.26319979871, 130.552616608],
    [0.00000003295, 3.98758407636, 488.5889840402],
    [0.00000002737, 3.15826692829, 683.0262567979],
    [0.00000002915, 1.47424610987, 680.0573113813],
    [0.00000002624, 0.47879556723, 29.226199388],
    [0.00000002678, 1.28275200438, 236.1936451179],
    [0.00000003678, 3.46436124301, 26468.0309095342],
    [0.00000002598, 2.16996571956, 191.3195694948],
    [0.00000002943, 3.58544468129, 12489.8856287072],
    [0.0000000272, 1.24094972893, 989.0537497468],
    [0.00000002894, 2.2699912084, 1615.8995982268],
    [0.00000002985, 4.93091159917, 132.5796060375],
    [0.00000002579, 1.27635624544, 1034.8428491066],
    [0.00000002711, 1.25250599577, 52250.5878817157],
    [0.00000002917, 5.69857391789, 688.6553310904],
    [0.00000003483, 1.97113718781, 655.938921424],
    [0.0000000328, 1.75059058234, 683.9894646444],
    [0.0000000326, 3.46047977615, 74.1908977363],
    [0.00000002936, 2.61715717878, 115.3623147599],
    [0.000000032, 0.66316490563, 457.3570470821],
    [0.00000002565, 3.47443238116, 2042.4977891028],
    [0.00000003158, 4.58160924364, 12492.8545741238],
    [0.00000002719, 2.8954618437, 27.7204748203],
    [0.00000003373, 5.52806001629, 10210.3166007944],
    [0.000000026, 0.31946397676, 85.9391734158],
    [0.00000002619, 4.43681016724, 949.1756089698],
    [0.0000000329, 1.35055242247, 515.6763194141],
    [0.0000000318, 4.49938964982, 694.8382229522],
    [0.00000002586, 4.09771865336, 1448.9108670104],
    [0.00000002574, 5.47692668053, 246.9787129509],
    [0.00000003001, 3.24181300229, 1618.8685436434],
    [0.00000003009, 3.16728117117, 385.7568422525],
    [0.00000002675, 4.91608217296, 754.0357607965],
    [0.00000002535, 0.13831089527, 591.9423906897],
    [0.00000003319, 5.98200177347, 533.8355666788],
    [0.00000003307, 3.31452419197, 732.97125859],
    [0.00000002975, 5.72770980032, 1011.4270345649],
    [0.0000000346, 2.59999470578, 267.5856407704],
    [0.00000002857, 4.11031053901, 2267.4332856357],
    [0.00000002754, 0.78792218586, 229.4526051326],
    [0.00000003422, 6.18592254593, 281.4884118663],
    [0.00000003495, 0.1722463496, 371.5297482509],
    [0.00000002547, 4.45612695304, 901.2207133455],
    [0.00000002476, 1.55163657371, 1234.1272988641],
    [0.0000000338, 3.46612468213, 283.6272758804],
    [0.00000002593, 1.42286075943, 141.6988906084],
    [0.00000002665, 2.98397830634, 250.6020496733],
    [0.00000002424, 3.87508350406, 70.6369969831],
    [0.00000002458, 4.65895339908, 392.6579409322],
    [0.00000002877, 5.47506403197, 1436.5407527326],
    [0.00000002948, 3.49876539234, 123.0183784819],
    [0.00000002739, 6.05181954433, 161.4120465506],
    [0.00000002361, 5.34825180906, 318.679491517],
    [0.00000003221, 1.06289254235, 388.7257876691],
    [0.00000002715, 1.28980431988, 108.982480942],
    [0.00000002392, 2.58938442749, 156.6767441354],
    [0.00000002313, 5.57068624384, 29.7956483596],
    [0.00000002351, 3.65378596351, 112.3933693433],
    [0.00000002768, 5.4225616879, 482.2573343321],
    [0.00000002731, 2.33677247572, 273.1510245881],
    [0.0000000323, 5.65661970187, 134.3728952865],
    [0.00000002685, 5.03687735302, 763.2244813366],
    [0.00000002816, 5.71804752798, 327.4375699205],
    [0.00000002608, 3.11386505876, 578.449009871],
    [0.00000002371, 3.52034351878, 3.6233367224],
    [0.0000000226, 6.23958645351, 400.5746370851],
    [0.00000003089, 5.69639540598, 537.3952129264],
    [0.0000000284, 0.03011890351, 563.3705826075],
    [0.0000000243, 4.24536997427, 27.7417266797],
    [0.000000023, 2.44747995452, 107.918699359],
    [0.00000002756, 0.44285569281, 255.8373650909],
    [0.00000002255, 3.38467700412, 1257.7031721002],
    [0.0000000226, 3.85026258012, 753.1419889192],
    [0.00000002598, 0.43155550046, 175.4266922311],
    [0.00000002319, 6.27990804405, 493.0424021651],
    [0.00000002579, 1.76841912074, 710.7467316182],
    [0.00000002323, 5.19875505188, 380.2396425446],
    [0.00000002426, 0.96570848986, 225.3080035484],
    [0.00000002182, 3.63636403703, 178.1350052168],
    [0.00000002713, 0.64055715691, 424.1505103212],
    [0.0000000285, 5.36388642993, 44.0921783304],
    [0.00000002174, 1.36737239358, 526.5095713569],
    [0.0000000223, 0.18624095003, 309.2783226558],
    [0.00000002691, 3.12857199475, 36.9091953604],
    [0.00000002356, 4.70736394167, 1297.0600480154],
    [0.00000002705, 3.96315420875, 466.7582159433],
    [0.0000000212, 4.00527978646, 78.9262001515],
    [0.0000000279, 4.69333575335, 845.8858927951],
    [0.0000000279, 3.15560752049, 696.3226956605],
    [0.00000002082, 4.28436571612, 1134.1635287565],
    [0.0000000265, 1.97955054585, 421.2297490144],
    [0.0000000235, 2.27006566559, 280.2163874791],
    [0.00000002757, 3.97088429501, 566.3395280241],
    [0.000000024, 2.08287192901, 3116.2676309979],
    [0.00000002091, 4.86268336295, 1222.2784494481],
    [0.00000002402, 4.59336971395, 569.0478410098],
    [0.00000002053, 4.50782983699, 2045.4667345194],
    [0.00000002585, 3.01434261062, 30.5987975117],
    [0.00000002362, 0.28351250494, 25863.55834587229],
    [0.00000002296, 2.43545418785, 52252.07235442399],
    [0.00000002296, 4.03915647243, 52102.50915728939],
    [0.0000000248, 4.82872104445, 702.1487119091],
    [0.00000002394, 2.7184228788, 688.4428827693],
    [0.00000002598, 5.52873150583, 207.3612046048],
    [0.00000002726, 2.73636031357, 320.3240229197],
    [0.00000002686, 3.13615031711, 161.7208630913],
    [0.00000002651, 4.31467866101, 639.6366538831],
    [0.00000001999, 3.81218083941, 122.0551706354],
    [0.00000002454, 4.63684196748, 1012.9115072732],
    [0.00000001998, 4.34234332604, 343.2185725996],
    [0.00000001982, 1.04358448861, 76.3142553854],
    [0.00000002651, 4.50494915824, 6209.7787241324],
    [0.00000002315, 2.16329763901, 380.0158933754],
    [0.00000002012, 0.58027132344, 530.6541729411],
    [0.00000001987, 2.34515279356, 768.8535556291],
    [0.00000002062, 5.14612272595, 68.3011910129],
    [0.00000001998, 4.72846905297, 76.2178871658],
    [0.00000002501, 1.46803291637, 95.2766518022],
    [0.00000002564, 2.20950808655, 566.600160455],
    [0.00000002569, 1.6864211704, 749.5823426716],
    [0.00000002047, 4.43426104911, 229.340730548],
    [0.00000002226, 1.08954827693, 383.3091616977],
    [0.00000002046, 3.37543676127, 1055.4497769261],
    [0.00000001954, 2.49907098662, 313.9441891018],
    [0.00000002177, 3.00048235729, 317.8763423649],
    [0.00000002238, 0.97968512796, 147.5574595645],
    [0.00000002148, 0.16770637484, 112.6540017742],
    [0.0000000235, 5.77036099171, 304.2342036999],
    [0.00000002183, 5.58654428071, 428.0826635843],
    [0.00000002063, 5.64116701319, 73.6696328745],
    [0.00000002535, 1.1355489711, 140.9651774255],
    [0.00000002445, 0.65211381551, 271.6665518798],
    [0.00000002072, 2.29027742046, 696.5196376166],
    [0.0000000208, 1.24910729957, 311.2840602259],
    [0.00000001912, 3.75992027324, 528.7277572481],
    [0.00000002063, 2.21480458793, 75.8935642601],
    [0.00000002107, 4.64640498877, 150.3663462867],
    [0.00000001883, 5.29259430554, 381.0909758065],
    [0.00000002562, 1.42062915032, 551.2129166508],
    [0.00000002062, 0.46104612533, 386.0656587932],
    [0.00000001916, 5.84122649523, 481.7360694703],
    [0.00000002333, 4.77162438255, 347.9326231554],
    [0.00000002156, 2.11521771652, 1250.5896250994],
    [0.00000002347, 1.97105922216, 188.2387494936],
    [0.00000002034, 5.51423990497, 678.3603903519],
    [0.00000002321, 3.54031153946, 103.9865460959],
    [0.00000001833, 5.62091026321, 840.6662087798],
    [0.00000002378, 6.0007378545, 664.1275508559],
    [0.00000001896, 2.15809918048, 379.1645601135],
    [0.00000001809, 5.61397062326, 14.2270940016],
    [0.00000002262, 4.5851769094, 430.5303441391],
    [0.00000001933, 0.42376762202, 915.4478073471],
    [0.00000001933, 5.10325064461, 1065.0110044817],
    [0.00000002083, 4.96820157485, 294.3004691288],
    [0.00000001797, 2.39655065767, 311.9384515317],
    [0.00000001797, 0.79284837309, 461.5016486663],
    [0.00000001865, 1.13583348993, 739.0579072695],
    [0.00000001865, 5.81531651252, 888.6211044041],
    [0.00000001793, 5.7880461393, 625.8826406335],
    [0.00000001947, 5.79903258109, 257.3912737684],
    [0.00000002462, 3.9591678311, 26.826702943],
    [0.00000002317, 0.68746265782, 625.9945152181],
    [0.00000002107, 0.10366607161, 1002.7595788866],
    [0.00000002174, 4.30981640926, 221.8971151471],
    [0.00000001883, 4.16371906934, 213.1872208534],
    [0.00000001991, 2.15389092541, 507.5995645668],
    [0.0000000181, 3.70831888738, 539.2521926502],
    [0.00000001991, 5.06761957393, 255.57673266],
    [0.00000001812, 0.78741962695, 151.260118164],
    [0.00000001964, 2.71891117329, 1024.217839968],
    [0.00000002252, 4.45925757192, 598.5346728287],
    [0.00000001804, 2.34130589983, 80.9319377216],
    [0.00000001854, 0.13193495049, 1396.9714284963],
    [0.00000001854, 4.81141797308, 1546.5346256309],
    [0.00000002186, 2.58979636823, 76.5267037065],
    [0.00000001763, 5.59121902178, 947.6911362615],
    [0.00000001763, 0.91173599918, 798.1279391269],
    [0.00000001816, 0.95956155095, 156.043604689],
    [0.00000002202, 2.18092416439, 583.8656358424],
    [0.0000000191, 2.64138421542, 498.1983957056],
    [0.0000000191, 4.24508650001, 348.635198571],
    [0.00000002215, 2.45791819477, 154.5591319807],
    [0.00000002322, 6.16493439544, 3340.6124266998],
    [0.00000001895, 2.0239663472, 467.4395394995],
    [0.00000001943, 4.41537853646, 185.5786206177],
    [0.00000001738, 2.44168217704, 913.0001267923],
    [0.00000002046, 2.19760587122, 882.9920301116],
    [0.0000000183, 1.16794111151, 47.2735720681],
    [0.00000002143, 5.26070898677, 42.0651889009],
    [0.000000022, 5.8975093892, 10139.988420352],
    [0.00000001677, 1.72367555591, 975.0391040663],
    [0.00000001677, 3.26140378877, 1124.6023012009],
    [0.00000001776, 5.05356646709, 956.2891559706],
    [0.00000002115, 3.10908283877, 84.8640909847],
    [0.00000002116, 4.50159315432, 269.0701134787],
    [0.0000000177, 2.96002469436, 1459.9565672743],
    [0.00000001807, 3.84800342064, 529.57909051],
    [0.0000000187, 2.9336511131, 1208.0513554465],
    [0.0000000187, 4.47137934596, 1357.6145525811],
    [0.00000001891, 1.70111414825, 190.665178189],
    [0.0000000206, 5.06581864584, 26013.1215430069],
    [0.00000001835, 4.7112058249, 76.1060125812],
    [0.0000000202, 1.67687010626, 354.7855377253],
    [0.00000001733, 2.43404581799, 187.2755416471],
    [0.00000001641, 0.46152323273, 303.0585475323],
    [0.00000001671, 0.67572104809, 154.6710065653],
    [0.00000001696, 3.15463633411, 398.2870152247],
    [0.00000001968, 5.83082526219, 195.4004806042],
    [0.0000000223, 1.7680194688, 624.5100425098],
    [0.00000002151, 3.33296618401, 552.6973893591],
    [0.00000001674, 3.34095983797, 316.6525020875],
    [0.00000002029, 2.07844879451, 199.8538987291],
    [0.00000002029, 0.47474650993, 349.4170958637],
    [0.00000002114, 3.86984575671, 81.2620061217],
    [0.00000002147, 5.6393177255, 590.8304249969],
    [0.00000001706, 0.73548513365, 961.0244583858],
    [0.00000001706, 2.33918741824, 811.4612612512],
    [0.00000001822, 1.64784768077, 473.4623726669],
    [0.00000001822, 3.25154996536, 323.8991755323],
    [0.00000001909, 5.58002039864, 6134.9971255651],
    [0.00000002061, 3.34168764903, 6.8529145699],
    [0.00000001846, 4.3315401475, 1396.2206689709],
    [0.00000001879, 4.21685982495, 52.1476813183],
    [0.00000001937, 2.04746615092, 367.8582274187],
    [0.00000001937, 3.58519438379, 517.4214245533],
    [0.00000001884, 1.88048876898, 12.1576659567],
    [0.00000001602, 1.46373302224, 325.9530972122],
    [0.00000001754, 4.23029342972, 539.0921339558],
    [0.00000001645, 6.23273743453, 782.3469364478],
    [0.00000002153, 1.61615068478, 587.8614795803],
    [0.00000001702, 2.46774061252, 407.4757357648],
    [0.00000001602, 4.95996654045, 487.1526954417],
    [0.00000001576, 3.95360340011, 2077.7624530605],
    [0.00000001576, 2.41587516724, 1928.1992559259],
    [0.00000001576, 5.4438886119, 532.1386456494],
    [0.0000000188, 1.41060159, 575.2676161333],
    [0.0000000188, 6.0900846126, 724.8308132679],
    [0.00000001596, 5.33991691502, 34.6215735],
    [0.00000001624, 1.21716384102, 475.5162943468],
    [0.00000001803, 0.60015233109, 529.8028396792],
    [0.00000001662, 3.50151803039, 484.7050148869],
    [0.00000001735, 1.01657070139, 196.8849533125],
    [0.00000001584, 0.28218018153, 1811.773159583],
    [0.00000001804, 6.08380488717, 188.6594406189],
    [0.00000001758, 0.5321154964, 550.8885937451],
    [0.00000001758, 2.06984372926, 700.4517908797],
    [0.00000001573, 5.3835015322, 461.1291416508],
    [0.00000001667, 0.24230138722, 556.5176680376],
    [0.00000001559, 6.02213221899, 343.7398374614],
    [0.00000001796, 5.78444078662, 525.4981794006],
    [0.00000001563, 0.8061744441, 563.6312150384],
    [0.00000001603, 4.38109882376, 59.5912967192],
    [0.00000001606, 1.83958629336, 1349.7502460549],
    [0.00000001606, 3.44328857794, 1200.1870489203],
    [0.00000001665, 3.75333799201, 764.7089540449],
    [0.00000001665, 2.14963570742, 914.2721511795],
    [0.00000001741, 0.81651703967, 548.2439712342],
    [0.00000001766, 2.00418474011, 495.9631634719],
    [0.0000000198, 4.53192980595, 1054.9285120643],
    [0.0000000198, 2.99420157308, 905.3653149297],
    [0.00000002146, 2.25428923199, 67.9286839974],
    [0.0000000156, 3.27821444787, 1208.9451273238],
    [0.00000001695, 2.26284891229, 493.303034596],
    [0.0000000194, 4.17311496384, 981.6313862053],
    [0.00000002135, 5.07005192745, 245.5424243524],
    [0.00000001604, 4.06884840529, 1136.4511506169],
    [0.00000001703, 2.08965979965, 274.5873131866],
    [0.00000001678, 0.30302488401, 1297.8631971675],
    [0.00000002086, 3.24437004031, 516.0488264296],
    [0.00000001505, 0.3862283384, 509.0840372751],
    [0.00000001631, 0.44359079978, 806.725958836],
    [0.00000001544, 4.38766645261, 206.706813299],
    [0.00000001495, 4.52648520007, 234.4967240885],
    [0.00000001549, 0.99024664404, 834.0739266408],
    [0.00000001549, 5.73570371835, 684.5107295062],
    [0.00000002013, 5.61129200002, 81.6345131372],
    [0.0000000195, 0.19680015179, 118.0706277456],
    [0.00000001943, 5.23985037412, 14.5571624017],
    [0.00000001483, 0.49824817575, 1020.8282034261],
    [0.00000001483, 2.03597640861, 1170.3914005607],
    [0.00000001482, 4.41190841719, 170.7126416753],
    [0.00000001902, 2.0710383254, 15.1903018481],
    [0.00000001493, 2.1365672033, 10.9338256793],
    [0.00000001702, 2.7847833526, 844.5983620429],
    [0.00000001914, 6.05987746357, 1211.2327491842],
    [0.00000002038, 1.60297482666, 6588.4220193841],
    [0.00000001689, 3.06284907974, 0.8031491521],
    [0.00000001685, 0.28381539862, 521.6142102473],
    [0.00000001734, 3.45650791724, 1895.9035373848],
    [0.00000001636, 1.62858153403, 164.3809919672],
    [0.00000001602, 0.20642761616, 64.4866578288],
    [0.000000018, 2.99044739237, 101.6083015103],
    [0.00000001867, 2.92532022361, 6060.2155269978],
    [0.00000001822, 4.31796502202, 934.1977554428],
    [0.0000000166, 5.69708947634, 1291.4309737229],
    [0.00000002, 5.18442514436, 452.2010535416],
    [0.00000001573, 2.39570178134, 614.8369403696],
    [0.00000001446, 6.12512087543, 568.2970814844],
    [0.00000001446, 4.58739264257, 418.7338843498],
    [0.00000001432, 1.97954511274, 504.561183181],
    [0.00000001578, 4.62126447177, 669.6929346736],
    [0.00000001773, 3.00675487512, 16.9835910971],
    [0.00000001514, 0.35161589106, 403.7036411961],
    [0.00000001888, 3.89724586598, 1440.9941708575],
    [0.000000019, 3.58215504368, 3192.5337022735],
    [0.00000001747, 4.07850521042, 6346.8117482948],
    [0.00000001747, 2.54077697756, 6197.2485511602],
    [0.00000001683, 1.9223528062, 181.6464673546],
    [0.00000001587, 4.9976178222, 6057.2465815812],
    [0.00000001889, 0.62618826487, 1129.7101106316],
    [0.00000001753, 1.82324191014, 1020.025054274],
    [0.00000001753, 3.360970143, 1169.5882514086],
    [0.00000001407, 3.8766789322, 904.1896587621],
    [0.00000001658, 0.17315209135, 170.0100662597],
    [0.00000001612, 4.71519560888, 370.0452755426],
    [0.00000001456, 5.78909667336, 415.6643651967],
    [0.00000001472, 3.92804806651, 212.3358875915],
    [0.00000001776, 5.89527317383, 1593.808197699],
    [0.00000001776, 4.29157088924, 1743.3713948336],
    [0.00000001398, 2.89266999881, 376.9463742223],
    [0.00000001936, 3.02716801943, 10518.6317156037],
    [0.00000001423, 1.34276219051, 302.7497309916],
    [0.00000001929, 4.65175583668, 2199.7652340692],
    [0.0000000193, 3.81505372582, 543.9180590962],
    [0.00000001581, 4.28040315071, 375.934982266],
    [0.00000001621, 2.21372960034, 362.0322111701],
    [0.00000001629, 4.08549980424, 340.5102596139],
    [0.00000001756, 1.24206336045, 555.6663347757],
    [0.00000001391, 4.05514082167, 623.2225117576],
    [0.0000000148, 0.85968170103, 557.0389328994],
    [0.00000001421, 0.13443282384, 1523.6924655777],
    [0.00000001421, 1.73813510842, 1374.1292684431],
    [0.00000001399, 1.64961108641, 356.2700104336],
    [0.00000001847, 1.78123333872, 25939.82441714789],
    [0.00000001466, 0.75306338987, 2.0057375701],
    [0.00000001461, 3.67524662572, 139.1718881765],
    [0.00000001453, 4.69267570928, 746.7621551013],
    [0.0000000145, 3.85293024011, 907.3710524998],
    [0.00000001369, 1.34933149459, 1130.2313754934],
    [0.0000000142, 2.79221953555, 396.5419100855],
];

const VSOP87_R1: Vsop87Element = [
    [0.01479896629, 3.67205697578, 74.7815985673],
    [0.00071212143, 6.22600975161, 63.7358983034],
    [0.0006862716, 6.13411179902, 149.5631971346],
    [0.00020857554, 5.2462584896, 11.0457002639],
    [0.00021468362, 2.60175716374, 76.2660712756],
    [0.00024059369, Math.PI],
    [0.00011405056, 0.01849738017, 70.8494453042],
    [0.00007496797, 0.42361355955, 73.297125859],
    [0.00004243606, 1.41691058162, 85.8272988312],
    [0.00003505951, 2.58348117401, 138.5174968707],
    [0.000032288, 5.25495561645, 3.9321532631],
    [0.00003926833, 3.15526349399, 71.8126531507],
    [0.00003059899, 0.15323842112, 1.4844727083],
    [0.00003578254, 2.31157935775, 224.3447957019],
    [0.00002564235, 0.98078549108, 148.0787244263],
    [0.00002429191, 3.99450740432, 52.6901980395],
    [0.0000164483, 2.65310351864, 127.4717966068],
    [0.00001583569, 1.4304953436, 78.7137518304],
    [0.0000141338, 4.57461623347, 202.2533951741],
    [0.00001489724, 2.67568435302, 56.6223513026],
    [0.0000140328, 1.36986207457, 77.7505439839],
    [0.00001227894, 1.04699377171, 62.2514255951],
    [0.00001507836, 5.06019185241, 151.0476698429],
    [0.00000991944, 2.1718165585, 65.2203710117],
    [0.00001032728, 0.26473484111, 131.4039498699],
    [0.00000861752, 5.05508815872, 351.8165923087],
    [0.00000744512, 3.07725212553, 35.1640902212],
    [0.00000603966, 0.90716451094, 984.6003316219],
    [0.00000647014, 4.47286717163, 70.3281804424],
    [0.00000574672, 3.2306914554, 447.7958195265],
    [0.00000687477, 2.49910872963, 77.962992305],
    [0.00000623247, 0.86227007749, 9.5612275556],
    [0.00000527867, 5.15141241909, 2.9689454166],
    [0.00000561872, 2.71781314149, 462.0229135281],
    [0.0000053053, 5.91685160971, 213.299095438],
    [0.00000459886, 4.22296426568, 12.5301729722],
    [0.00000494251, 0.4632180053, 145.6310438715],
    [0.00000487371, 0.70688896635, 380.12776796],
    [0.00000380709, 3.85094436388, 3.1813937377],
    [0.00000444185, 2.15555848995, 67.6680515665],
    [0.00000338646, 2.53719277381, 18.1592472647],
    [0.00000372951, 5.05141758574, 529.6909650946],
    [0.00000348335, 1.74875375735, 71.6002048296],
    [0.00000405615, 1.22950417858, 22.0914005278],
    [0.00000268994, 6.2420480531, 340.7708920448],
    [0.0000025586, 2.95699944505, 84.3428261229],
    [0.00000259244, 3.92085033287, 59.8037450403],
    [0.00000224702, 3.90949421678, 160.6088973985],
    [0.00000221874, 3.64708443278, 137.0330241624],
    [0.00000254339, 3.50524488134, 38.1330356378],
    [0.000002382, 2.04842095939, 269.9214467406],
    [0.00000272459, 3.38353829996, 222.8603229936],
    [0.000002006, 1.24854381161, 69.3649725959],
    [0.00000234216, 0.27861629739, 108.4612160802],
    [0.00000188802, 4.41158620525, 265.9892934775],
    [0.00000212138, 0.68012161063, 111.4301614968],
    [0.00000205992, 1.53361539719, 284.1485407422],
    [0.00000196457, 4.77133840382, 299.1263942692],
    [0.00000153201, 5.21574674133, 209.3669421749],
    [0.00000163544, 4.34120077587, 33.6796175129],
    [0.00000150382, 1.98905719076, 54.1746707478],
    [0.00000136927, 0.40354426815, 195.1398481733],
    [0.00000117521, 0.39618046394, 87.3117715395],
    [0.00000128577, 2.40591376513, 39.6175083461],
    [0.00000104684, 2.91746030897, 134.5853436076],
    [0.0000010387, 1.81603765254, 72.3339180125],
    [0.00000106087, 0.17146170085, 79.2350166922],
    [0.00000106822, 0.69945014388, 2.4476805548],
    [0.00000094904, 4.02460487466, 82.8583534146],
    [0.00000104645, 4.43615418997, 305.3461693927],
    [0.00000093832, 5.01799603662, 51.2057253312],
    [0.00000103733, 2.57520994669, 191.2076949102],
    [0.0000010682, 1.22984965801, 225.8292684102],
    [0.0000009358, 3.09257295667, 77.2292791221],
    [0.00000097607, 3.8140415956, 152.5321425512],
    [0.00000084782, 5.72500693196, 68.8437077341],
    [0.00000077488, 0.08155105577, 45.5766510387],
    [0.00000076047, 4.2042219855, 73.8183907208],
    [0.00000086387, 0.53091293351, 145.1097790097],
    [0.00000075755, 3.78546185557, 75.7448064138],
    [0.00000077592, 1.63627982289, 479.2883889155],
    [0.0000008478, 0.61510586137, 116.4260963429],
    [0.00000100494, 4.93994320097, 120.358249606],
    [0.00000071979, 4.30613043603, 565.1156877467],
    [0.00000071236, 2.38119498898, 60.7669528868],
    [0.00000071539, 3.93757368948, 153.4953503977],
    [0.00000084837, 5.55880391517, 344.7030453079],
    [0.00000063516, 1.93751130249, 41.6444977756],
    [0.00000071587, 3.7120401109, 408.4389436113],
    [0.00000061914, 3.90141588459, 4.4534181249],
    [0.00000065088, 1.55911828467, 106.9767433719],
    [0.00000060091, 0.60112111486, 74.8934731519],
    [0.00000061828, 4.39028435621, 453.424893819],
    [0.00000063246, 4.18799696764, 184.7272873558],
    [0.00000062339, 3.23753339104, 422.6660376129],
    [0.00000054893, 3.72792577723, 7.1135470008],
    [0.00000052457, 6.08632045364, 404.5067903482],
    [0.00000053071, 3.51022280941, 125.9873238985],
    [0.00000059034, 1.55684840494, 456.3938392356],
    [0.00000058831, 5.33573241567, 220.4126424388],
    [0.00000052838, 5.20104115605, 358.9301393095],
    [0.00000052878, 4.44628349017, 426.598190876],
    [0.00000055201, 1.60181891958, 14.977853527],
    [0.00000050997, 0.52968367981, 490.3340891794],
    [0.00000049541, 4.25523625544, 5.4166259714],
    [0.00000051389, 0.37029408817, 206.1855484372],
    [0.00000051834, 1.7547806765, 8.0767548473],
    [0.00000056742, 0.8389113562, 146.594251718],
    [0.00000049107, 0.94051631401, 99.1606209555],
    [0.00000045714, 5.34241750716, 152.7445908723],
    [0.00000048197, 1.97584360072, 288.0806940053],
    [0.00000044024, 3.03717070644, 20.6069278195],
    [0.00000049092, 5.84636334727, 112.9146342051],
    [0.00000041989, 0.0489566624, 128.9562693151],
    [0.00000048335, 3.62867663323, 81.0013736908],
    [0.00000041451, 2.33805925587, 277.0349937414],
    [0.00000040161, 5.0967211278, 35.4247226521],
    [0.00000041968, 2.50991447143, 24.3790223882],
    [0.00000038204, 3.61405134343, 173.9422195228],
    [0.00000038414, 2.06063652881, 333.657345044],
    [0.00000042597, 1.260887373, 1514.2912967165],
    [0.00000038855, 0.74315611802, 347.8844390456],
    [0.00000038552, 4.95041145803, 92.940845832],
    [0.00000033234, 1.38358507432, 74.6697239827],
    [0.00000033788, 3.68407945156, 66.9172920411],
    [0.00000039054, 5.4970292656, 200.7689224658],
    [0.00000031786, 0.54344835858, 203.7378678824],
    [0.00000033322, 6.26106483857, 1059.3819301892],
    [0.00000030806, 2.53797566903, 977.4867846211],
    [0.00000030059, 0.19481253674, 387.2413149608],
    [0.0000002912, 5.44130853027, 58.1068240109],
    [0.00000028997, 3.10546504714, 991.7138786227],
    [0.00000027827, 0.36512476794, 80.1982245387],
    [0.00000035694, 3.72852678524, 96.8729990951],
    [0.00000032516, 4.3844786763, 221.3758502853],
    [0.0000002684, 1.35294770385, 0.9632078465],
    [0.00000031276, 0.79566551587, 373.0142209592],
    [0.00000025922, 3.45840169631, 144.1465711632],
    [0.00000031032, 2.06301188151, 230.5645708254],
    [0.00000030278, 0.71358545978, 109.9456887885],
    [0.00000024834, 3.04814439142, 14.0146456805],
    [0.00000025206, 5.12301274564, 81.3738807063],
    [0.00000027765, 4.75859307922, 415.5524906121],
    [0.00000025582, 2.56904012503, 522.5774180938],
    [0.00000024351, 2.20288762433, 628.8515860501],
    [0.00000024132, 5.67351884701, 443.8636662634],
    [0.00000025491, 1.78473889586, 143.6253063014],
    [0.00000024065, 0.6701080534, 46.2097904851],
    [0.00000025679, 5.43185950755, 546.956440482],
    [0.00000024624, 3.30585050808, 617.8058857862],
    [0.00000024242, 5.59897471399, 32.1951448046],
    [0.0000002239, 4.82189515313, 135.5485514541],
    [0.00000027179, 2.02720095476, 536.8045120954],
    [0.00000021973, 4.59216176679, 241.6102710893],
    [0.00000022055, 4.61793641919, 391.1734682239],
    [0.00000020834, 0.24550904041, 465.9550667912],
    [0.00000027275, 2.15420645259, 140.001969579],
    [0.00000023632, 4.94972840898, 561.1835344836],
    [0.00000021149, 5.27166890173, 159.1244246902],
    [0.00000023328, 3.80624099549, 55.1378785943],
    [0.00000020015, 1.30330553666, 518.6452648307],
    [0.00000024853, 0.5339855631, 181.7583419392],
    [0.00000020058, 4.88841177982, 909.8187330546],
    [0.00000019193, 1.31168318333, 543.0242872189],
    [0.00000020801, 0.91178178054, 76.4785195967],
    [0.0000001899, 4.67975156701, 98.8999885246],
    [0.00000019667, 0.66620464883, 66.70484372],
    [0.00000025922, 4.52830002662, 454.9093665273],
    [0.00000018833, 6.0804245163, 103.0927742186],
    [0.00000021624, 1.23560892029, 41.1019810544],
    [0.00000018091, 0.96586313214, 55.6591434561],
    [0.00000021264, 4.1951431552, 329.7251917809],
    [0.00000018717, 5.77529020491, 142.4496501338],
    [0.00000019415, 4.31464975363, 6.2197751235],
    [0.00000023318, 5.83851945854, 297.6419215609],
    [0.00000016657, 6.09418922673, 211.8146227297],
    [0.00000016201, 2.49044081792, 61.2882177486],
    [0.00000020158, 3.16239645425, 186.2117600641],
    [0.00000016004, 2.97277766861, 81.8951455681],
    [0.00000019202, 6.01151966247, 155.7829722581],
    [0.00000017468, 4.82367359029, 273.1028404783],
    [0.00000015141, 3.65588411554, 472.1748419147],
    [0.00000018451, 3.47623430315, 36.6485629295],
    [0.00000016303, 0.13085990583, 554.0699874828],
    [0.00000018634, 0.23919770714, 23.5758732361],
    [0.00000014358, 2.69393539884, 70.1157321213],
    [0.0000001519, 2.43789398876, 486.4019359163],
    [0.00000014488, 0.14254642208, 235.3904959658],
    [0.00000013868, 5.09135892763, 29.2049475286],
    [0.00000014406, 1.56741430063, 110.2063212194],
    [0.00000015722, 4.25156109914, 146.3818033969],
    [0.00000017435, 1.95393343617, 835.0371344873],
    [0.00000013691, 1.63831110433, 92.0470739547],
    [0.00000013239, 2.85690648081, 49.5088043018],
    [0.00000012541, 2.92111856784, 60.5545045657],
    [0.00000012594, 3.20935822266, 100.3844612329],
    [0.00000014937, 0.32571457437, 259.5088859231],
    [0.00000012827, 2.77958172785, 105.4922706636],
    [0.00000012323, 3.36427641421, 440.6822725257],
    [0.00000015261, 0.25477631378, 258.8757464767],
    [0.00000012061, 0.08834689678, 157.6399519819],
    [0.00000012881, 0.30715003179, 124.2904028691],
    [0.0000001093, 3.41396817201, 33.1371007917],
    [0.00000011062, 4.99201784219, 604.4725636619],
    [0.00000010713, 3.88653353837, 767.3690829208],
    [0.00000010435, 5.25417558285, 264.5048207692],
    [0.0000001286, 4.80794300903, 114.3991069134],
    [0.00000011561, 2.6045014019, 166.828672522],
    [0.00000010926, 0.64149188846, 558.0021407459],
    [0.0000001232, 4.33795118362, 16.6747745564],
    [0.00000009947, 0.67247104431, 31.492569389],
    [0.00000011298, 0.96114335836, 373.9079928365],
    [0.0000001215, 1.91679035087, 378.6432952517],
    [0.00000012229, 0.70508380884, 218.4069048687],
    [0.00000010319, 0.18138367123, 275.5505210331],
    [0.00000010753, 5.74480767273, 88.1149206916],
    [0.00000009402, 0.67913169059, 353.301065017],
    [0.00000010651, 2.32656568944, 132.8884225782],
    [0.00000009113, 2.99457723392, 681.5417840896],
    [0.00000010788, 2.62866889129, 154.0166152595],
    [0.00000009169, 4.79284571455, 216.4804891757],
    [0.00000009121, 0.77801335714, 67.3592350258],
    [0.00000009222, 0.73831686735, 129.9194771616],
    [0.00000010633, 0.37523847853, 699.7010313543],
    [0.00000009637, 2.88664912193, 67.8804998876],
    [0.00000008646, 6.1226167326, 150.5264049811],
    [0.00000008601, 2.2012646488, 342.2553647531],
    [0.00000009283, 3.02854870998, 162.0933701068],
    [0.00000009178, 1.49445512725, 19.643719973],
    [0.00000010072, 3.56581375513, 278.5194664497],
    [0.00000009455, 3.06088366945, 149.6750717192],
    [0.00000009786, 2.43713607191, 75.3028634291],
    [0.00000009167, 5.33037538537, 152.0108776894],
    [0.00000008844, 5.263892204, 80.7194894005],
    [0.00000008017, 4.7182259586, 106.0135355254],
    [0.00000010094, 0.7860106238, 339.2864193365],
    [0.00000008813, 0.01616162779, 42.5864537627],
    [0.00000007821, 0.61192552414, 135.336103133],
    [0.00000008193, 2.59644466423, 469.1364605289],
    [0.00000008571, 5.69112316506, 760.25553592],
    [0.00000009277, 1.97750611607, 147.1155165798],
    [0.00000007482, 2.64377659424, 5.9378908332],
    [0.00000008699, 0.54050826161, 66.1835788582],
    [0.00000009761, 2.59090843673, 50.4025761791],
    [0.00000007547, 5.94593031762, 97.4155158163],
    [0.00000007597, 5.80197876381, 450.9772132642],
    [0.00000008669, 3.69932904987, 300.6108669775],
    [0.00000007728, 1.95146228634, 180.2738692309],
    [0.00000007309, 4.98689362574, 117.9105690512],
    [0.00000008195, 2.30281777892, 254.9435932136],
    [0.00000007536, 1.47100575256, 32.2433289144],
    [0.00000008473, 1.27680705707, 39.3568759152],
    [0.00000007026, 0.68091865104, 874.3940104025],
    [0.00000007389, 4.09295183164, 92.3077063856],
    [0.00000007314, 5.04313738379, 756.3233826569],
    [0.00000008454, 1.22026161161, 79.4474650133],
    [0.00000008732, 1.34335847863, 48.7580447764],
    [0.000000087, 0.17463519061, 43.1289704839],
    [0.00000008187, 4.29619724129, 624.919432787],
    [0.00000006941, 5.420540286, 610.6923387854],
    [0.00000006816, 3.90452052962, 480.7728616238],
    [0.00000006753, 6.03251850119, 350.3321196004],
    [0.00000006692, 4.78230287697, 142.6620984549],
    [0.00000007025, 1.27885740826, 68.5618234438],
    [0.00000006824, 1.36436524169, 291.262087743],
    [0.000000069, 3.33848530676, 68.1893164283],
    [0.00000007254, 3.18927739209, 268.4369740323],
    [0.00000007635, 4.81180010568, 312.4597163935],
    [0.00000008135, 1.99010407624, 692.5874843535],
    [0.0000000631, 5.42075206842, 88.7962442478],
    [0.00000006477, 1.05239284135, 685.4739373527],
    [0.00000007121, 5.79764411155, 468.2426886516],
    [0.0000000632, 2.58497126634, 458.090760265],
    [0.00000006775, 2.59596588927, 282.6640680339],
    [0.00000006222, 5.68982546821, 113.8778420516],
    [0.00000008525, 0.00581798397, 227.3137411185],
    [0.0000000652, 3.99093726386, 42.5382696529],
    [0.00000006435, 1.03721543099, 365.9006739584],
    [0.00000008153, 4.04274797388, 183.2428146475],
    [0.00000006039, 4.35471040863, 19.1224551112],
    [0.00000008149, 1.12461637867, 69.1525242748],
    [0.00000006151, 2.783037838, 121.8427223143],
    [0.00000007815, 0.55588235015, 296.1574488526],
    [0.00000005989, 4.98445156091, 184.0941479094],
    [0.00000006379, 0.16323583721, 228.276948965],
    [0.00000006269, 4.22014121556, 119.5069163441],
    [0.00000005982, 5.44774666431, 17.5261078183],
    [0.0000000587, 0.36534808613, 148.5999892881],
    [0.00000005868, 5.39245291119, 95.3885263868],
    [0.00000005906, 0.97697194245, 13.3333221243],
    [0.0000000578, 0.17831781847, 458.8415197904],
    [0.00000005719, 4.74598221436, 248.7238180901],
    [0.00000005534, 4.24741728108, 75.5323580927],
    [0.0000000563, 2.81567861587, 154.979823106],
    [0.0000000626, 3.52991762509, 285.6330134505],
    [0.00000006919, 3.31432622158, 306.830642101],
    [0.00000006087, 4.04640130992, 271.4059194489],
    [0.00000006866, 1.3429923722, 7.8643065262],
    [0.00000005586, 5.33279407873, 920.8644333185],
    [0.00000006528, 0.45565192064, 106.2741679563],
    [0.00000005586, 0.29304653043, 173.6815870919],
    [0.00000005353, 2.49825965802, 24.1183899573],
    [0.00000006205, 5.27879491339, 120.9913890524],
    [0.00000005974, 3.62786821437, 189.7232222019],
    [0.00000005176, 3.69984512887, 778.4147831847],
    [0.0000000524, 4.14231460056, 89.7594520943],
    [0.00000005172, 1.54846732288, 193.655375465],
    [0.0000000636, 0.35370738254, 411.620337349],
    [0.0000000526, 1.26005665335, 267.4737661858],
    [0.00000006906, 4.88299482194, 419.4846438752],
    [0.00000006332, 5.25617761055, 58.319272332],
    [0.00000005993, 4.70505278581, 298.2326223919],
    [0.00000005507, 2.72405080404, 986.0848043302],
    [0.00000004936, 6.07953205967, 134.0640787458],
    [0.00000005469, 6.2163560823, 91.4563731237],
    [0.00000004846, 5.6671411571, 90.8232336773],
    [0.0000000487, 1.24431497533, 25.6028626656],
    [0.00000006149, 1.88362168986, 397.3932433474],
    [0.00000005154, 3.37555501409, 831.1049812242],
    [0.00000005253, 1.85387498292, 114.9416236346],
    [0.00000005163, 0.49175608455, 16.4623262353],
    [0.0000000467, 0.85077620511, 403.0223176399],
    [0.00000004688, 4.94827397388, 902.7051860538],
    [0.00000005005, 1.40309022449, 6.1503391543],
    [0.00000005217, 0.27521357608, 192.6921676185],
    [0.00000006177, 2.78454594522, 198.321241911],
    [0.00000005014, 5.57665259095, 451.9404211107],
    [0.0000000458, 2.47734499363, 31.2319369581],
    [0.00000005129, 3.2352870415, 109.3125493421],
    [0.0000000574, 0.95870813397, 483.2205421786],
    [0.00000004369, 6.21847573079, 207.8824694666],
    [0.00000004425, 2.74721673213, 823.9914342234],
    [0.00000004299, 0.66587852826, 210.3301500214],
    [0.00000004527, 1.8736581989, 44.7253177768],
    [0.00000004484, 1.03729827686, 606.7601855223],
    [0.00000004135, 0.41031273891, 180.1619946463],
    [0.00000004646, 5.82325024322, 905.8865797915],
    [0.00000004086, 4.84914558939, 124.5028511902],
    [0.00000004486, 0.35223479841, 457.8783119439],
    [0.00000004318, 1.68857333749, 309.2783226558],
    [0.00000005151, 2.90867214997, 28.3111756513],
    [0.00000004061, 3.32301396744, 107.4980082337],
    [0.00000004332, 1.41872733238, 25.1297819136],
    [0.00000004944, 5.87125173636, 303.8616966844],
    [0.00000004407, 5.2874885047, 449.2802922348],
    [0.0000000418, 1.67985859496, 7.4223635415],
    [0.00000003977, 3.22662754639, 639.897286314],
    [0.00000005415, 2.15030495019, 187.6962327724],
    [0.00000004217, 0.73382717079, 497.4476361802],
    [0.00000004875, 0.88184557385, 255.0554677982],
    [0.00000004758, 4.60909386948, 258.0244132148],
    [0.00000005337, 2.36556705745, 477.8039162072],
    [0.00000004456, 1.74674336635, 95.9792272178],
    [0.00000004138, 3.80344455465, 460.5384408198],
    [0.00000003843, 4.02615028031, 104.0077979553],
    [0.00000005032, 0.36645338967, 123.5396433437],
    [0.0000000378, 2.89085160996, 27.0873353739],
    [0.00000004309, 4.77464606019, 463.5073862364],
    [0.00000003779, 3.05636034284, 142.1408335931],
    [0.00000004357, 3.73616179561, 376.1956146969],
    [0.00000003705, 2.47343159576, 25.2727942655],
    [0.00000004232, 4.31629167726, 446.3113468182],
    [0.00000003576, 2.55404008547, 6.592282139],
    [0.00000003685, 3.26448469664, 170.7608257851],
    [0.00000003575, 4.31199276037, 572.2292347475],
    [0.00000004496, 2.10358455875, 838.218528225],
    [0.00000003716, 0.20018583737, 394.3548619616],
    [0.00000003846, 5.8108074508, 586.3133163972],
    [0.00000003527, 4.05179036599, 433.7117378768],
    [0.00000003524, 3.75716903766, 473.068613792],
    [0.00000003501, 4.445648846, 384.0599212231],
    [0.00000003636, 2.12955997197, 73.1852512744],
    [0.00000003841, 5.28811045359, 43.2890291783],
    [0.00000003928, 4.26291422687, 196.6243208816],
    [0.00000003702, 3.86923731076, 981.6313862053],
    [0.00000003445, 2.10100539423, 316.3918696566],
    [0.00000003432, 2.97356096189, 535.9107402181],
    [0.00000004312, 0.38740046308, 988.532484885],
    [0.00000003867, 2.08559458308, 457.3570470821],
    [0.00000003353, 4.19681836937, 114.1384744825],
    [0.00000004128, 3.06165703137, 377.1588225434],
    [0.00000003545, 4.41886084391, 1293.8786542777],
    [0.00000003309, 3.54050386234, 520.129737539],
    [0.00000003337, 6.23473900765, 9947.0556815321],
    [0.00000004527, 4.61192905449, 47.061123747],
    [0.00000003523, 2.00908999163, 47.6942631934],
    [0.0000000337, 3.65249455401, 976.0023119128],
    [0.0000000329, 6.135297351, 34.2008823747],
    [0.00000003253, 5.22413528932, 425.1137181677],
    [0.00000003461, 5.18605119393, 993.198351331],
    [0.00000003712, 2.53410725291, 237.6781178262],
    [0.0000000324, 3.56995183051, 17.2654753874],
    [0.00000003362, 1.26285882591, 233.9060232575],
    [0.00000003606, 1.94705146379, 661.0949149645],
    [0.00000003182, 0.3660331511, 449.4927405559],
    [0.00000003427, 6.03153107557, 199.2844497575],
    [0.00000003169, 2.55715329118, 6133.5126528568],
    [0.00000003994, 4.53148620187, 916.9322800554],
    [0.00000004413, 4.14550138614, 219.891377577],
    [0.000000036, 4.16003477661, 214.7835681463],
    [0.00000004193, 4.26425258521, 381.6122406683],
    [0.00000003846, 3.76849990033, 8.5980197091],
    [0.00000003183, 3.15317674552, 15.1903018481],
    [0.0000000335, 5.63661413371, 444.8268741099],
    [0.0000000378, 5.35722293289, 328.2407190726],
    [0.00000003166, 2.16351748263, 983.1158589136],
    [0.0000000393, 2.09444900058, 653.9813679637],
    [0.00000003585, 1.24517449239, 162.8965192589],
    [0.00000003527, 1.89208045227, 280.9671470045],
    [0.00000003282, 1.91872815218, 2349.3284312038],
    [0.00000003076, 4.77282170585, 820.0592809603],
    [0.00000003399, 5.35259772941, 141.6988906084],
    [0.00000003269, 0.52855777633, 450.4559484024],
    [0.00000003582, 1.60170266832, 1587.5884225755],
    [0.00000003044, 0.84602343274, 30.7106720963],
    [0.00000003616, 6.16820602029, 171.6545976624],
    [0.00000003007, 4.69605806277, 978.9712573294],
    [0.00000003528, 4.79818282081, 406.954470903],
    [0.0000000298, 2.17792323043, 597.3590166611],
    [0.00000002977, 0.6947862817, 294.3004691288],
    [0.00000003411, 1.18022650672, 167.7224443993],
    [0.00000004049, 3.15153850922, 833.552661779],
    [0.00000003725, 5.84743216544, 6058.7310542895],
    [0.00000003242, 0.63525153286, 141.4864422873],
    [0.00000003683, 1.86888555615, 371.5297482509],
    [0.00000003877, 1.44138798341, 346.1875180162],
    [0.00000003142, 2.26934250738, 517.1607921224],
    [0.00000004077, 0.07273073033, 1190.0351205337],
    [0.00000002893, 3.53141229605, 94.4253185403],
    [0.0000000302, 2.64998251178, 20.4468691251],
    [0.0000000311, 1.11431255827, 1044.4040766622],
    [0.00000002836, 0.62522723719, 749.2098356561],
    [0.00000002898, 4.11830043593, 600.5404103988],
    [0.00000002819, 4.72400465237, 122.4758617607],
    [0.00000003572, 1.96375884146, 372.4235201282],
    [0.00000002801, 3.99301180541, 10063.7223490764],
    [0.00000002806, 3.85026986935, 133.1008708993],
    [0.00000002791, 6.24681129336, 908.3342603463],
    [0.00000003466, 3.43275071793, 82.6459050935],
    [0.00000003725, 1.68366366742, 683.9894646444],
    [0.00000003763, 3.28247771799, 432.8179659995],
    [0.00000003493, 0.98765698465, 9988.9407505091],
    [0.00000003523, 5.12512607932, 105.380396079],
    [0.00000003432, 2.8048316223, 764.1876891831],
    [0.00000002733, 0.42373696972, 354.9979860464],
    [0.00000003041, 5.75641149588, 409.9234163196],
    [0.00000003379, 5.47448876584, 1396.2206689709],
    [0.00000003102, 0.41684444831, 521.0929453855],
    [0.00000002863, 0.41519700992, 894.8408795276],
    [0.00000003128, 5.23384180625, 424.1505103212],
    [0.00000002688, 3.59170326422, 621.7380390493],
    [0.00000002848, 2.16605887838, 216.9224321604],
    [0.00000002673, 1.60411606116, 136.0698163159],
    [0.00000003414, 4.93712749827, 1140.38330388],
    [0.00000002653, 5.10283251074, 118.0224436358],
    [0.0000000273, 4.22647867347, 990.2294059144],
    [0.00000003113, 5.23808775951, 417.0369633204],
    [0.00000003289, 4.26401031509, 544.5087599272],
    [0.000000031, 5.4792852793, 701.1855040626],
    [0.00000002785, 5.19343849093, 144.8973306886],
    [0.00000002605, 4.82136791856, 362.8622925726],
    [0.00000003183, 4.76078229245, 294.6729761443],
    [0.0000000355, 3.82073713802, 511.5317178299],
    [0.00000002641, 3.49997209213, 293.188503436],
    [0.00000002788, 1.54956737675, 28.5718080822],
    [0.00000002897, 0.37376102831, 582.3811631341],
    [0.00000002615, 2.25516923974, 74.9940468884],
    [0.00000003582, 1.27992264402, 987.5692770385],
    [0.00000003115, 5.10929689813, 459.0539681115],
    [0.00000002589, 1.83177157042, 657.1627617014],
    [0.00000002539, 4.14968938109, 74.7334144575],
    [0.00000002797, 2.82242772664, 2036.8687148103],
    [0.00000002688, 2.16500211397, 262.8078997398],
    [0.00000002817, 6.06679932038, 374.4986936675],
    [0.00000002539, 0.46036497385, 74.8297826771],
    [0.00000002504, 3.523948017, 1183.6723330583],
    [0.00000002565, 1.64023845161, 73.4090004436],
    [0.00000002663, 4.23321349902, 421.1815649046],
    [0.00000003019, 1.62290757266, 414.0680179038],
    [0.00000002793, 2.00644423849, 75.0422309982],
    [0.00000003253, 2.43153394317, 98.3574718034],
    [0.00000002883, 2.41875736533, 4.665866446],
    [0.00000002553, 1.25909246207, 670.4960838257],
    [0.00000003135, 1.96936617667, 842.1506814881],
    [0.00000002604, 3.87350462519, 74.0308390419],
    [0.0000000251, 3.35948960782, 464.9918589447],
    [0.0000000305, 1.8107797128, 331.2096644892],
    [0.00000003005, 0.81031349171, 73.88782669],
    [0.00000002701, 5.89709637826, 525.2375469697],
    [0.0000000311, 6.14956891318, 118.8737768977],
    [0.00000002774, 6.26134027482, 1022.3126761344],
    [0.00000002402, 4.38353347008, 1303.2798231389],
    [0.000000028, 2.60339313269, 74.5209661364],
    [0.00000003005, 0.76247280223, 75.6753704446],
    [0.00000002434, 4.9478467943, 969.6224780949],
    [0.0000000263, 0.62894209942, 227.5261894396],
    [0.00000002669, 0.7334022821, 73.0846775379],
    [0.00000002465, 1.3064877338, 77.0692204277],
    [0.00000002395, 2.76580569447, 768.8535556291],
    [0.00000002753, 5.59058621175, 388.7257876691],
    [0.0000000323, 0.01981320255, 881.5075574033],
    [0.00000003008, 5.6595546366, 1969.2006632438],
    [0.00000003008, 0.91409756228, 2118.7638603784],
    [0.00000002465, 0.26629856014, 72.4939767069],
    [0.00000002313, 3.37979302623, 286.596221297],
    [0.00000002272, 2.77069357318, 515.463871093],
    [0.00000002579, 4.80372721669, 103.3534066495],
    [0.0000000236, 4.12736987374, 74.6215398729],
    [0.0000000222, 2.17920233841, 491.8185618877],
    [0.00000002498, 1.19812774743, 383.0967133766],
    [0.00000002981, 3.15769661969, 1887.3055176757],
    [0.0000000257, 3.1385967429, 229.0800981171],
    [0.00000002355, 0.48259604722, 74.9416572617],
    [0.00000002228, 1.4245214891, 6219.339951688],
    [0.00000002184, 5.18000549953, 59.2824801785],
    [0.00000002319, 2.10326941903, 11.1575748485],
    [0.00000002724, 3.48225905765, 10.2949407385],
    [0.00000002162, 3.61282527361, 22.633917249],
    [0.00000002232, 3.98572942665, 68.631259413],
    [0.0000000239, 2.47806087593, 177.8743727859],
    [0.00000002199, 0.22998162264, 217.2312487011],
    [0.00000002915, 5.18526716284, 218.9281697305],
    [0.00000002875, 2.77889026188, 184.9879197867],
    [0.00000002865, 0.62015957113, 1411.1985224979],
    [0.00000002298, 3.95654643159, 26.0235537909],
    [0.00000002318, 1.21463632824, 291.7040307277],
    [0.0000000256, 1.48802298081, 1055.4497769261],
    [0.00000002796, 5.59819583385, 260.9933586314],
    [0.00000002492, 4.25519394022, 149.45132255],
    [0.00000002007, 6.11892578566, 63.6240237188],
    [0.0000000211, 3.59139003023, 256.4280659219],
    [0.00000002198, 4.46404375855, 524.0618908021],
    [0.00000002706, 0.80150714262, 89.0086925689],
    [0.0000000241, 2.28619111368, 74.2603337055],
    [0.00000002102, 3.18561308775, 635.9651330509],
    [0.00000002006, 1.30247563131, 385.7568422525],
    [0.00000002304, 3.60550712225, 115.8835796217],
    [0.00000001899, 2.42426868365, 273.8536000037],
    [0.00000002119, 5.98199852906, 559.6990617753],
    [0.00000002152, 5.30772822745, 2.0057375701],
    [0.00000002447, 5.10278930542, 205.2223405907],
    [0.00000001962, 1.45399000044, 80.4106728598],
    [0.00000001895, 3.30475087405, 46.470422916],
    [0.00000001942, 1.79179369066, 346.3999663373],
    [0.0000000185, 5.74338030118, 175.1660598002],
    [0.00000001848, 2.74750349182, 429.7795846137],
    [0.00000001848, 1.20977525896, 280.2163874791],
    [0.0000000222, 1.12912931401, 323.5054166574],
    [0.00000001839, 3.5808636747, 327.4375699205],
    [0.00000001839, 4.86693953738, 507.5995645668],
    [0.00000001848, 5.26302620499, 81.682697247],
    [0.00000001996, 4.36291795113, 1812.5239191084],
    [0.00000001893, 0.10622820999, 93.9040536785],
    [0.00000002368, 2.77235858734, 477.0007670551],
    [0.00000001891, 2.25571301508, 4.7353024152],
    [0.00000001792, 1.5975940843, 832.5894539325],
    [0.00000001792, 3.20129636889, 683.0262567979],
    [0.00000002092, 0.32766195745, 343.2185725996],
    [0.00000001792, 5.80267442975, 779.899255893],
    [0.00000001726, 3.18023607065, 332.1728723357],
    [0.00000001831, 3.75183606052, 469.7271613599],
    [0.00000001831, 5.28956429339, 619.2903584945],
    [0.00000001721, 0.80119805379, 1432.3961511484],
    [0.00000001721, 2.33892628665, 1581.959348283],
    [0.00000001978, 1.7419645108, 331.3215390738],
    [0.00000001895, 5.31311179301, 253.5709950899],
    [0.00000001758, 2.96038070029, 1596.1864422846],
    [0.00000001758, 1.42265246742, 1446.62324515],
    [0.00000002109, 0.73357181364, 758.7710632117],
    [0.00000001911, 0.46392477628, 1589.0728952838],
    [0.0000000196, 5.98949067581, 1392.2885157078],
    [0.0000000196, 1.31000765322, 1242.7253185732],
    [0.00000001833, 6.18306213718, 535.3200393871],
    [0.00000002195, 0.42296220916, 703.6331846174],
    [0.00000001815, 5.00776376696, 255.8373650909],
    [0.0000000189, 0.32598438166, 221.1634019642],
    [0.00000001864, 2.6802330408, 405.9912630565],
    [0.00000002065, 6.09002439734, 763.4369296577],
    [0.00000002065, 4.55229616447, 613.8737325231],
    [0.0000000161, 4.9140818566, 115.3623147599],
    [0.00000001823, 5.54014516908, 357.4456666012],
    [0.0000000162, 2.90668209411, 609.2078660771],
    [0.00000001604, 3.64436334999, 30.0562807905],
    [0.00000001578, 6.12288879129, 423.6292454594],
    [0.00000001754, 3.29214293116, 1515.7757694248],
    [0.00000001819, 6.21015313585, 215.4379594521],
    [0.00000001679, 2.61674435978, 181.0557665236],
    [0.00000001907, 5.520303318, 602.9880909536],
    [0.0000000152, 1.94954212244, 1228.4982245716],
    [0.0000000152, 0.34583983785, 1378.0614217062],
    [0.00000001538, 4.79041960434, 543.9180590962],
    [0.00000001518, 3.84678636307, 14.2270940016],
    [0.00000001851, 4.61165114292, 774.4826299216],
    [0.0000000152, 3.24071154201, 39.0962434843],
    [0.00000001647, 5.88231739154, 398.8777160557],
    [0.00000001471, 1.35595542925, 481.7360694703],
    [0.00000001469, 5.56206799884, 301.4140161296],
    [0.00000001474, 1.58634608266, 274.0660483248],
    [0.0000000148, 6.05250894033, 194.2885149114],
    [0.00000001473, 0.67726919761, 539.2521926502],
    [0.00000001472, 3.07440978254, 50.66320861],
    [0.00000001564, 5.43230552977, 459.3627846522],
    [0.00000001468, 5.20182042843, 130.4407420234],
    [0.00000001802, 2.75155368399, 30.5987975117],
    [0.00000001483, 2.08618845205, 69.6737891366],
    [0.00000001433, 3.35897454068, 267.5856407704],
    [0.00000001801, 6.06701083819, 210.8514148832],
    [0.00000001473, 1.65632386952, 1052.2683831884],
    [0.00000001392, 3.13732434239, 369.0820676961],
    [0.00000001502, 0.28443439725, 495.9631634719],
    [0.00000001403, 4.98324477005, 35.685355083],
    [0.00000001404, 3.16559098208, 255.57673266],
    [0.00000001456, 5.36560710378, 6283.0758499914],
    [0.00000001412, 0.68968780108, 348.8476468921],
    [0.00000001589, 4.89344411716, 1366.2125722902],
    [0.00000001426, 5.72934799733, 335.1418177523],
    [0.00000001469, 4.66006940636, 893.3564068193],
    [0.00000001469, 6.26377169094, 743.7932096847],
    [0.00000001668, 1.29876086261, 1673.2556627123],
    [0.00000001668, 2.90246314719, 1523.6924655777],
    [0.00000001526, 5.93140614398, 1662.9607219738],
    [0.00000001373, 4.85710108204, 61.448276443],
    [0.00000001366, 4.78315200862, 470.6903692064],
    [0.0000000139, 5.7698716402, 79.889407998],
    [0.00000001461, 3.00376275716, 632.7837393132],
];

const VSOP87_R2: Vsop87Element = [
    [0.00022439899, 0.69953310903, 74.7815985673],
    [0.00004726838, 1.69896897296, 63.7358983034],
    [0.00001681383, 4.64842242588, 70.8494453042],
    [0.00001433633, 3.52135281258, 149.5631971346],
    [0.00001649477, 3.09669484042, 11.0457002639],
    [0.00000769974],
    [0.00000461159, 0.76667185672, 3.9321532631],
    [0.00000500193, 6.17218448634, 76.2660712756],
    [0.00000390377, 4.49603136758, 56.6223513026],
    [0.00000389972, 5.52663268311, 85.8272988312],
    [0.00000292283, 0.20370820668, 52.6901980395],
    [0.00000272269, 3.8473537521, 138.5174968707],
    [0.00000286451, 3.53449822561, 73.297125859],
    [0.00000205341, 3.24759155116, 78.7137518304],
    [0.00000219349, 1.96433948894, 131.4039498699],
    [0.00000215812, 0.84820922453, 77.962992305],
    [0.0000012904, 2.08142441038, 3.1813937377],
    [0.00000148716, 4.89757177249, 127.4717966068],
    [0.00000117642, 4.93417950365, 447.7958195265],
    [0.00000112873, 1.01358614296, 462.0229135281],
    [0.00000099082, 6.15736951949, 224.3447957019],
    [0.00000091634, 0.68110922044, 18.1592472647],
    [0.00000089537, 0.23396296581, 202.2533951741],
    [0.00000088475, 2.93078580361, 62.2514255951],
    [0.00000113471, 4.78996247308, 145.6310438715],
    [0.00000103857, 3.58561861261, 71.6002048296],
    [0.00000061854, 3.29891157272, 351.8165923087],
    [0.00000057828, 4.90530751807, 22.0914005278],
    [0.00000064448, 3.38789169908, 1.4844727083],
    [0.0000007111, 6.10490045777, 454.9093665273],
    [0.0000005092, 3.86475363643, 65.2203710117],
    [0.00000063666, 3.96437325595, 67.6680515665],
    [0.00000059151, 5.54929939724, 9.5612275556],
    [0.00000048713, 3.74773116593, 269.9214467406],
    [0.0000004401, 1.92372120641, 59.8037450403],
    [0.00000042677, 2.61696151844, 151.0476698429],
    [0.00000044556, 5.90316779799, 71.8126531507],
    [0.00000042421, 6.1363853032, 284.1485407422],
    [0.00000037328, 5.91300114911, 984.6003316219],
    [0.00000042329, 2.08837866544, 12.5301729722],
    [0.00000036234, 5.4033118009, 77.7505439839],
    [0.00000031472, 4.58140053324, 148.0787244263],
    [0.00000031469, 2.26119541579, 195.1398481733],
    [0.00000027151, 3.53245541147, 209.3669421749],
    [0.00000028313, 4.57742211849, 77.2292791221],
    [0.00000026135, 0.65832277309, 120.358249606],
    [0.00000024371, 5.86680470366, 69.3649725959],
    [0.00000023072, 1.04150250909, 84.3428261229],
    [0.00000022686, 1.71276605718, 160.6088973985],
    [0.00000027909, 4.91450005237, 277.0349937414],
    [0.00000020958, 2.202477842, 45.5766510387],
    [0.00000020277, 2.30684759993, 2.4476805548],
    [0.00000016889, 4.75579457418, 213.299095438],
    [0.00000016616, 1.85435119988, 340.7708920448],
    [0.00000017053, 4.3720784206, 54.1746707478],
    [0.00000016086, 3.65914337666, 152.7445908723],
    [0.00000014838, 5.44395102901, 408.4389436113],
    [0.00000013872, 3.3853110087, 358.9301393095],
    [0.00000013344, 5.24928235077, 137.0330241624],
    [0.00000013276, 1.26302583053, 134.5853436076],
    [0.000000127, 3.02323882509, 92.940845832],
    [0.00000013615, 1.5319229404, 422.6660376129],
    [0.00000012387, 1.33244915199, 51.2057253312],
    [0.0000001645, 0.40355823582, 265.9892934775],
    [0.00000012052, 5.08792165794, 191.2076949102],
    [0.00000011443, 2.05677650023, 7.1135470008],
    [0.00000012762, 4.42146478775, 87.3117715395],
    [0.00000012158, 3.23645294871, 116.4260963429],
    [0.00000011636, 4.65085291428, 41.6444977756],
    [0.00000011612, 4.17982719132, 60.5545045657],
    [0.00000011692, 3.73284551397, 220.4126424388],
    [0.00000010313, 0.35141402139, 70.3281804424],
    [0.00000011316, 1.07773417628, 72.3339180125],
    [0.00000009522, 3.05257396853, 2.9689454166],
    [0.00000009279, 2.43997351068, 565.1156877467],
    [0.00000008993, 5.1884103266, 225.8292684102],
    [0.00000010284, 1.18602188589, 344.7030453079],
    [0.00000008847, 6.00863947318, 5.4166259714],
    [0.00000008508, 5.24741470219, 347.8844390456],
    [0.00000008322, 3.71500823381, 14.977853527],
    [0.00000008276, 2.27407098373, 299.1263942692],
    [0.00000008064, 5.71681525179, 55.1378785943],
    [0.00000007829, 0.90269701074, 222.8603229936],
    [0.00000008335, 4.48600419464, 70.1157321213],
    [0.00000008489, 3.911747962, 333.657345044],
    [0.00000008708, 5.81537952972, 153.4953503977],
    [0.00000010194, 5.97791997034, 35.1640902212],
    [0.00000009652, 0.38887666466, 415.5524906121],
    [0.00000007106, 1.5059848847, 991.7138786227],
    [0.00000008055, 2.25812279923, 206.1855484372],
    [0.00000006468, 2.99863142327, 380.12776796],
    [0.00000006393, 1.1686180992, 96.8729990951],
    [0.00000008976, 6.05363032396, 146.3818033969],
    [0.00000006131, 0.05596259493, 99.1606209555],
    [0.00000005803, 0.79879069877, 142.4496501338],
    [0.00000005816, 4.63029217647, 49.5088043018],
    [0.00000005557, 0.63854330387, 58.1068240109],
    [0.00000005869, 2.21418083323, 80.1982245387],
    [0.00000005162, 4.36457872885, 977.4867846211],
    [0.00000005428, 0.85181859845, 546.956440482],
    [0.0000000575, 2.48104577171, 373.0142209592],
    [0.00000005766, 0.34229026122, 536.8045120954],
    [0.00000005924, 5.48443563529, 76.4785195967],
    [0.00000005154, 4.81339702575, 387.2413149608],
    [0.00000005325, 3.72411790512, 23.5758732361],
    [0.00000005037, 5.06388596602, 440.6822725257],
    [0.00000005209, 4.09574144962, 132.8884225782],
    [0.0000000579, 3.39593613152, 458.090760265],
    [0.00000005007, 4.25821411688, 522.5774180938],
    [0.00000005114, 0.4964558173, 60.7669528868],
    [0.00000005027, 6.1524848967, 39.6175083461],
    [0.00000005183, 3.25775152471, 561.1835344836],
    [0.00000004603, 1.69268338637, 152.5321425512],
    [0.00000004566, 0.46068888813, 33.1371007917],
    [0.00000005302, 1.83522660093, 124.2904028691],
    [0.00000004454, 2.30288945184, 312.4597163935],
    [0.00000005766, 0.6606915576, 38.1330356378],
    [0.00000004255, 3.58596694157, 479.2883889155],
    [0.00000004315, 1.64104755836, 128.9562693151],
    [0.0000000419, 4.37674804409, 79.2350166922],
    [0.00000005756, 0.87494010124, 20.6069278195],
    [0.00000005409, 0.87333646247, 81.8951455681],
    [0.00000005124, 1.40551554367, 144.1465711632],
    [0.00000004045, 6.07362424621, 19.643719973],
    [0.00000003994, 5.77048046468, 288.0806940053],
    [0.00000004987, 2.99179430284, 29.2049475286],
    [0.0000000387, 4.43713601497, 141.6988906084],
    [0.00000003811, 3.15820960943, 159.1244246902],
    [0.00000004553, 0.01384318412, 298.2326223919],
    [0.00000003737, 5.28319518103, 353.301065017],
    [0.00000003742, 2.67921642406, 426.598190876],
    [0.00000003939, 5.27301148162, 521.0929453855],
    [0.00000005065, 4.09433474334, 111.4301614968],
    [0.00000003861, 1.343943837, 535.3200393871],
    [0.00000003619, 5.10070043677, 490.3340891794],
    [0.00000004385, 0.620576801, 827.1728279611],
    [0.00000003645, 0.34509016266, 33.6796175129],
    [0.00000003558, 2.51710360898, 258.8757464767],
    [0.00000003919, 0.62079541541, 152.0108776894],
    [0.00000003576, 3.24526237368, 230.5645708254],
    [0.00000003469, 0.79054323335, 983.1158589136],
    [0.0000000453, 2.86839686392, 129.9194771616],
    [0.00000003648, 5.59395544992, 774.4826299216],
    [0.0000000344, 4.71254994607, 6.9010986797],
    [0.00000003513, 4.49630054276, 376.1956146969],
    [0.00000004521, 2.05472247761, 404.5067903482],
    [0.00000003336, 0.89628904042, 469.1364605289],
    [0.00000003274, 3.86236880159, 42.5382696529],
    [0.00000003201, 2.76459652868, 248.7238180901],
    [0.00000003184, 0.07709843451, 1514.2912967165],
    [0.00000003783, 5.29835962126, 369.0820676961],
    [0.00000003119, 1.27526406087, 200.7689224658],
    [0.00000003266, 2.24754480216, 73.8183907208],
    [0.00000003055, 2.60120354408, 433.7117378768],
    [0.00000003051, 4.54953369151, 980.6681783588],
    [0.00000003472, 4.93521260607, 411.620337349],
    [0.00000003531, 4.49372794858, 881.5075574033],
    [0.00000003284, 5.59170577331, 472.1748419147],
    [0.00000003049, 3.68906777491, 16.6747745564],
    [0.00000003015, 6.02967446446, 291.262087743],
    [0.00000003755, 3.1258774756, 108.4612160802],
    [0.00000003467, 2.17484439267, 554.0699874828],
    [0.00000003138, 0.52367930477, 1094.8066528413],
    [0.00000003257, 2.49339546514, 451.7279727896],
    [0.00000002886, 2.44887846041, 135.336103133],
    [0.00000002965, 0.3929499553, 25.2727942655],
    [0.00000002794, 5.32964924523, 125.9873238985],
    [0.00000002814, 1.70481689541, 639.897286314],
    [0.00000002777, 5.94801147914, 89.7594520943],
    [0.00000002831, 2.52728803131, 867.2804634017],
    [0.00000002779, 0.48501334493, 305.3461693927],
    [0.00000002872, 0.77434367967, 486.4019359163],
    [0.00000002857, 4.71106805785, 218.9281697305],
    [0.00000003081, 4.10993868704, 146.594251718],
    [0.00000002763, 4.27510031656, 350.3321196004],
    [0.00000003365, 3.67691210011, 661.0949149645],
    [0.00000002925, 1.43646759644, 381.6122406683],
    [0.00000002802, 3.11122994722, 216.4804891757],
    [0.00000002756, 4.6267249884, 1357.6145525811],
    [0.0000000345, 2.12911756067, 685.4739373527],
    [0.00000002646, 3.81808560938, 550.8885937451],
    [0.00000002584, 5.63009428967, 24.3790223882],
    [0.0000000274, 1.85885336732, 529.6909650946],
    [0.00000002606, 4.36605237304, 1080.5795588397],
    [0.00000002438, 3.04265976382, 391.1734682239],
    [0.00000002446, 5.7384638154, 535.9107402181],
    [0.00000002471, 4.1814010428, 235.3904959658],
    [0.00000002568, 1.09886876369, 913.0001267923],
    [0.00000002346, 1.88690998393, 82.8583534146],
    [0.00000002301, 0.2711625493, 7.8643065262],
    [0.00000003053, 5.35047433775, 681.5417840896],
    [0.0000000229, 2.49218620138, 203.7378678824],
    [0.00000002325, 0.52844013308, 14.2270940016],
    [0.00000002258, 0.0315661773, 398.2870152247],
    [0.0000000216, 6.01811980506, 140.001969579],
    [0.00000002328, 3.12607654898, 273.1028404783],
    [0.00000002139, 4.33383273131, 91.4563731237],
    [0.00000002723, 1.24464892033, 166.828672522],
    [0.00000002053, 4.3243438112, 515.463871093],
    [0.00000002398, 5.9014427096, 79.4474650133],
    [0.00000002222, 4.80208391464, 268.4369740323],
    [0.0000000231, 0.48180017719, 14.0146456805],
    [0.00000002022, 5.85402756377, 271.4059194489],
    [0.00000002521, 3.23111737258, 901.9544265284],
    [0.00000002369, 2.40985582671, 73.0846775379],
    [0.00000002034, 0.47496124187, 2043.9822618111],
    [0.00000001955, 6.21237525891, 384.0599212231],
    [0.00000001954, 3.38054663002, 820.0592809603],
    [0.00000001867, 5.32253331194, 31.492569389],
    [0.00000002416, 0.0642020989, 419.4846438752],
    [0.00000001762, 5.772005785, 1589.0728952838],
    [0.00000001762, 4.23427755214, 1439.5096981492],
    [0.00000001925, 0.79521713622, 184.0941479094],
    [0.00000002204, 0.52846501316, 278.5194664497],
    [0.00000002228, 4.32684227036, 66.9172920411],
    [0.00000001679, 5.14179135334, 1059.3819301892],
    [0.00000001706, 1.54289098759, 234.4967240885],
    [0.00000001625, 5.07314285147, 100.3844612329],
    [0.00000001609, 6.16926697458, 1119.1856752295],
    [0.00000002033, 3.53119363701, 109.9456887885],
    [0.00000002129, 1.22429037482, 184.7272873558],
    [0.00000001717, 2.42144217711, 678.3603903519],
    [0.00000001717, 3.95917040998, 827.9235874865],
    [0.0000000181, 0.05278694247, 17.2654753874],
    [0.00000001585, 1.88716701489, 4.4534181249],
    [0.00000001577, 5.35894329524, 1894.4190646765],
    [0.00000001523, 3.77627435709, 181.0557665236],
    [0.00000001534, 0.19778048653, 135.5485514541],
    [0.00000001506, 2.95864025543, 849.2642284889],
    [0.00000001506, 1.35493797085, 998.8274256235],
    [0.00000001722, 5.00518792666, 699.7010313543],
    [0.00000001722, 3.46745969379, 550.1378342197],
    [0.00000001643, 5.86122302822, 89.0086925689],
    [0.0000000152, 1.42254433373, 0.2124483211],
    [0.00000001529, 0.77073213979, 329.7251917809],
    [0.00000001458, 5.90775641818, 147.1155165798],
    [0.00000001792, 1.11686829848, 453.424893819],
    [0.00000001498, 2.6114567579, 365.9006739584],
    [0.00000001793, 2.14241351007, 211.8146227297],
    [0.0000000158, 5.57997675255, 785.5283301855],
    [0.0000000158, 4.04224851969, 635.9651330509],
    [0.00000001835, 4.31480288855, 465.9550667912],
    [0.00000001407, 4.94842057032, 74.8934731519],
    [0.00000001403, 5.15016124506, 180.1619946463],
    [0.0000000142, 2.60452620081, 95.3885263868],
    [0.00000001383, 5.95287019467, 74.6697239827],
    [0.00000001382, 2.10457236484, 458.8415197904],
    [0.00000001513, 1.88475439191, 1051.517623663],
    [0.00000001368, 5.67966974902, 66.70484372],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001164663, 4.73440180792, 74.7815985673],
    [0.00000212363, 3.34268349684, 63.7358983034],
    [0.00000196315, 2.981012371, 70.8494453042],
    [0.00000104707, 0.95789279555, 11.0457002639],
    [0.00000071681, 0.02528295071, 56.6223513026],
    [0.00000072719, 0.99479831041, 149.5631971346],
    [0.00000054933, 2.59936585639, 3.9321532631],
    [0.00000034026, 3.82319495878, 76.2660712756],
    [0.00000032081, 3.59825177872, 131.4039498699],
    [0.00000029569, 3.44303690664, 85.8272988312],
    [0.00000036377, 5.65035573026, 77.962992305],
    [0.00000027625, 0.42885477377, 3.1813937377],
    [0.00000027552, 2.55709855563, 52.6901980395],
    [0.0000002474, 5.14634979896, 78.7137518304],
    [0.00000019382, 5.13444064222, 18.1592472647],
    [0.00000015767, 0.37116951743, 447.7958195265],
    [0.00000015441, 5.57271837433, 462.0229135281],
    [0.00000015035, 3.84415419523, 73.297125859],
    [0.0000001545, 2.9757251436, 145.6310438715],
    [0.00000017788],
    [0.00000015958, 5.19915553861, 71.6002048296],
    [0.0000001078, 6.02554585112, 138.5174968707],
    [0.00000010347, 3.60350847669, 224.3447957019],
    [0.00000007612, 1.47668980969, 1.4844727083],
    [0.0000000814, 2.61444086595, 22.0914005278],
    [0.00000007107, 5.43946774526, 269.9214467406],
    [0.00000006459, 4.37142319461, 284.1485407422],
    [0.00000006817, 0.0148593733, 151.0476698429],
    [0.00000007811, 0.29898229022, 127.4717966068],
    [0.00000005768, 4.22672716677, 373.0142209592],
    [0.00000005105, 1.81797461354, 202.2533951741],
    [0.00000004692, 2.7840457544, 120.358249606],
    [0.00000005071, 0.7664167964, 62.2514255951],
    [0.00000004133, 1.8887930071, 209.3669421749],
    [0.00000005201, 4.15791319343, 195.1398481733],
    [0.00000003946, 1.83105030444, 72.3339180125],
    [0.00000003582, 3.92592140377, 124.2904028691],
    [0.0000000434, 3.99626115302, 9.5612275556],
    [0.00000003739, 1.50894993813, 148.0787244263],
    [0.00000003436, 1.99291271003, 65.2203710117],
    [0.00000003835, 1.15614639932, 153.4953503977],
    [0.00000003593, 0.94897593272, 92.940845832],
    [0.0000000395, 1.85721204646, 152.7445908723],
    [0.00000003277, 1.40881404192, 351.8165923087],
    [0.00000003058, 5.76662885271, 160.6088973985],
    [0.00000002719, 5.64780369357, 134.5853436076],
    [0.000000028, 0.79480255927, 572.2292347475],
    [0.00000002727, 6.00569967758, 12.5301729722],
    [0.00000002524, 3.05071097098, 387.2413149608],
    [0.00000002662, 1.98593312104, 450.9772132642],
    [0.00000002391, 1.62282528307, 358.9301393095],
    [0.0000000257, 2.81202618885, 213.299095438],
    [0.00000002291, 4.81424601791, 536.8045120954],
    [0.00000002213, 2.20360299816, 465.9550667912],
    [0.00000002345, 3.89530188536, 76.4785195967],
    [0.0000000199, 6.00348345539, 77.2292791221],
    [0.00000001836, 0.86993337572, 288.0806940053],
    [0.00000002233, 4.20038854663, 45.5766510387],
    [0.00000001745, 4.28595550732, 67.6680515665],
    [0.00000001715, 5.36211200127, 84.3428261229],
    [0.0000000164, 5.46719808619, 309.2783226558],
    [0.0000000164, 3.86349580161, 458.8415197904],
    [0.00000001728, 3.60055588821, 81.8951455681],
    [0.00000001483, 3.46836166107, 59.8037450403],
    [0.00000001463, 3.58895839694, 347.8844390456],
    [0.00000001415, 1.8281699263, 497.4476361802],
    [0.00000001399, 5.26616832831, 909.8187330546],
    [0.00000001399, 3.66246604373, 1059.3819301892],
    [0.00000001401, 4.64442933182, 96.8729990951],
];

const VSOP87_R4: Vsop87Element = [
    [0.00000053224, 3.00468894529, 74.7815985673],
    [0.00000009887, 1.91399083603, 56.6223513026],
    [0.00000007008, 5.08677527404, 11.0457002639],
    [0.00000006718, 5.39509675772, 149.5631971346],
    [0.00000003855, 5.18994119112, 131.4039498699],
    [0.00000003316, 1.22839100759, 85.8272988312],
    [0.00000002664, 0.44064577837, 63.7358983034],
    [0.00000002309, 0.92380720934, 145.6310438715],
    [0.00000002383, 6.21390585593, 358.9301393095],
    [0.00000002288, 2.23425399117, 440.6822725257],
    [0.00000002472, 3.28269448244, 18.1592472647],
    [0.00000002837, Math.PI],
];

const VSOP87_R5: Vsop87Element = [[Math.LN2]];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];

export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];

export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
